const translations = {
  en: {
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.update': 'Update',
    'common.view': 'View',
    'common.hide': 'Hide',
    'common.viewOrders': 'View orders',
    'common.viewInvoices': 'View invoices',
    'common.delete': 'Delete',
    'common.remove': 'Remove',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.actions': 'Actions',
    'common.refresh': 'Refresh',
    'common.confirmDeleteTitle': 'Delete Item',
    'common.confirmDeleteMessage': 'Are you sure you want to delete this item?',
    'common.back': 'Back',
    'common.deleteConfirm': 'Delete',
    'common.added': 'Added',
    'common.zeroPlaceholder': '0',
    'common.notes': 'Notes',
    'common.phone': 'Phone Number',
    'common.whatsapp': 'WhatsApp Number',
    'common.address': 'Address',
    'common.email': 'Email',
    'common.subject': 'Subject',
    'common.required': 'This field is required',
    'common.confirm': 'Confirm',
    'common.validationError': 'Validation error',
    'api.errors.validation_error': 'Validation error',
    'api.errors.invalid_credentials': 'Invalid credentials',
    'api.errors.unauthenticated': 'Unauthenticated',
    'api.errors.permission_denied': 'You do not have permission to perform this action',
    'api.errors.invalid_current_password': 'Current password is incorrect',
    'api.errors.login_identifier_required': 'Please provide an email address or a username.',
    'api.errors.email_invalid': 'Please provide a valid email address.',
    'api.errors.email_taken': 'This email is already registered.',
    'api.errors.username_taken': 'This username is already taken.',
    'api.errors.already_taken': 'This value is already taken.',
    'api.errors.backoffice_access_denied': 'This account cannot access the backoffice portal.',
    'api.errors.vendor_portal_only': 'This account must sign in through the vendor portal.',
    'api.errors.not_found': 'Not found',
    'api.errors.request_failed': 'Something went wrong',
    'forms.whatsappSameAsPhone': 'WhatsApp same as phone',
    'forms.phone.placeholder': 'Enter phone number',
    'forms.whatsapp.placeholder': 'Enter WhatsApp number',
    'forms.copyFromVendor.label': 'Use lab contact details',
    'forms.copyFromVendor.phone': 'Lab phone',
    'forms.copyFromVendor.whatsapp': 'Lab WhatsApp',
    'forms.copyFromVendor.address': 'Lab address',
    'forms.copyFromClient.label': 'Use client contact details',
    'forms.copyFromClient.phone': 'Client phone',
    'forms.copyFromClient.whatsapp': 'Client WhatsApp',
    'forms.copyFromClient.address': 'Client address',
    'common.clear': 'Clear',
    'common.resetFilters': 'Reset Filters',
    'common.filters': 'Filters',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.general': 'General',
    'validation.name.required': 'Name is required',
    'validation.name.min': 'Name must be at least 2 characters',
    'validation.name.max': 'Name cannot exceed 255 characters',
    'validation.email.required': 'Email is required',
    'validation.email.invalid': 'Please enter a valid email address',
    'validation.email.max': 'Email cannot exceed 255 characters',
    'validation.username.required': 'Username is required',
    'validation.username.min': 'Username must be at least 3 characters',
    'validation.username.max': 'Username cannot exceed 50 characters',
    'validation.username.invalid': 'Username may only contain letters, numbers, dots, underscores, and hyphens',
    'validation.login.identifierRequired': 'Enter an email or a username',
    'validation.phone.required': 'Phone is required',
    'validation.phone.invalid': 'Please enter a valid phone number',
    'validation.phone.max': 'Phone cannot exceed 50 characters',
    'validation.whatsapp.required': 'WhatsApp is required',
    'validation.whatsapp.invalid': 'Please enter a valid WhatsApp number',
    'validation.whatsapp.max': 'WhatsApp cannot exceed 50 characters',
    'common.loading': 'Loading...',
    'common.saved': 'Saved successfully',
    'common.active': 'Active',
    'common.status': 'Status',
    'common.inactive': 'Inactive',
    'common.export': 'Export',
    'common.export.csv': 'Export CSV',
    'common.export.excel': 'Export Excel',
    'common.export.pdf': 'Export PDF',
    'common.export.selectedCount': '{{count}} selected',
    'common.export.error': 'Export failed',
    'common.export.entity.orders': 'Orders',
    'common.export.entity.invoices': 'Invoices',
    'common.export.entity.clients': 'Clients',
    'common.export.entity.users': 'Users',

    // Sidebar
    'sidebar.dashboard': 'Dashboard',
    'sidebar.reports': 'Reports',
    'sidebar.settings': 'Settings',
    'sidebar.client_settings': 'Settings',
    'sidebar.client_transactions': 'Transactions',
    'sidebar.setting': 'Lab Settings',
    'sidebar.setting_lab_info': 'Lab',
    'sidebar.setting_subscription': 'Subscription',
    'sidebar.setting_payment': 'Payment Settings',
    'sidebar.setting_delivery': 'Delivery Settings',
    'sidebar.setting_vacations': 'Vacations',
    'sidebar.orders': 'Orders',
    'sidebar.orders_calendar': 'Calendar',
    'sidebar.invoices': 'Invoices',

    // Invoices
    'invoices.header.title': 'Invoices',
    'invoices.header.subtitle': 'Manage laboratory invoices, payment collection statuses and financial records',
    'invoices.filter.title': 'Filter Invoices',
    'invoices.filter.active': 'Active',
    'invoices.filter.clear': 'Reset Filters',
    'invoices.table.refresh': 'Refresh',
    'invoices.table.ordersCount': 'Orders',
    'invoices.table.number': 'Invoice ID',
    'invoice.table.orderRef': 'Order Ref',
    'invoice.table.invoiceRef': 'Invoice Ref',
    'invoice.field.shipmentDate': 'Shipment Date',
    'invoice.field.vat': 'VAT',
    'invoice.field.deliveryCost': 'Delivery Cost',
    'invoice.field.orderId': 'Order Id',
    'invoice.field.amount': 'Amount',
    'invoices.table.status': 'Status',
    'invoices.table.issueDate': 'Issue Date',
    'invoices.table.client': 'Client',
    'invoices.table.dentist': 'Dentist',
    'invoices.table.dueDate': 'Due Date',
    'invoices.table.total': 'Total',
    'invoices.table.remaining': 'Rem',
    'invoices.table.actions': 'Actions',
    'invoices.table.draft': 'Draft',
    'invoices.table.draftLabel': 'Draft',
    'invoices.confirm.delete': 'Are you sure you want to delete this invoice?',
    'invoices.alert.noAccess': 'You do not have access to view invoices.',
    'invoices.button.showDrafts': 'Show Drafts',
    'invoices.button.hideDrafts': 'Hide Drafts',
    'invoices.filter.all': 'Show All',
    'invoices.filter.drafts': 'Show Drafts',
    'invoices.filter.nonDrafts': 'Hide Drafts',
    'invoices.search.placeholder': 'Search invoice #, ref, client, dentist or notes',

  
    'sidebar.formula_types': 'Formulas and Services',
    'sidebar.colors': 'Colors',
    'sidebar.platform_settings': 'Platform Settings',
    'sidebar.assets': 'Assets',
    'sidebar.branchs': 'Branches',
    'sidebar.delivery_centers': 'Delivery Centers',
    'sidebar.expenses': 'Expenses',
    'sidebar.expense_types': 'Expense Types',
    'sidebar.dentists': 'Dentists',
    'sidebar.users': 'Users',
    'sidebar.roles': 'Roles & Permissions',
    'sidebar.transactions': 'Transactions',
    'sidebar.activities': 'Activities',
    'sidebar.units': 'Units',
    'sidebar.unit_types': 'Unit Types',

    // Activities
    'activities.table.entity_affected': 'Entity affected',
    'activities.table.user': 'User name',
    'activities.table.operation': 'Operation',
    'activities.table.ip': 'Device IP',
    'activities.table.date': 'Date',
    'activities.table.properties': 'Properties',
    'activities.filters.name': 'Name',
    'activities.filters.entity': 'Entity',
    'activities.filters.operation': 'Operation',
    'activities.operations.create': 'CREATE',
    'activities.operations.created': 'CREATE',
    'activities.operations.update': 'UPDATE',
    'activities.operations.updated': 'UPDATE',
    'activities.operations.delete': 'DELETE',
    'activities.operations.deleted': 'DELETE',
    'activities.operations.paid_invoice': 'PAID_INVOICE',
    'activities.operations.undo_mark_paid': 'UNDO_MARK_PAID',
    'activities.operations.refund_invoice': 'REFUND_INVOICE',
    'activities.operations.cancel': 'CANCEL',
    'activities.operations.send_email': 'SEND_EMAIL',
    'activities.operations.send_whatsapp': 'SEND_WHATSAPP',
    'activities.operations.download_invoice_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_invoice_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    // Legacy activity event aliases
    'activities.operations.download_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    'activities.operations.login': 'LOGIN',
    'activities.operations.logout': 'LOGOUT',
    'activities.operations.password_reset': 'PASSWORD RESET',
    'activities.operations.password_reset_request': 'PASSWORD RESET REQUEST',
    'activities.operations.impersonate': 'IMPERSONATE',
    'activities.properties.field': 'Field',
    'activities.properties.old': 'Old',
    'activities.properties.new': 'New',
    'activities.properties.no_changes': 'No old/new comparison data for this activity.',
    'activities.modal.properties_title': 'Changed properties',
    'activities.fields.id': 'ID',
    'activities.fields.name': 'Name',
    'activities.fields.email': 'Email',
    'activities.fields.phone': 'Phone',
    'activities.fields.notes': 'Notes',
    'activities.fields.address': 'Address',
    'activities.fields.whatsapp': 'WhatsApp',
    'activities.fields.client': 'Client',
    'activities.fields.client_id': 'Client',
    'activities.fields.client_name': 'Client',
    'activities.fields.client_address': 'Client Address',
    'activities.fields.dentist': 'Dentist',
    'activities.fields.dentist_id': 'Dentist',
    'activities.fields.dentist_name': 'Dentist',
    'activities.fields.dentist_email': 'Dentist Email',
    'activities.fields.dentist_phone': 'Dentist Phone',
    'activities.fields.technician': 'Technician',
    'activities.fields.technician_id': 'Technician',
    'activities.fields.technician_name': 'Technician Name',
    'activities.fields.technician_email': 'Technician Email',
    'activities.fields.courier': 'Courier',
    'activities.fields.courier_id': 'Courier',
    'activities.fields.orders': 'Orders',
    'activities.fields.units': 'Units',
    'activities.fields.units_count': 'Units Count',
    'activities.fields.attachments': 'Attachments',
    'activities.fields.requested_at': 'Requested At',
    'activities.fields.delivered_at': 'Delivered At',
    'activities.fields.code': 'Code',
    'activities.fields.color': 'Color',
   
    'activities.fields.delivery_type': 'Delivery Type',
    'activities.fields.delivery_type_name': 'Delivery Type',
    'activities.fields.user_type': 'User Type',
    'activities.fields.payment_method': 'Payment Method',
    'activities.fields.payment_method_id': 'Payment Method',
    'activities.fields.payment_status': 'Payment Status',
    'activities.fields.payment_status_id': 'Payment Status',
    'activities.fields.order_status': 'Order Status',
    'activities.fields.delivery_center': 'Delivery Center',
    'activities.fields.delivery_center_id': 'Delivery Center',
    'activities.fields.delivery_center_name': 'Delivery Center Name',
    'activities.fields.delivery_center_address': 'Delivery Center Address',
    'activities.fields.delivery_center_created_at': 'Delivery Center Created At',
    'activities.fields.delivery_center_updated_at': 'Delivery Center Updated At',
    'activities.fields.delivery_cost': 'Delivery Cost',
    'activities.fields.discount_amount': 'Discount Amount',
    'activities.fields.vat_percentage': 'VAT Percentage',
    'activities.fields.unit_price_override': 'Unit Price Override',
    'activities.fields.unit_price_source': 'Unit Price Source',
    'activities.fields.reference': 'Reference',
    'activities.fields.is_draft': 'Draft',
    'activities.fields.due_date': 'Due Date',
    'activities.fields.issue_date': 'Issue Date',
    'activities.fields.paid_at': 'Paid At',
    'activities.fields.paid_amount': 'Paid Amount',
    'activities.fields.total_amount': 'Total Amount',
    'activities.fields.subtotal_amount': 'Subtotal Amount',
    'activities.fields.remaining_amount': 'Remaining Amount',
    'activities.fields.created_at': 'Created At',
    'activities.fields.updated_at': 'Updated At',

    // Auth
    'auth.login.title': 'Welcome back',
    'auth.login.vendorTitle': 'Vendor Portal',
    'auth.login.vendorSubtitle': 'Sign in to manage your lab',
    'auth.login.brandLede': 'Orders, invoices, and delivery — one place for your dental lab.',
    'auth.login.formSubtitle': 'Sign in with your email or username and password',
    'auth.login.secureNotice': 'Protected access for authorized lab staff only.',
    'auth.login.email.label': 'Email',
    'auth.login.email.required': 'Please enter the email address',
    'auth.login.email.invalid': 'Please enter a valid email address',
    'auth.login.email.placeholder': 'Enter the email address',
    'auth.login.identifier.label': 'Email or username',
    'auth.login.identifier.required': 'Please enter your email or username',
    'auth.login.identifier.placeholder': 'Enter email or username',
    'auth.login.password.label': 'Password',
    'auth.login.password.required': 'Please enter the password',
    'auth.login.password.placeholder': 'Enter the password',
    'auth.login.submit': 'Sign in',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.forgotPassword.title': 'Reset password',
    'auth.forgotPassword.description': 'Enter your email address and we will send you a link to reset your password.',
    'auth.forgotPassword.brandHeadline': 'Regain access in a few steps',
    'auth.forgotPassword.brandLede': 'Use your email for a reset link, or look up your lab admin if you sign in with a username only.',
    'auth.forgotPassword.submit': 'Send reset link',
    'auth.forgotPassword.success': 'If an account exists for that email, a password reset link has been sent.',
    'auth.forgotPassword.failed': 'Unable to send reset link. Please try again.',
    'auth.forgotPassword.backToLogin': 'Back to login',
    'auth.forgotPassword.noEmailDivider': 'No email?',
    'auth.forgotPassword.noEmailDescription': 'If you sign in with a username and have no email, enter your username to get your lab admin contact details. They can reset your password to the temporary password.',
    'auth.forgotPassword.contactAdmin': 'Get admin contact',
    'auth.forgotPassword.usernameRequired': 'Please enter your username',
    'auth.forgotPassword.contactFailed': 'Unable to look up admin contact. Please try again.',
    'auth.forgotPassword.hasEmail': 'This account has an email. Use the form above to receive a reset link.',
    'auth.forgotPassword.contactFound': 'Contact your lab administrator and ask them to reset your password.',
    'auth.forgotPassword.contactAdminGeneric': 'Contact your lab administrator and ask them to reset your password to the temporary password.',
    'auth.resetPassword.title': 'Set new password',
    'auth.resetPassword.description': 'Choose a new password for your account.',
    'auth.resetPassword.brandHeadline': 'Choose a strong new password',
    'auth.resetPassword.brandLede': 'After resetting, you can sign in again with your updated credentials.',
    'auth.resetPassword.password.label': 'New password',
    'auth.resetPassword.password.required': 'Please enter a new password',
    'auth.resetPassword.password.minLength': 'Password must be at least 8 characters',
    'auth.resetPassword.password.placeholder': 'Enter your new password',
    'auth.resetPassword.password.confirm': 'Confirm password',
    'auth.resetPassword.password.confirmRequired': 'Please confirm your password',
    'auth.resetPassword.password.confirmPlaceholder': 'Confirm your new password',
    'auth.resetPassword.password.mismatch': 'Passwords do not match',
    'auth.resetPassword.submit': 'Reset password',
    'auth.resetPassword.success': 'Your password has been reset. You can now log in.',
    'auth.resetPassword.failed': 'Unable to reset password. Please try again.',
    'auth.resetPassword.error': 'Invalid link',
    'auth.resetPassword.invalidLink': 'Invalid or expired reset link. Please request a new one.',

    // Assets
    'assets.table.name': 'Name',
    'assets.table.cost': 'Cost',
    'assets.table.notes': 'Notes',
    'assets.table.actions': 'Actions',
    'assets.button.add': 'Add Asset',
    'assets.modal.title': 'Assets',
    'assets.confirm.deleteTitle': 'Delete Asset',
    'assets.confirm.deleteMessage': 'Are you sure you want to delete this asset?',
    'assets.form.name.label': 'Asset Name',
    'assets.form.name.placeholder': 'Asset name',
    'assets.form.name.required': 'Please enter the asset name',
    'assets.form.cost.label': 'Cost',
    'assets.form.cost.placeholder': 'Enter cost',
    'assets.form.cost.required': 'Please enter the cost',
    'assets.form.cost.min': 'Cost must be at least 1',
    'assets.form.notes.label': 'Notes',
    'assets.form.notes.placeholder': 'Notes',
    'assets.search.namePlaceholder': 'Search by name',
    'assets.search.notesPlaceholder': 'Search by notes',
    'assets.alert.noAccess': 'You do not have access to view assets.',

    // Branchs
    'branchs.table.name': 'Branch Name',
    'branchs.table.address': 'Address',
    'branchs.table.phone': 'Phone Number',
    'branchs.table.whatsapp': 'WhatsApp Number',
    'branchs.table.email': 'Email',
    'branchs.table.notes': 'Notes',
    'branchs.table.actions': 'Actions',
    'branchs.button.add': 'Add Branch',
    'branchs.modal.title': 'Branches',
    'branchs.confirm.deleteTitle': 'Delete Branch',
    'branchs.confirm.deleteMessage': 'Are you sure you want to delete this branch?',
    'branchs.form.name.label': 'Branch Name',
    'branchs.form.name.placeholder': 'Enter branch name',
    'branchs.form.name.required': 'Please enter the branch name',
    'branchs.form.name.max': 'Name must be at most 255 characters',
    'branchs.form.address.label': 'Address',
    'branchs.form.address.placeholder': 'Enter address',
    'branchs.form.address.required': 'Please enter the address',
    'branchs.form.address.max': 'Address must be at most 500 characters',
    'branchs.form.phone.label': 'Phone Number',
    'branchs.form.phone.placeholder': 'Enter phone number',
    'branchs.form.phone.required': 'Please enter the phone number',
    'branchs.form.phone.max': 'Phone number must be at most 50 characters',
    'branchs.form.whatsapp.label': 'WhatsApp Number',
    'branchs.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'branchs.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'branchs.form.email.label': 'Email',
    'branchs.form.email.placeholder': 'Enter email',
    'branchs.form.email.invalid': 'Please enter a valid email address',
    'branchs.form.notes.label': 'Notes',
    'branchs.form.notes.placeholder': 'Enter notes',
    'branchs.form.notes.max': 'Notes must be at most 1000 characters',
    'branchs.alert.noAccess': 'You do not have access to view branches.',

    // Delivery Centers
    'deliveryCenters.table.name': 'Center Name',
    'deliveryCenters.table.address': 'Address',
    'deliveryCenters.table.phone': 'Phone Number',
    'deliveryCenters.table.whatsapp': 'WhatsApp Number',
    'deliveryCenters.table.email': 'Email',
    'deliveryCenters.table.client': 'Assigned Client',
    'deliveryCenters.table.noClient': 'No client assigned',
    'deliveryCenters.table.actions': 'Actions',
    'deliveryCenters.button.add': 'Add Delivery Center',
    'deliveryCenters.modal.title': 'Delivery Centers',
    'deliveryCenters.confirm.deleteTitle': 'Delete Delivery Center',
    'deliveryCenters.confirm.deleteMessage': 'Are you sure you want to delete this delivery center?',
    'deliveryCenters.form.address.max': 'Address must be at most 500 characters',
    'deliveryCenters.form.phone.max': 'Phone number must be at most 50 characters',
    'deliveryCenters.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'deliveryCenters.form.notes.max': 'Notes must be at most 1000 characters',
    'deliveryCenters.form.client.label': 'Client',
    'deliveryCenters.form.client.placeholder': 'Select a client',
    'deliveryCenters.form.client.required': 'Please select a client',
    'deliveryCenters.alert.noAccess': 'You do not have access to view delivery centers.',
    'deliveryCenters.filter.title': 'Filter Delivery Centers',
    'deliveryCenters.filter.active': 'Active',
    'deliveryCenters.filter.clear': 'Reset Filters',
    'responses.delivery_center.updated': 'Delivery center updated successfully',

    // Clients
    'clients.header.title': 'Clients',
    'clients.header.subtitle': 'Manage clinics, hospitals, and labs with contacts, dentists, and delivery centers',
    'clients.filter.title': 'Filter Clients',
    'clients.filter.active': 'Active',
    'clients.filter.clear': 'Reset Filters',
    'clients.wallet.historyEmpty': 'No wallet transactions yet',
    'clients.alert.noAccess': 'You do not have access to view clients.',
    'clients.table.name': 'Client Name',
    'clients.table.type': 'Client Type',
    'clients.table.phone': 'Phone Number',
    'clients.table.whatsapp': 'WhatsApp Number',
    'clients.table.email': 'Email',
    'clients.table.dentists': 'Assigned Dentists',
    'clients.table.noDentists': 'No dentists assigned',
    'clients.table.noLabContacts': 'No lab contacts assigned',
    'clients.table.showMore': 'Show more',
    'clients.table.showLess': 'Show less',
    'clients.table.deliveryCenters': 'Delivery Centers',
    'clients.table.noDeliveryCenters': 'No delivery centers assigned',
    'clients.table.actions': 'Actions',
    'clients.formulaTypePrices.button': 'Formula type prices',
    'clients.formulaTypePrices.title': 'Formula type prices for',
    'clients.formulaTypePrices.help': 'Set a custom unit price per formula type for this client. Leave empty to use the default selling price.',
    'clients.formulaTypePrices.formulaType': 'Formula type',
    'clients.formulaTypePrices.defaultPrice': 'Default price',
    'clients.formulaTypePrices.customPrice': 'Custom unit price',
    'clients.formulaTypePrices.noChanges': 'No changes to save',
    'clients.button.add': 'Add Client',
    'clients.title': 'Client',
    'clients.modal.title': 'Clients',
    'clients.confirm.deleteTitle': 'Delete Client',
    'clients.confirm.deleteMessage': 'Are you sure you want to delete this client?',
    'clients.form.name.label': 'Client Name',
    'clients.form.name.placeholder': 'Enter client name',
    'clients.form.name.required': 'Please enter the client name',
    'clients.form.name.max': 'Name must be at most 255 characters',
    'clients.form.type.label': 'Client Type',
    'clients.form.type.placeholder': 'Select a client type',
    'clients.form.type.required': 'Please select a client type',
    'clients.form.type.options.clinic': 'Clinic',
    'clients.form.type.options.hospital': 'Hospital',
    'clients.form.type.options.lab': 'Lab',
    'clients.form.search.placeholder': 'Search by name, email, or phone',
    'clients.form.phone.label': 'Phone Number',
    'clients.form.phone.placeholder': 'Enter phone number',
    'clients.form.phone.max': 'Phone number must be at most 50 characters',
    'clients.form.whatsapp.label': 'WhatsApp Number',
    'clients.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'clients.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'clients.form.email.label': 'Email',
    'clients.form.email.placeholder': 'Enter email',
    'clients.form.email.invalid': 'Please enter a valid email address',
    'clients.form.dentists.label': 'Dentists',
    'clients.form.dentists.placeholder': 'Select dentists',
    'clients.form.dentists.empty': 'No available dentists',
    'clients.form.dentists.labelLab': 'Lab contacts',
    'clients.form.dentists.placeholderLab': 'Select lab contacts',
    'clients.form.dentists.emptyLab': 'No available lab contacts',
    'clients.form.deliveryCenters.label': 'Delivery Centers',
    'clients.form.deliveryCenters.placeholder': 'Select or add delivery centers',
    'clients.form.deliveryCenters.empty': 'No available delivery centers',
    'clients.form.submit.edit': 'Update',
    'clients.form.submit.createThenContacts': 'Create client & add contacts',
    'clients.form.submit.createWithContacts': 'Create client with contacts',
    'clients.form.contactMode.label': 'Contacts for this client',
    'clients.form.contactMode.required': 'Please choose how to add contacts',
    'clients.form.contactMode.mirror': 'Create a dentist with the same details',
    'clients.form.contactMode.mirrorLab': 'Create a lab contact with the same details',
    'clients.form.contactMode.mirrorHelp': 'Best when the clinic/hospital has one doctor — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.mirrorHelpLab': 'Best when the lab has one contact — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.list': 'Add multiple dentists',
    'clients.form.contactMode.listLab': 'Add multiple lab contacts',
    'clients.form.contactMode.listHelp': 'Expand this form to add one or more dentists now, then create everything together.',
    'clients.form.contactMode.listHelpLab': 'Expand this form to add one or more lab contacts now, then create everything together.',
    'clients.form.contactMode.dentistTypeMissing': 'Dentist user type is not available. Refresh and try again.',
    'clients.form.mirror.sectionTitle': 'Dentist login',
    'clients.form.mirror.sectionTitleLab': 'Lab contact login',
    'clients.form.mirror.hint': 'Name, phone, WhatsApp, and email are taken from the client. Add a username and/or email for portal login.',
    'clients.form.mirror.createFailed': 'Client was created, but the dentist could not be created. Add them from the client page.',
    'clients.form.mirror.createFailedLab': 'Client was created, but the lab contact could not be created. Add them from the client page.',
    'clients.form.list.sectionTitle': 'Dentists',
    'clients.form.list.sectionTitleLab': 'Lab contacts',
    'clients.form.list.clientCreated': 'Client "{{name}}" was created',
    'clients.form.list.stepTitle': 'Add dentists — {{name}}',
    'clients.form.list.stepTitleLab': 'Add lab contacts — {{name}}',
    'clients.form.list.stepHelp': 'Add one or more dentists for this client. You can skip and add them later.',
    'clients.form.list.stepHelpLab': 'Add one or more lab contacts for this client. You can skip and add them later.',
    'clients.form.list.addAnother': 'Add another dentist',
    'clients.form.list.addAnotherLab': 'Add another lab contact',
    'clients.form.list.saveContacts': 'Save dentists',
    'clients.form.list.saveContactsLab': 'Save lab contacts',
    'clients.form.list.createFailed': 'Client was created, but some dentists could not be created. Add them from the client page.',
    'clients.form.list.createFailedLab': 'Client was created, but some lab contacts could not be created. Add them from the client page.',
    'clients.form.list.done': 'Done',
    'clients.type.clinic': 'Clinic',
    'clients.type.hospital': 'Hospital',
    'clients.type.lab': 'Lab',
    'clients.wallet.title': 'Client Wallet',
    'clients.tabs.overview': 'Overview',
    'clients.tabs.wallet': 'Wallet',
    'clients.tabs.deliveryCenters': 'Delivery Centers',
    'clients.tabs.dentists': 'Dentists',
    'clients.tabs.labContacts': 'Lab contacts',
    'clients.tabs.customPrices': 'Custom prices',
    'clients.wallet.balance': 'Balance',
    'clients.wallet.recharge': 'Recharge',
    'clients.wallet.amount': 'Amount',
    'clients.wallet.amountPlaceholder': 'Enter amount',
    'clients.wallet.notes': 'Notes',
    'clients.wallet.notesPlaceholder': 'Optional notes for this recharge',
    'clients.wallet.rechargeSuccess': 'Wallet recharged successfully',
    'clients.wallet.rechargeError': 'Failed to recharge wallet',
    'clients.wallet.amountRequired': 'Amount is required',
    'clients.wallet.amountMin': 'Amount must be at least 0.01',
    'clients.wallet.paymentMethod': 'Payment Method',
    'clients.wallet.paymentMethodPlaceholder': 'Select payment method',
    'clients.wallet.attachments': 'Attachments',
    'clients.wallet.uploadImage': 'Upload image',
    'clients.wallet.history': 'Wallet History',
    'clients.wallet.historyDate': 'Date',
    'clients.wallet.transactionType': 'Type',
    'sidebar.clients': 'Clients and Doctors',
    'sidebar.wallets': 'Wallets',
    'wallets.title': 'Wallets',
    'wallets.column.walletId': 'Wallet ID',
    'wallets.column.clientName': 'Client name',
    'wallets.column.balance': 'Balance',
    'wallets.viewTitle': 'Wallet #{{id}}',
    'wallets.backToList': 'Back to Transactions',
    'wallets.openClient': 'Client profile',
    'wallets.walletIdLabel': 'Wallet ID',
    'wallets.alert.noAccess': 'You do not have access to wallets.',

    // Colors
    'colors.table.name': 'Color',
    'colors.table.actions': 'Actions',
    'colors.button.add': 'Add Color',
    'colors.modal.title': 'Colors',
    'colors.confirm.deleteTitle': 'Delete Color',
    'colors.confirm.deleteMessage': 'Are you sure you want to delete this color?',
    'colors.form.code.placeholder': 'Enter code',
    'colors.form.preview.label': 'Tooth Color Preview',
    'colors.alert.noAccess': 'You do not have access to view colors.',

    // Dentists
    'dentists.label.singular': 'Dentist',
    'dentists.label.singular.lab': 'Lab contact',
    'dentists.label.plural': 'Dentists',
    'dentists.label.plural.lab': 'Lab contacts',
    'dentists.table.name': 'Dentist Name',
    'dentists.table.username': 'Username',
    'dentists.table.email': 'Email',
    'dentists.table.address': 'Address',
    'dentists.table.phone': 'Phone Number',
    'dentists.table.whatsapp': 'WhatsApp Number',
    'dentists.table.client': 'Client',
    'dentists.table.accountRole': 'Account',
    'dentists.table.accountRoleMain': 'Main',
    'dentists.table.accountRoleSub': 'Sub',
    'dentists.table.noClient': 'No client',
    'dentists.table.actions': 'Actions',
    'dentists.filter.title': 'Filter Dentists',
    'dentists.filter.titleLab': 'Filter Lab Contacts',
    'dentists.filter.active': 'Active',
    'dentists.button.add': 'Add Dentist',
    'dentists.button.addLabContact': 'Add Lab Contact',
    'dentists.modal.title': 'Dentists',
    'dentists.modal.titleLabContact': 'Lab Contacts',
    'dentists.confirm.deleteTitle': 'Delete Dentist',
    'dentists.confirm.deleteMessage': 'Are you sure you want to delete this dentist?',
    'dentists.confirm.removeTitle': 'Remove Dentist',
    'dentists.confirm.removeMessage': 'This dentist will be detached from this client and deactivated.',
    'dentists.confirm.deleteTitleLabContact': 'Delete Lab Contact',
    'dentists.confirm.deleteMessageLabContact': 'Are you sure you want to delete this lab contact?',
    'dentists.confirm.removeTitleLabContact': 'Remove Lab Contact',
    'dentists.confirm.removeMessageLabContact': 'This lab contact will be detached from this client and deactivated.',
    'dentists.form.accountRole.label': 'Account type',
    'dentists.form.accountRole.main': 'Main account',
    'dentists.form.accountRole.sub': 'Sub account',
    'dentists.form.accountRole.hint': 'Main accounts can access all client resources. Sub accounts only access their own orders and profile.',
    'dentists.form.accountRole.labLocked': 'Lab contacts are always main accounts.',
    'dentists.form.client.label': 'Client',
    'dentists.form.client.placeholder': 'Select or add a client',
    'dentists.alert.noAccess': 'You do not have access to view dentists.',
    'dentists.alert.noDentistType': 'Dentist user type is missing. Please configure user types first.',
    'dentists.changeHistory': 'Change history',
    'dentists.versions.title': 'Dentist change history',
    'dentists.versions.empty': 'No change history yet',
    'dentists.versions.timelineTitle': 'Timeline',
    'dentists.versions.by': 'Updated by',
    'dentists.versions.fieldsChanged': 'Fields changed',
    'dentists.versions.compareTitle': 'Compare with current',
    'dentists.versions.selectVersion': 'Select a version',
    'dentists.versions.noFields': 'No changed fields captured',
    'dentists.versions.before': 'Before',
    'dentists.versions.after': 'After (Current)',

    // Expenses
    'expenses.table.expenseType': 'Expense Item',
    'expenses.table.cost': 'Cost',
    'expenses.table.date': 'Date',
    'expenses.table.notes': 'Notes',
    'expenses.table.assignedUser': 'Assigned to',
    'expenses.table.actions': 'Actions',
    'expenses.button.add': 'Add Expense',
    'expenses.modal.title': 'Expense Record',
    'expenses.confirm.deleteTitle': 'Delete Expense',
    'expenses.confirm.deleteMessage': 'Are you sure you want to delete this expense?',
    'expenses.form.type.label': 'Expense Item',
    'expenses.form.expense_type_id': 'Expense Type',
    'expenses.form.type.placeholder': 'Select expense item',
    'expenses.form.type.required': 'Please select an expense item',
    'expenses.form.cost.label': 'Cost',
    'expenses.form.cost.placeholder': '0',
    'expenses.form.cost.required': 'Please enter the cost',
    'expenses.form.notes.label': 'Notes',
    'expenses.form.notes.placeholder': 'Enter notes',
    'expenses.form.assignedUser.label': 'Assigned user',
    'expenses.form.assignedUser.placeholder': 'Select courier, technician, or admin',
    'expenses.form.assignedUser.unassigned': 'Unassigned',
    'expenses.search.notesPlaceholder': 'Search notes',
    'expenses.filter.assignedUser.placeholder': 'Filter by assigned user',
    'expenses.alert.noAccess': 'You do not have access to view expenses.',

    // Expense Types
    'expenseTypes.table.name': 'Item Name',
    'expenseTypes.table.description': 'Description',
    'expenseTypes.table.actions': 'Actions',
    'expenseTypes.button.add': 'Add Expense Item',
    'expenseTypes.modal.title': 'Expense Items',
    'expenseTypes.confirm.deleteTitle': 'Delete Expense Item',
    'expenseTypes.confirm.deleteMessage': 'Are you sure you want to delete this expense item?',
    'expenseTypes.form.name.label': 'Item Name',
    'expenseTypes.form.name.placeholder': 'Enter item name',
    'expenseTypes.form.name.required': 'Please enter the item name',
    'expenseTypes.form.description.label': 'Item Description',
    'expenseTypes.form.description.placeholder': 'Enter item description',
    'expenseTypes.search.namePlaceholder': 'Search by name',
    'expenseTypes.search.descriptionPlaceholder': 'Search by description',
    'expenseTypes.alert.noAccess': 'You do not have access to view expense types.',

    // Orders
    'orders.header.title': 'Orders',
    'orders.header.subtitle': 'Track laboratory orders, production workflow and delivery schedules',
    'orders.search.placeholder': 'Search patient, order # or reference',
    'orders.filter.title': 'Filter Orders',
    'orders.filter.clear': 'Reset Filters',
    'orders.filter.active': 'Active',
    'orders.table.refresh': 'Refresh',
    'orders.table.notInvoiced': 'Not Invoiced',
    'orders.table.patientName': 'Patient Name',
    'orders.table.dentistName': 'Dentist Name',
    'orders.table.color': 'Color',
    'orders.table.formulaType': 'Formula Type',
    'orders.table.client': 'Client',
    'orders.table.invoice': 'Invoice',
    'orders.table.total': 'Total Amount',
    'orders.table.id': 'Order ID',
    'orders.table.paid': 'Paid Amount',
    'orders.table.remaining': 'Remaining Amount',
    'orders.table.paymentStatus': 'Payment Status',
    'orders.table.status': 'Order Status',
    'orders.summary.title': 'Order Summary',
    'orders.summary.itemsLabel': 'Items',
    'orders.summary.deliveryCenter': 'Delivery Center',
    'orders.summary.noDeliveryCenter': 'No delivery center',
    'orders.summary.color': 'Color',
    'orders.summary.noColor': '—',
    'orders.summary.subtotal': 'Subtotal',
    'orders.summary.discount': 'Discount',
   
    'orders.summary.discountClientFormulaType': 'Client formula type discount',
    'orders.summary.discountUnitOverride': 'Per-unit override discount',
    'orders.summary.discountOrderAmount': 'Order discount',
    'orders.summary.totalDiscount': 'Total discount',
    'orders.actions.workCard': 'Work Card',
    'orders.actions.workCardCreated': 'Work card created',
    'orders.actions.createWorkCard': 'Work Card',
    'orders.actions.downloadWorkCard': 'Download Work Card',
    'orders.calendar.title': 'Calendar',
    'orders.calendar.subtitle': 'Track order and invoice dates across week, month, and year views',
    'orders.calendar.viewList': 'View Orders List',
    'orders.calendar.more': 'more',
    'orders.calendar.week': 'Week',
    'orders.calendar.month': 'Month',
    'orders.calendar.year': 'Year',
    'orders.calendar.ordersCount': 'orders',
    'orders.calendar.itemsCount': 'items',
    'orders.calendar.today': 'Today',
    'orders.calendar.noOrders': 'No orders',
    'orders.calendar.noItems': 'No items',
    'orders.calendar.patient': 'Patient',
    'orders.calendar.client': 'Client',
    'orders.calendar.ref': 'Ref',
    'orders.calendar.entity.order': 'Order',
    'orders.calendar.entity.invoice': 'Invoice',
    'orders.calendar.filter.title': 'Show on calendar',
    'orders.calendar.filter.byClientDentist': 'Clients & dentists',
    'orders.calendar.filter.orders': 'Orders',
    'orders.calendar.filter.invoices': 'Invoices',
    'orders.calendar.filter.orderDeliveryDate': 'Delivery date',
    'orders.calendar.filter.orderIssueDate': 'Issue date',
    'orders.calendar.filter.orderRequestedAt': 'Requested at',
    'orders.calendar.filter.invoiceIssueDate': 'Issue date',
    'orders.calendar.filter.invoiceDueDate': 'Due date',
    'orders.calendar.weekend': 'Weekend',
    'orders.calendar.vacation': 'Vacation',
    'orders.calendar.legend.closed': 'Closed days',

    // Vacations / weekend settings
    'vacations.weekend.title': 'Weekend days',
    'vacations.weekend.hint': 'Select which weekdays are weekends. They will be highlighted on the orders calendar.',
    'vacations.weekend.save': 'Save weekend days',
    'vacations.list.title': 'Vacations',
    'vacations.list.hint': 'Add date ranges when the lab is closed. These days will appear on the calendar.',
    'vacations.add': 'Add vacation',
    'vacations.edit': 'Edit vacation',
    'vacations.table.name': 'Name',
    'vacations.table.startsOn': 'Starts on',
    'vacations.table.endsOn': 'Ends on',
    'vacations.table.notes': 'Notes',
    'vacations.table.actions': 'Actions',
    'vacations.form.name': 'Name',
    'vacations.form.nameRequired': 'Name is required',
    'vacations.form.namePlaceholder': 'e.g. Eid holiday',
    'vacations.form.range': 'Date range',
    'vacations.form.rangeRequired': 'Date range is required',
    'vacations.form.notes': 'Notes',
    'vacations.confirm.deleteTitle': 'Delete vacation?',
    'vacations.confirm.deleteMessage': 'This cannot be undone.',
    'vacations.weekday.sunday': 'Sunday',
    'vacations.weekday.monday': 'Monday',
    'vacations.weekday.tuesday': 'Tuesday',
    'vacations.weekday.wednesday': 'Wednesday',
    'vacations.weekday.thursday': 'Thursday',
    'vacations.weekday.friday': 'Friday',
    'vacations.weekday.saturday': 'Saturday',

    // UI labels for work card modal
    'ui.order.work_card': 'Work Card',
    'ui.order.order_id': 'Order ID',
    'ui.order.client': 'Client',
    'ui.order.dentist': 'Dentist',
    'ui.order.patient': 'Patient',
   
    'ui.order.formulaType': 'Formula type',
    'ui.order.color': 'Color',
    'ui.order.units': 'Units',
    'ui.order.units_positions': 'Units (positions)',
    'ui.order.units_count': 'Units count',
    'ui.order.items': 'Items',
    'ui.order.unit': 'Unit',
    'ui.order.no_qr_available': 'No QR available',
    'ui.order.order_barcode': 'Order Barcode',
    'ui.order.view_public_note': 'This is a public view of the order. No authentication required.',
    'ui.order.unit_types': 'Chosen Units (by position)',
    'ui.order.unit_positions': 'Unit positions',
    'ui.order.color_hex': 'Hex',
    // Arabic translation
    'ui.order.unit_positions_ar': 'Unit positions',
    'ui.order.unit_level': 'Level',
    'ui.order.unit_direction': 'Direction',
    'ui.order.unit_order': 'Order',
    'ui.order.unit_name': 'Type',
    'ui.order.tooth_picker': 'Tooth Picker',
    'ui.order.tooth_previewer': 'Tooth Previewer',
    'ui.order.tooth_picker_hint': 'Selected units are highlighted below',
    'ui.order.note': 'Note',
    'ui.order.view_title': 'Order View',
    'ui.order.switch_to_en': 'Switch to English',
    'ui.order.switch_to_ar': 'Switch to Arabic',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',
    'ui.order.tracking_barcode': 'Lab Tracking & Barcode',
    'ui.order.scan_instructions': 'Scan barcode with a scanner or QR code with a camera to view or track this order.',
    'ui.order.dental_chart': 'Dental Chart (Odontogram)',
    'ui.order.clinical_specifications': 'Clinical Specifications & Restorations',
    'ui.order.clinical_notes': 'Clinical Notes & Special Instructions',
    'ui.order.no_notes': 'No special clinical instructions or notes recorded for this order.',
    'ui.order.attachments_title': 'Clinical Attachments & 3D Scans',
    'ui.order.no_attachments': 'No clinical files or scans attached to this order.',
    'ui.order.logistics_title': 'Delivery & Logistics',
    'ui.order.linked_invoice': 'Linked Invoice',
    'ui.order.view_invoice_action': 'View Public Invoice',
    'ui.order.selected_teeth_legend': 'Restored Teeth',
    'ui.order.natural_teeth_legend': 'Natural / Untreated',
    'ui.order.qc_signoff': 'Quality Control & Lab Sign-Off',
    'ui.order.qc_passed': 'QC Inspection Passed',
    'ui.order.technician_signature': 'Technician Signature',
    'ui.order.qc_date': 'Date',
    'ui.order.teeth_selected_count': '{{count}} teeth specified',
    'ui.order.expected_delivery': 'Expected Delivery',
    'ui.order.shade_color': 'Shade / Color',
    'ui.order.product_type': 'Product',
    'ui.order.quadrant_1': 'Q1 (Upper Right)',
    'ui.order.quadrant_2': 'Q2 (Upper Left)',
    'ui.order.quadrant_3': 'Q3 (Lower Left)',
    'ui.order.quadrant_4': 'Q4 (Lower Right)',
    'ui.order.scan_modal_title': 'Order Barcode & QR Code',
    'ui.order.fullscreen_scan': 'Scan / Enlarge',
    'ui.order.download_attachment': 'Download',
    'ui.order.preview_attachment': 'Preview',
    'ui.order.clinic': 'Clinic',
    'ui.order.order_date': 'Order Date',
    'ui.order.public_order_disclaimer': 'This official dental lab order specification is provided for clinical and laboratory verification. No login required.',
    'ui.order.loading_details': 'Loading order details...',

    // Generic language toggler
    'ui.switch_to_en': 'Switch to English',
    'ui.switch_to_ar': 'Switch to Arabic',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.copy_link': 'Copy link',
    'ui.copy_link_copied': 'Link copied',
    'ui.theme.lightMode': 'Light Mode',
    'ui.theme.darkMode': 'Dark Mode',
    'ui.menu.open': 'Open menu',
    'ui.menu.navigation': 'Navigation',
    'ui.prices.show': 'Show prices',
    'ui.prices.hide': 'Hide prices',
    'ui.date.startDate': 'Start Date',
    'ui.date.endDate': 'End Date',

    'cookies.title': 'We use cookies',
    'cookies.message':
      'We use cookies to keep you signed in, remember your language and preferences, and improve Dentrist. By continuing, you accept our use of cookies.',
    'cookies.accept': 'Accept cookies',

    'onboarding.menu.start': 'System tour',
    'onboarding.welcome.title': 'Welcome to Dentrist',
    'onboarding.welcome.description':
      'This system tour walks you through the workspace chrome and every page in your sidebar. You can replay it anytime from your profile menu.',
    'onboarding.navigation.title': 'Main navigation',
    'onboarding.navigation.description':
      'Use the sidebar to open every page available in your system. Next, we will visit each one.',
    'onboarding.controls.title': 'Language & theme',
    'onboarding.controls.description':
      'Switch between Arabic and English, and choose light or dark mode for your workspace.',
    'onboarding.account.title': 'Account & alerts',
    'onboarding.account.description':
      'Check notifications, show or hide prices, open your profile, or restart this tour from the user menu.',
    'onboarding.workspace.title': 'Your workspace',
    'onboarding.workspace.description':
      'This is where dashboards, lists, and forms appear. Start from Home to see your lab activity at a glance.',
    'onboarding.pages.title': 'System pages',
    'onboarding.pages.description':
      'We will now open each page included in your system so you can see where everything lives.',
    'onboarding.page.description':
      'This is the {{page}} page. Open it anytime from the sidebar to continue your work here.',
    'onboarding.finish.title': 'You are ready',
    'onboarding.finish.description':
      'That covers every page in your system. Restart this tour anytime from your profile menu.',

    'userTypes.dentist': 'Dentist',
    'userTypes.lab_contact': 'Lab contact',
    'userTypes.technician': 'Technician',
    'userTypes.courier': 'Courier',
    'userTypes.admin': 'Admin',

    'deliveryTypes.standard_delivery': 'Standard Delivery',
    'deliveryTypes.free_delivery': 'Free Delivery',
    'ui.order.units_list': 'Units',
    'ui.order.qr': 'QR',

    'orders.summary.vat': 'VAT ({{percent}}%)',

    // General UI
    'common.print': 'Print',
    'common.openNew': 'Open in New Page',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.save': 'Save',
    'common.updated': 'Updated',
    'orders.summary.delivery': 'Delivery Cost',
    'orders.summary.total': 'Total',
    'orders.summary.noFormulaType': 'No formula type selected',
    'orders.summary.formulaType': 'Formula type',
    'orders.summary.unitUnknown': 'Unit',
    'orders.summary.noUnits': 'No units selected',
    'orders.summary.unitLabel': 'Unit',
    'orders.summary.price': 'Price',
    'orders.summary.formulaLineTitle': 'Formula {{n}}',
    'orders.summary.pricePerUnit': 'Price per unit',
    'orders.summary.unitsCount': 'Units count',
    'orders.summary.formulaLineTotal': 'Formula price',
    'orders.summary.vatLabel': 'VAT',
    'orders.summary.deliveryLabel': 'Delivery Cost',
    'orders.summary.deliveryLabelWithType': 'Delivery Cost ({type})',
    'orders.summary.free': 'Free',
    'orders.table.delivery': 'Delivery',
    'orders.table.createdAt': 'Created On',
    'orders.table.requestedAt': 'Requested At',
    'orders.table.deliveredAt': 'Delivered At',
    'orders.table.units': 'Units Count',
    'orders.table.actions': 'Actions',
    'orders.table.technician': 'Technician',
    'orders.table.courier': 'Courier',
    'orders.status.delivered': 'Delivered',
    'orders.status.pendingDelivery': 'Not delivered',
    'orders.status.paid': 'Paid',
    'orders.status.unpaid': 'Unpaid',
    'orders.status.unknown': 'Unknown',
    'orders.form.patientName.label': 'Patient Name',
    'orders.form.patientName.placeholder': 'Enter patient name',
    'orders.form.patientName.required': 'Please enter the patient name',
    'orders.form.dentist.label': 'Dentist',
    'orders.form.dentist.placeholder': 'Select or add a dentist',
    'orders.form.dentist.required': 'Please select a dentist',
    'orders.form.dentist.clientRequired': 'Select a client first to choose a dentist.',
    'orders.form.dentist.labelLabContact': 'Lab contact',
    'orders.form.dentist.placeholderLabContact': 'Select or add a lab contact',
    'orders.form.dentist.requiredLabContact': 'Please select a lab contact',
    'orders.form.dentist.clientRequiredLabContact': 'Select a client first to choose a lab contact.',
    'orders.form.client.label': 'Client',
    'orders.form.client.placeholder': 'Select or add a client',
    'orders.form.client.required': 'Please select a client',
    'orders.form.color.label': 'Color',
    'orders.form.color.defaultLabel': 'Default color (for new units)',
    'orders.form.color.defaultHelp': 'Applied when you add a new unit',
    'orders.form.color.placeholder': 'Select or add a color',
    'orders.form.color.required': 'Please select a color',
    'orders.form.unitColors.label': 'Color per unit',
    'orders.form.unitFormulaTypes.label': 'Formula type per unit',
    'orders.form.formulaType.defaultLabel': 'Default Formula Type (for new units)',
    'orders.form.formulaType.defaultHelp': 'Applied when you add a new unit',
    'orders.form.unitPriceOverride.placeholder': 'Price override',
    'orders.form.discountAmount.label': 'Order discount (amount)',
    'orders.form.discountAmount.help': 'Deduct this amount from the order subtotal.',
    'orders.form.discountAmount.placeholder': '0',
    'orders.form.formulaType.label': 'Formula Type',
    'orders.form.formulaType.placeholder': 'Select Formula Type',
    'orders.form.formulaType.required': 'Please select a Formula Type',
    'orders.form.requestedAt.label': 'Requested At',
    'orders.form.requestedAt.placeholder': 'Select date',
    'orders.form.issueDate.label': 'Issue Date',
    'orders.form.issueDate.placeholder': 'Select date',
    'orders.form.deliveryDate.label': 'Delivery Date',
    'orders.form.deliveryDate.placeholder': 'Select date',
    'orders.form.additionalCostItems.title': 'Additional cost items',
    'orders.form.additionalCostItems.help': 'Add extra charges (e.g. rush fee, custom shade). Each line has a description and amount.',
    'orders.form.additionalCostItems.labelPlaceholder': 'Item description',
    'orders.form.additionalCostItems.amountPlaceholder': 'Cost',
    'orders.form.additionalCostItems.add': 'Add cost item',
    'orders.form.additionalCostItems.remove': 'Remove',
    'orders.form.additionalCostItems.labelRequired': 'Enter a description for this item',
    'orders.form.additionalCostItems.amountRequired': 'Enter the cost amount',
    'orders.summary.additionalCostsTitle': 'Additional costs',
    'orders.summary.additionalCostItemFallback': 'Extra item',
    'orders.summary.additionalCosts': 'Additional costs total',
    'orders.form.notes.label': 'Notes',
    'orders.form.notes.placeholder': 'Notes',
    'orders.form.technician.label': 'Technicians',
    'orders.form.technician.placeholder': 'Select technicians',
    'orders.form.technician.required': 'Please select at least one technician',
    'orders.form.selectUnits.label': 'Select Units',
    'orders.form.selectUnits.required': 'Please select at least one unit',
    'orders.form.orderFormulas.title': 'Order formulas',
    'orders.form.orderFormulas.help': 'An order can include several formulas. On each line, first choose the formula type, then choose the units (teeth for unit scope, or upper and/or lower arch for arch scope). Only unit types that match the formula type are shown.',
    'orders.form.orderFormulas.lineTitle': 'Formula {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'Formula #',
    'orders.form.orderFormulas.material': 'Material',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.stepFormulaType': 'Step 1: Formula type',
    'orders.form.orderFormulas.colorLabel': 'Color (this formula)',
    'orders.form.orderFormulas.stepUnits': 'Step 2: Units',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'Select formula type first',
    'orders.form.orderFormulas.addLine': 'Add another formula',
    'orders.form.orderFormulas.removeLine': 'Remove this formula',
    'orders.form.orderFormulas.formulaType': 'Formula type',
    'orders.form.orderFormulas.selectUnits': 'Teeth / units',
    'orders.form.orderFormulas.archChoice': 'Arch',
    'orders.form.orderFormulas.archUpper': 'Upper arch',
    'orders.form.orderFormulas.archLower': 'Lower arch',
    'orders.form.orderFormulas.pickTypeFirst': 'Choose a formula type to load matching units.',
    'orders.form.orderFormulas.required': 'Add at least one formula line with a type and selected units.',
    'orders.form.orderFormulas.incompleteLine': 'Each formula line with a selected type must include at least one unit (tooth or arch).',
    'orders.form.orderFormulas.duplicateFormulaType': 'You can only add one line per formula type on an order.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'Each selected unit must have a formula type before saving.',
    'orders.form.orderFormulas.summaryUnits': 'Units in this order',
    'orders.form.persistedFormulas.title': 'Formulas on this order',
    'orders.form.persistedFormulas.help': 'Each row is a saved formula (type, unit, and color). Adjust per-unit formula types and pricing in the summary when editing.',
    'orders.form.persistedFormulas.unit': 'Unit (FDI)',
    'orders.form.persistedFormulas.color': 'Color',
    'orders.form.persistedFormulas.detach': 'Remove from order',
    'orders.form.persistedFormulas.detachConfirm': 'Remove this formula line from the order? Linked teeth will lose this formula until you add a new line or set types in the summary.',
    'orders.form.persistedFormulas.detachSuccess': 'Formula line removed from the order.',
    'orders.form.persistedFormulas.detachError': 'Could not remove the formula line. Try again.',
    'orders.form.toothPreview.title': 'Teeth preview',
    'orders.form.toothPreview.help': 'Same chart as when creating an order. When editing, tap teeth to change the selection, then save.',
    'toothPicker.selectUpper': 'Select upper arch',
    'toothPicker.selectLower': 'Select lower arch',
    'toothPicker.clear': 'Clear',
    'orders.form.deliveryCenter.label': 'Delivery Center',
    'orders.form.deliveryCenter.placeholder': 'Select or add a delivery center',
    'orders.form.deliveryCenter.required': 'Please select a delivery center',
    'orders.form.deliveryCenter.clientRequired': 'Select a client first to choose a delivery center.',
    'orders.form.deliveryType.label': 'Delivery Type',
    'orders.form.deliveryType.placeholder': 'Select delivery type',
    'orders.form.attachment.label': 'Attachments',
    'orders.form.attachments.label': 'Attachments',
    'orders.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'orders.form.attachments.choose': 'Choose files',
    'orders.form.attachments.existing': 'Existing attachments:',
    'orders.form.attachments.deleteConfirm': 'Remove attachment?',
    'orders.form.attachments.empty': 'No attachments',
    'orders.form.attachments.download': 'Download',
    'orders.form.attachments.commentPlaceholder': 'Comment',
    'orders.form.attachments.col.id': 'ID',
    'orders.form.attachments.col.name': 'Name',
    'orders.form.attachments.col.url': 'URL',
    'orders.form.attachments.col.file': 'File',
    'orders.form.attachments.col.comment': 'Comment',
    'orders.form.attachments.col.preview': 'Preview',
    'orders.form.attachments.col.download': 'Download',
    'orders.form.attachments.col.delete': 'Delete',
    'orders.form.attachments.col.edit': 'Edit',
    'orders.form.attachments.edit': 'Edit',
    'orders.form.attachments.editTitle': 'Edit attachment',
    'orders.form.attachments.viewTitle': 'Attachment details',
    'orders.form.attachments.namePlaceholder': 'Attachment name',
    'orders.form.attachments.replaceFile': 'Replace file',
    'orders.form.attachments.replaceFileHint': 'Leave empty to keep the current file.',
    'orders.form.attachments.chooseReplacement': 'Choose replacement file',
    'orders.form.submit.create': 'Create Order',
    'orders.form.submit.save': 'Save Changes',
    'orders.create.header.title': 'New Order',
    'orders.create.header.subtitle': 'Pick the client and dentist, add the order formulas, then confirm the delivery schedule.',
    'orders.create.header.backToOrders': 'Back to orders',
    'orders.form.section.parties': 'Client & Dentist',
    'orders.form.section.schedule': 'Patient & Schedule',
    'orders.form.section.notesAttachments': 'Notes & Attachments',
    'orders.create.section.primaryTitle': 'Order Details',
    'orders.create.section.secondaryTitle': 'Financial Details',
    'orders.create.section.secondaryPlaceholder': 'This section will be available soon.',
    'orders.update.section.primaryTitle': 'Order Details',
    'orders.update.section.secondaryTitle': 'Order Actions',
    'orders.update.section.secondaryPlaceholder': 'Additional order information will appear here soon.',
    'orders.changeHistory': 'Change history',
    'orders.comments.title': 'Messages',
    'orders.comments.internal.tab': 'Internal (team)',
    'orders.comments.internal.hint': 'Visible to your lab team only. Clients cannot see these messages.',
    'orders.comments.external.tab': 'Client conversation',
    'orders.comments.external.hint': 'Visible to the client’s dentists / lab contacts, lab admins and assigned technicians.',
    'orders.comments.external.hintClient': 'Your conversation with the lab about this order.',
    'orders.comments.empty': 'No messages yet. Start the conversation.',
    'orders.comments.placeholder': 'Write a message… (Ctrl+Enter to send)',
    'orders.comments.send': 'Send',
    'orders.comments.edited': 'edited',
    'orders.comments.edit': 'Edit',
    'orders.comments.delete': 'Delete',
    'orders.comments.save': 'Save',
    'orders.comments.deleteConfirm': 'Delete this message?',
    'orders.comments.sendError': 'Failed to send message',
    'orders.comments.updateError': 'Failed to update message',
    'orders.comments.deleteError': 'Failed to delete message',
    'orders.comments.loadError': 'Failed to load messages',
    'orders.comments.you': 'You',
    'orders.comments.role.client': 'Client',
    'orders.comments.role.admin': 'Admin',
    'orders.comments.role.technician': 'Technician',
    'orders.comments.role.courier': 'Courier',
    'orders.phases.title': 'Phases',
    'orders.phases.add': 'Add phase',
    'orders.phases.addTitle': 'Add phase',
    'orders.phases.editTitle': 'Edit phase',
    'orders.phases.edit': 'Edit',
    'orders.phases.delete': 'Delete',
    'orders.phases.save': 'Save',
    'orders.phases.empty': 'No phases for this order yet.',
    'orders.phases.noDates': 'No dates set',
    'orders.phases.deleteConfirm': 'Delete phase "{{title}}"?',
    'orders.phases.created': 'Phase added',
    'orders.phases.updated': 'Phase updated',
    'orders.phases.deleted': 'Phase deleted',
    'orders.phases.createError': 'Failed to add phase',
    'orders.phases.updateError': 'Failed to update phase',
    'orders.phases.deleteError': 'Failed to delete phase',
    'orders.phases.loadError': 'Failed to load phases',
    'orders.phases.type.engine': 'Engine phase',
    'orders.phases.type.custom': 'Custom phase',
    'orders.phases.fields.template': 'Start from a standard phase',
    'orders.phases.fields.templateHint': 'Optional: fills in the title and details, which you can still edit.',
    'orders.phases.fields.templatePlaceholder': 'Select a standard phase',
    'orders.phases.fields.title': 'Title (English)',
    'orders.phases.fields.titleAr': 'Title (Arabic)',
    'orders.phases.fields.titleRequired': 'Please enter a title',
    'orders.phases.fields.description': 'Details (English)',
    'orders.phases.fields.descriptionAr': 'Details (Arabic)',
    'orders.phases.fields.technician': 'Technician',
    'orders.phases.fields.swap': 'Change phase',
    'orders.phases.fields.swapPlaceholder': 'Replace with a collapsed phase',
    'orders.phases.fields.noHiddenPhases': 'All phases are expanded',
    'orders.phases.swapped': 'Phase changed',
    'orders.phases.swapError': 'Could not change the phase',
    'orders.phases.visibilityError': 'Could not update the phases view',
    'orders.phases.fields.dates': 'Start and end date',
    'orders.phases.fields.startDate': 'Start date',
    'orders.phases.fields.endDate': 'End date',
    'orders.phases.step': 'Step {{n}}',
    'orders.phases.status.current': 'Current',
    'orders.phases.status.done': 'Done',
    'orders.phases.setCurrent': 'Set as current',
    'orders.phases.moveUp': 'Move up',
    'orders.phases.moveDown': 'Move down',
    'orders.phases.currentSet': 'Current phase updated',
    'orders.phases.currentError': 'Failed to set the current phase',
    'orders.phases.reorderError': 'Failed to update the phase sequence',
    'orders.phases.summary': 'Current phase: {{title}} (step {{n}} of {{total}})',
    'orders.phases.noCurrent': 'No current phase set',
    'orders.phases.completedCount': '{{done}} of {{total}} completed',
    'orders.phases.expand': 'Expand',
    'orders.phases.collapse': 'Collapse',
    'orders.phases.collapseAll': 'Collapse phases after the current one',
    'orders.versions.title': 'Order change history',
    'orders.versions.empty': 'No change history yet',
    'orders.versions.timelineTitle': 'Timeline',
    'orders.versions.by': 'Updated by',
    'orders.versions.fieldsChanged': 'Fields changed',
    'orders.versions.compareTitle': 'Compare with current',
    'orders.versions.selectVersion': 'Select a version',
    'orders.versions.noFields': 'No changed fields captured',
    'orders.versions.before': 'Before',
    'orders.versions.after': 'After (Current)',
    'orders.versions.unitLabel': 'Unit',
    'orders.versions.priceLabel': 'Price',
    'orders.actions.technician.label': 'Technicians',
    'orders.actions.technician.unassigned': 'Unassigned',
    'orders.actions.technician.change': 'Change Technicians',
    'orders.actions.viewInvoice': 'View Invoice',
    'orders.actions.technician.select': 'Select technicians',
    'orders.actions.technician.changeSuccess': 'Technicians updated',
    'orders.actions.technician.changeError': 'Failed to update technicians',
    'orders.actions.courier.label': 'Courier',
    'orders.actions.courier.unassigned': 'Unassigned',
    'orders.actions.courier.change': 'Change Courier',
    'orders.actions.courier.select': 'Select courier',
    'orders.actions.courier.changeSuccess': 'Courier updated',
    'orders.actions.courier.changeError': 'Failed to update courier',
    'orders.actions.courier.unassign': 'Unassign',
    'orders.actions.disableClientEdit.label': 'Disable client edit',
    'orders.actions.disableClientEdit.enabled': 'Client cannot edit this order',
    'orders.actions.disableClientEdit.disabled': 'Client can edit this order',
    'orders.actions.disableClientEdit.lockedMessage': 'This order is locked. You cannot edit it. Contact the lab if you need changes.',
    'orders.actions.sharePhasesWithClient.label': 'Share phases with client',
    'orders.actions.sharePhasesWithClient.short': 'Share with client',
    'orders.actions.sharePhasesWithClient.enabled': 'Client can follow the order phases',
    'orders.actions.sharePhasesWithClient.disabled': 'Phases are visible to the lab only',
    'orders.orderStatus.requested': 'Requested',
    'orders.orderStatus.review': 'Review',
    'orders.orderStatus.tx-review': 'Tx. Review',
    'orders.orderStatus.tx-approved': 'Tx. Approved',
    'orders.orderStatus.tx-replan': 'Tx. Replan',
    'orders.orderStatus.in-progress': 'In Progress',
    'orders.orderStatus.in-delivery': 'In Delivery',
    'orders.orderStatus.delivered': 'Delivered',
    'orders.orderStatus.finished': 'Finished',
    'orders.orderStatus.cancelled': 'Cancelled',
    'orders.orderStatus.dispute': 'Dispute',
    'orders.actions.status.label': 'Order Status',
    'orders.actions.status.change': 'Change Status',
    'orders.actions.status.changeSuccess': 'Status updated',
    'orders.actions.status.changeError': 'Failed to update status',
    'orders.actions.status.cannotCancelPaid': 'Cannot change status to cancelled when order is attached to a paid invoice.',
    'orders.bulk.status.change': 'Change Status',
    'orders.bulk.status.title': 'Change Status ({{count}})',
    'orders.bulk.status.selectPlaceholder': 'Select status',
    'orders.bulk.status.selectRequired': 'Select a status',
    'orders.bulk.status.changeSuccess': 'Updated status for {{count}} order(s)',
    'orders.bulk.status.partialSuccess': 'Updated {{success}} order(s); {{failed}} failed',
    'orders.bulk.status.noneEligible': 'None of the selected orders can have their status changed.',
    'orders.bulk.status.skipped': '{{count}} order(s) were skipped',
    'orders.bulk.attach.cta': 'Attach to Invoice',
    'orders.bulk.attach.title': 'Attach to Invoice ({{count}})',
    'orders.bulk.attach.success': 'Attached {{count}} order(s) to invoice',
    'orders.bulk.attach.sameClientRequired': 'Select orders from the same client to attach to one invoice.',
    'orders.bulk.attach.missingClient': 'Selected orders must belong to a client.',
    'orders.bulk.attach.noneEligible': 'None of the selected orders can be attached to an invoice.',
    'orders.bulk.attach.skipped': '{{count}} order(s) were skipped',
    'orders.bulk.attach.loadInvoicesError': 'Failed to load invoices',
    'orders.actions.createWorkOrder.title': 'Create Work Order',
    'orders.actions.createWorkOrder.assignedTo': 'Assign To',
    'orders.actions.createWorkOrder.notes': 'Notes',
    'orders.actions.createWorkOrder.cta': 'Create Work Order',
    'orders.actions.createWorkOrder.success': 'Work order created',
    'orders.actions.createWorkOrder.error': 'Failed to create work order',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'Order items (by formula type)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} units',
    'orders.actions.createWorkOrder.unitLabel': 'Unit {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'No formula items in this order.',
    'orders.paymentStatus.draft': 'Draft',

    'orders.paymentStatus.unpaid': 'Unpaid',
    'orders.paymentStatus.paid': 'Paid',
    'orders.paymentStatus.void': 'Void',
    'orders.button.add': 'Add Order',
    'orders.button.create': 'Create Order',
    'orders.empty.noOrdersYet': 'No orders yet',
    'orders.empty.noneMatchFilters': 'No orders match the current filters. Try changing payment status or other filters.',
    'orders.button.cancel': 'Cancel',
    'orders.confirm.cancelTitle': 'Cancel Order',
    'orders.confirm.cancelMessage': 'Are you sure you want to cancel this order? This will mark it as a draft and detach it from invoices.',
    'orders.confirm.cancelSuccess': 'Order cancelled',
    'orders.confirm.cancelError': 'Failed to cancel order',
    'orders.button.assignInvoice': 'Assign to Invoice',
    'orders.assign.title': 'Assign Order to Invoice',
    'orders.assign.selectExisting': 'Select an existing invoice for this order\'s client',
    'orders.assign.selectPlaceholder': 'Select an invoice',
    'orders.assign.selectInvoice': 'Please select an invoice to assign',
    'orders.assign.success': 'Order assigned to invoice',
    'orders.assign.attachExisting': 'Attach to existing invoice',
    'orders.assign.created': 'Invoice created and order attached',
    'orders.assign.error': 'Failed to assign order to invoice',
    'orders.assign.assign': 'Assign',
    'orders.assign.create': 'Create Invoice',

    'orders.button.viewEdit': 'View | Edit',
    'orders.button.view': 'View',
    'orders.confirm.deleteTitle': 'Delete Order',
    'orders.confirm.deleteMessage': 'Are you sure you want to delete this order?',
    'orders.update.collectPayment': 'Collect Payment',
    'orders.update.refundPayment': 'Refund Payment',
    'orders.update.markDelivered': 'Mark as Delivered',
    'orders.update.invoiceButton': 'Invoice',
    'invoice.addOrder.modalTitle': 'Attach Order to Invoice',
    'invoice.addOrder.chooseExisting': 'Attach to existing invoice',
    'invoice.addOrder.selectPlaceholder': 'Select invoice',
    'invoice.addOrder.attach': 'Attach to Invoice',
    'invoice.addOrder.createNew': 'Create New Invoice',
    'invoice.addOrder.attached': 'Order attached to invoice',
    'invoice.addOrder.attachedSuccess': 'Order attached successfully',
    'orders.alert.noAccess': 'You do not have access to view orders.',
    'orders.alert.noCreate': 'You do not have permission to create orders.',
    'orders.alert.dentistNoClient': 'Your account is not linked to a client. Please contact your lab administrator before creating orders.',
    'orders.alert.noView': 'You do not have access to view this order.',
    'orders.alert.editBlocked': 'Order details cannot be edited because this order is finished, delivered, or attached to an invoice. Technician, courier, and status can still be updated when allowed.',
    'responses.permission.denied': 'You do not have permission to perform this action.',
    'responses.common.password_reset_link_sent': 'If an account exists for that email, a password reset link has been sent.',
    'responses.common.password_reset_success': 'Your password has been reset. You can now log in.',
    'colors.form.name.label': 'Color Name',
    'colors.form.name.placeholder': 'Enter color name',
    'colors.form.name.required': 'Please enter the color name',
    'colors.form.name.max': 'Color name must be 255 characters or fewer',
    'colors.form.code.label': 'Color Code',
    'colors.form.code.required': 'Color is required.',
    'colors.search.placeholder': 'Search colors by name',
    'colors.quickCreate.title': 'Add Color',
    'colors.quickCreate.button': 'Add new color',
    'colors.quickCreate.errorFallback': 'Unable to create color. Please try again.',
    'dentists.quickCreate.title': 'Add Dentist',
    'dentists.quickCreate.button': 'Add new dentist',
    'dentists.quickCreate.errorFallback': 'Unable to create dentist. Please try again.',
    'dentists.quickCreate.missingType': 'Unable to detect dentist user type. Please refresh and try again.',
    'dentists.quickCreate.titleLabContact': 'Add Lab Contact',
    'dentists.quickCreate.buttonLabContact': 'Add new lab contact',
    'dentists.quickCreate.errorFallbackLabContact': 'Unable to create lab contact. Please try again.',
    'dentists.form.name.label': 'Dentist Name',
    'dentists.form.name.placeholder': 'Enter dentist name',
    'dentists.form.name.required': 'Please enter the dentist name',
    'dentists.form.name.labelLabContact': 'Lab Contact Name',
    'dentists.form.name.placeholderLabContact': 'Enter lab contact name',
    'dentists.form.name.requiredLabContact': 'Please enter the lab contact name',
    'dentists.form.email.label': 'Email',
    'dentists.form.email.placeholder': 'Enter email',
    'dentists.form.email.required': 'Please enter the email',
    'dentists.form.email.invalid': 'Please enter a valid email address',
    'dentists.form.username.label': 'Username',
    'dentists.form.username.placeholder': 'Enter username',
    'dentists.form.username.hint': 'Required if the dentist has no email',
    'dentists.form.password.label': 'Password',
    'dentists.form.password.placeholder': 'Enter password',
    'dentists.form.password.required': 'Please enter the password',
    'dentists.form.password.min': 'Password must be at least 6 characters',
    'dentists.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'dentists.form.phone.label': 'Phone Number',
    'dentists.form.phone.placeholder': 'Enter phone number',
    'dentists.form.whatsapp.label': 'WhatsApp Number',
    'dentists.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'dentists.form.address.label': 'Address',
    'dentists.form.address.placeholder': 'Enter address',

    // Transactions
    'transactions.table.type': 'Type',
    'transactions.table.reference': 'Reference',
    'transactions.table.amount': 'Amount',
    'transactions.table.notes': 'Notes',
    'transactions.table.createdAt': 'Created On',
    'transactions.types.invoice': 'Invoice',
    'transactions.types.expense': 'Expense',
    'transactions.types.wallet_recharge': 'Wallet Recharge',
    'transactions.types.wallet': 'Wallet',
    'transactions.types.wallet_deduction': 'Wallet Deduction',
    'transactions.types.invoice_refund': 'Invoice Refund',
    'transactions.alert.noAccess': 'You do not have access to view transactions.',

    // Formula Types
    'formulaTypes.table.name': 'Name',
    'formulaTypes.search.placeholder': 'Search by name',
    'formulaTypes.search.descriptionPlaceholder': 'Search description',
    'formulaTypes.filter.unit.placeholder': 'Filter by unit or arch',
    'formulaTypes.table.cost': 'Unit Cost',
    'formulaTypes.table.description': 'Description',
    'formulaTypes.table.actions': 'Actions',
    'formulaTypes.button.add': 'Add Formula Type',
    'formulaTypes.modal.title': 'Formula Types',
    'formulaTypes.confirm.deleteTitle': 'Delete Formula Type',
    'formulaTypes.alert.noAccess': 'You do not have access to view formula types.',
    'formulaTypes.confirm.deleteMessage': 'Are you sure you want to delete this formula_type?',
    'formulaTypes.form.name.label': 'Formula Type Name',
    'formulaTypes.form.name.placeholder': 'Enter formula_type name',
    'formulaTypes.form.name.required': 'Please enter the formula_type name',
    'formulaTypes.form.name.max': 'Name must be at most 255 characters',
    'formulaTypes.form.cost.label': 'Unit Cost',
    'formulaTypes.form.cost.placeholder': '0',
    'formulaTypes.form.cost.required': 'Please enter the unit cost',
    'formulaTypes.form.purchasePrice.label': 'Purchase price',
    'formulaTypes.form.purchasePrice.placeholder': '0',
    'formulaTypes.form.purchasePrice.required': 'Please enter the purchase price',
    'formulaTypes.form.sellingPrice.label': 'Selling price',
    'formulaTypes.form.sellingPrice.placeholder': '0',
    'formulaTypes.form.sellingPrice.required': 'Please enter the selling price',
    'formulaTypes.form.technicianCost.label': 'Technician cost',
    'formulaTypes.form.technicianCost.placeholder': '0',
    'formulaTypes.form.technicianCost.required': 'Please enter the technician cost',
    'formulaTypes.form.scope.label': 'Applies to',
    'formulaTypes.form.scope.placeholder': 'Unit or arch',
    'formulaTypes.form.scope.required': 'Please select unit or arch',
    'formulaTypes.scope.unit': 'Unit',
    'formulaTypes.scope.arch': 'Arch',
    'formulaTypes.table.purchasePrice': 'Purchase price',
    'formulaTypes.table.sellingPrice': 'Selling price',
    'formulaTypes.table.technicianCost': 'Technician cost',
    'formulaTypes.table.scope': 'Unit / arch',
    'formulaTypes.table.material': 'Material',
    'formulaTypes.form.description.label': 'Formula Type Description',
    'formulaTypes.form.description.placeholder': 'Enter formula_type description',
    'formulaTypes.form.material.label': 'Material',
    'formulaTypes.form.material.placeholder': 'Type materials as text (comma-separated), e.g. Zirconia, PMMA',
    'formulaTypes.form.attachments.label': 'Attachments',
    'formulaTypes.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'formulaTypes.form.attachments.choose': 'Choose files',
    'formulaTypes.form.attachments.existing': 'Existing attachments:',
    'formulaTypes.form.attachments.deleteConfirm': 'Remove attachment?',
    'formulaTypes.attachment.deleted': 'Attachment removed',
    'formulaTypes.attachment.deleteError': 'Failed to remove attachment',
    'formulaTypes.quickCreate.title': 'Add Formula Type',
    'formulaTypes.quickCreate.button': 'Add new formula type',
    'deliveryCenters.quickCreate.title': 'Add Delivery Center',
    'deliveryCenters.quickCreate.button': 'Add new delivery center',
    'deliveryCenters.quickCreate.errorFallback': 'Unable to create delivery center. Please try again.',
    'deliveryCenters.form.name.label': 'Delivery Center Name',
    'deliveryCenters.form.name.placeholder': 'Enter delivery center name',
    'deliveryCenters.form.name.required': 'Please enter the delivery center name',
    'deliveryCenters.form.address.label': 'Address',
    'deliveryCenters.form.address.placeholder': 'Enter address',
    'deliveryCenters.form.phone.label': 'Phone Number',
    'deliveryCenters.form.phone.placeholder': 'Enter phone number',
    'deliveryCenters.form.whatsapp.label': 'WhatsApp Number',
    'deliveryCenters.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'deliveryCenters.form.email.label': 'Email',
    'deliveryCenters.form.email.placeholder': 'Enter email',
    'deliveryCenters.form.email.invalid': 'Please enter a valid email address',
    'deliveryCenters.form.notes.label': 'Notes',
    'deliveryCenters.form.notes.placeholder': 'Add notes (optional)',

    // Lab Profile
    'lab.title': 'Lab Information',
    'lab.subtitle': 'View and update your laboratory profile, contact details, and branding',
    'lab.delivery.subtitle': 'Configure delivery types, amounts, and the default option for orders',
    'lab.payment.subtitle': 'Manage bank accounts and money transfer channels for client payments',
    'vacations.subtitle': 'Manage weekend days and lab closure periods shown on the calendar',
    'branchs.subtitle': 'Manage laboratory branches, addresses, and contact details',
    'assets.subtitle': 'Track laboratory assets, purchase costs, and notes',
    'expenses.subtitle': 'Record and track laboratory expenses by type, date, and amount',
    'expenseTypes.subtitle': 'Define expense categories used when recording lab expenses',
    'colors.subtitle': 'Manage shade catalog colors used across formulas and orders',
    'formulaTypes.subtitle': 'Configure formula types, pricing, units, and attachments',
    'activities.subtitle': 'Audit trail of user operations across the platform',
    'transactions.subtitle': 'Review invoice, expense, and wallet money movements',
    'lab.table.field': 'Field',
    'lab.table.value': 'Value',
    'lab.table.actions': 'Actions',
    'lab.table.branches': 'Branches',
    'lab.delivery.title': 'Delivery',
    'lab.delivery.col.name': 'Name',
    'lab.delivery.col.amount': 'Amount',
    'lab.delivery.default': 'Default',
    'lab.delivery.setDefault': 'Set as default',
    'lab.delivery.setDefaultSuccess': 'Set as default.',
    'lab.delivery.editValue': 'Change value',
    'lab.delivery.editStandardTitle': 'Change Standard Delivery value',
    'lab.delivery.amountForCurrency': 'Amount ({currency})',
    'lab.delivery.updateSuccess': 'Updated.',
    'lab.field.name': 'Lab Name',
    'lab.field.logo': 'Logo',
    'lab.field.phone': 'Lab Phone',
    'lab.field.contactPhone': 'Contact Phone',
    'lab.field.vatPercentage': 'VAT %',
    'lab.field.delivery': 'Delivery',
    'lab.field.currency': 'Currency',
    'lab.field.showPriceDiscounts': 'Show discounts',
    'lab.field.showPriceDiscounts.show': 'Shown',
    'lab.field.showPriceDiscounts.hide': 'Hidden',
    'lab.field.whatsapp': 'Lab WhatsApp',
    'orders.orderStatus.on-hold': 'On Hold',
    'lab.button.edit': 'Edit',
    'lab.modal.title': 'Edit Lab Information',
    'lab.form.name.label': 'Lab Name',
    'lab.form.name.placeholder': 'Enter lab name',
    'lab.form.name.required': 'Please enter the lab name',
    'lab.form.phone.label': 'Phone Number',
    'lab.form.phone.placeholder': 'Enter phone number',
    'lab.form.contactPhone.label': 'Contact Phone',
    'lab.form.contactPhone.placeholder': 'Enter contact phone',
    'lab.form.vatPercentage.label': 'VAT Percentage',
    'lab.form.vatPercentage.placeholder': '0',
    'lab.form.delivery.label': 'Delivery',
    'lab.form.delivery.placeholder': '0',
    'lab.form.showPriceDiscounts.label': 'Show discounts on orders & invoices',
    'lab.form.showPriceDiscounts.help': 'When off, discount labels and amounts are hidden on orders, invoices, PDFs, and public invoices. Charged totals still use the client’s prices.',
    'lab.form.showPriceDiscounts.show': 'Show',
    'lab.form.showPriceDiscounts.hide': 'Hide',
    'lab.form.currency.label': 'Currency',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.readOnly': 'Currency cannot be changed after setup.',
    'lab.form.whatsapp.label': 'WhatsApp Number',
    'lab.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'lab.form.notes.label': 'Lab Description',
    'lab.form.notes.placeholder': 'Enter lab description',
    'lab.form.logo.label': 'Logo (navbar)',
    'lab.form.logo.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'lab.form.logo.uploadButton': 'Choose logo file',
    'lab.form.removeLogo': 'Remove current logo',
    'lab.saveSuccess': 'Settings saved',
    'lab.saveError': 'Could not save settings',
    'lab.button.save': 'Save',

    // Home
    'home.currency.egp': 'EGP',
    'home.welcome': 'Welcome {{labName}},',
    'home.lab_workspace_badge': 'Lab Workspace',
    'home.dentist_portal_badge': 'Dentist Portal',
    'home.dentist_welcome': 'Welcome, Dr. {{name}}',
    'home.summary': 'Summary of lab activity and performance.',
    'home.dentist_summary': 'Overview of your clinic cases, deliveries, and invoices.',
    'home.lab_contact_portal_badge': 'Lab Contact Portal',
    'home.lab_contact_welcome': 'Welcome, {{name}}',
    'home.lab_contact_summary': 'Overview of your lab cases, deliveries, and invoices.',
    'home.my_orders': 'Clinic Orders',
    'home.my_orders_count': 'Clinic Orders',
    'home.lab_orders': 'Lab Orders',
    'home.lab_orders_count': 'Lab Orders',
    'home.delivered_orders': 'Delivered',
    'home.pending_orders': 'Pending',
    'home.in_progress_orders': 'In Progress',
    'home.upcoming_deliveries': 'Upcoming Deliveries',
    'home.patients': 'Patients',
    'home.filter_by_clients': 'Filter by clients',
    'home.cases_this_month': 'Cases This Month',
    'home.clinic_invoices': 'Clinic Invoices',
    'home.lab_invoices': 'Lab Invoices',
    'home.patient': 'Patient',
    'home.delivery_date': 'Delivery Date',
    'home.invoices_amount': 'Invoices Amount',
    'home.paid_invoices': 'Paid Invoices',
    'home.orders': 'Orders',
    'home.dentists': 'Dentists',
    'home.invoices': 'Invoices',
    'home.unpaid_amount': 'Unpaid Amount',
    'home.statistics': 'Statistics',
    'home.recent_clinics': 'Top Clinics',
    'home.activity_overview': 'Activity Overview',
    'home.activity_subtitle': 'Overview of orders, invoices and revenue',
    'home.view_reports': 'View Reports',
    'home.dental_clinic': 'Dental Clinic',
    'home.active_invoices': 'Active Invoices',
    'home.active_expenses': 'Active Expenses',
    'home.invoices_label': 'Invoices',
    'home.expenses_label': 'Expenses',
    'home.amount': 'Amount',
    'home.count': 'Count',
    'home.revenue': 'Revenue',
    'home.paid_invoices_amount': 'Paid Invoices Amount',
    'home.unpaid_invoices_amount': 'Unpaid Invoices Amount',
    'home.expenses_amount': 'Expenses Amount',
    'home.paid_invoices_count': 'Paid Invoices Count',
    'home.unpaid_invoices_count': 'Unpaid Invoices Count',
    'home.invoices_count': 'Invoices Count',
    'home.clients_count': 'Clients Count',
    'home.orders_count': 'Orders Count',
    'home.units_count': 'Units Count',
    'home.orders_trend': 'Orders Trend',
    'home.revenue_by_month': 'Revenue (6 months)',
    'home.invoices_breakdown': 'Invoices Breakdown',
    'home.active_clients': 'Active Clients',
    'home.active_orders': 'Active Orders',
    'home.active_dentists': 'Active Dentists',
    'home.clients_label': 'Clients',
    'home.orders_label': 'Orders',
    'home.full_period': 'Full period',

    // New home keys
    'home.new_orders': 'New Orders',
    'home.latest_orders': 'Latest Orders',
    'home.latest_invoices': 'Latest Invoices',
    'home.view_all_invoices': 'View All Invoices',
    'home.orders_tracker': 'Orders Tracker',
    'home.invoices_tracker': 'Invoices Tracker',
    'home.formula_types_tracker': 'Formula Types Tracker',
    'home.formula_type': 'Formula Type',
    'home.units_amount': 'Units Amount',
    'home.total_units_amount': 'Total Units Amount',
    'home.this_week': 'This week',
    'home.this_month': 'This month',
    'home.last_month': 'Last month',
    'home.last_3_months': 'Last 3 months',
    'home.last_6_months': 'Last 6 months',
    'home.last_year': 'Last year',
    'home.custom_range': 'Custom range',
    'home.revenue_tracker': 'Revenue Tracker',
    'home.total_invoices': 'Total Invoices',
    'home.total_invoices_amount': 'Total Invoices Amount',
    'home.total_expenses': 'Total Expenses',
    'home.net': 'Net',
    'home.invoices_vs_expenses': 'Invoices vs Expenses',
    'home.order': 'Order',
    'home.client': 'Client',
    'home.status': 'Status',
    'home.date': 'Date',
    'home.total': 'Total',
    'home.total_orders': 'Total Orders',
    'home.requested': 'Requested',
    'home.in_progress': 'In Progress',
    'home.finished': 'Finished',
    'home.completed_percentage': 'Completed',
    'home.completed_orders': 'Completed Orders',
    'home.view_all_orders': 'View All Orders',

    // Profile
    'profile.title': 'Profile',
    'profile.error.title': 'Unable to load profile',
    'profile.avatar.upload': 'Upload photo',
    'profile.avatar.remove': 'Remove photo',
    'profile.avatar.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'profile.avatar.tooLarge': 'The uploaded image is too large. Please use an image up to 4 MB.',
    'profile.field.avatar': 'Photo',
    'profile.field.name': 'Name',
    'profile.field.username': 'Username',
    'profile.field.email': 'Email',
    'profile.field.userType': 'User Type',
    'profile.field.vendorName': 'Vendor Name',
    'profile.field.assignedClient': 'Assigned Client',
    'profile.section.assignedClient': 'Assigned Client',
    'profile.menu.profile': 'Profile',
    'profile.menu.settings': 'Settings',
    'profile.field.password': 'Password',
    'profile.field.passwordConfirm': 'Confirm Password',
    'profile.field.phone': 'Phone',
    'profile.field.whatsapp': 'WhatsApp',
    'profile.passwordSet': '••••••••',
    'profile.passwordPending': 'Pending invitation',
    'profile.field.currentPassword': 'Current Password',
    'profile.changePassword': 'Change Password',
    'profile.menu.logout': 'Log out',

    'notifications.title': 'Notifications',
    'notifications.empty': 'No notifications yet',
    'notifications.markAllRead': 'Mark all as read',
    'notifications.close': 'Close',
    'notifications.unread': 'Unread',
    'notifications.showMore': 'Show more',
    'notifications.page.subtitle': 'View and manage all of your notifications',
    'notifications.countLabel': 'total',

    // Users
    'users.page.title': 'Users',
    'users.header.title': 'Users',
    'users.header.subtitle': 'Manage lab staff accounts, invitations, permissions, and access',
    'users.filter.title': 'Filter Users',
    'users.filter.active': 'Active',
    'users.filter.clear': 'Reset Filters',
    'users.button.addUser': 'Add User',
    'users.modal.title': 'Users',
    'users.table.name': 'Name',
    'users.table.username': 'Username',
    'users.table.email': 'Email',
    'users.table.userType': 'User Type',
    'users.table.status': 'Status',
    'users.table.contact': 'Contact',
    'users.table.phone': 'Phone Number',
    'users.table.whatsapp': 'WhatsApp Number',
    'users.table.address': 'Address',
    'users.table.actions': 'Actions',
    'users.status.verified': 'Verified',
    'users.status.pending': 'Pending',
    'users.status.activated': 'User activated',
    'users.status.deactivated': 'User deactivated',
    'users.status.toggleFailed': 'Unable to update user status',
    'users.status.manualVerified': 'User verified',
    'users.status.manualUnverified': 'User marked as unverified',
    'users.status.verifyToggleFailed': 'Unable to update verification status',
    'users.actions.activate': 'Activate',
    'users.actions.deactivate': 'Deactivate',
    'users.actions.verify': 'Verify',
    'users.actions.unverify': 'Unverify',
    'users.table.accountStatus': 'Activation',
    'users.table.invitationStatus': 'Verification',
    'users.details.profileSection': 'Profile details',
    'users.details.invitationSection': 'Invitation',
    'users.details.clientNotAssigned': 'Not assigned',
    'users.details.assignedOrdersSection': 'Assigned orders',
    'users.details.noAssignedOrders': 'No assigned orders',
    'users.confirm.activateTitle': 'Activate User',
    'users.confirm.activateMessage': 'This user will be able to sign in again.',
    'users.confirm.deactivateTitle': 'Deactivate User',
    'users.confirm.deactivateMessage': 'This user will be signed out and blocked from signing in until reactivated.',
    'users.confirm.verifyTitle': 'Verify User',
    'users.confirm.verifyMessage': 'Mark this user as verified without completing the invitation flow.',
    'users.confirm.unverifyTitle': 'Unverify User',
    'users.confirm.unverifyMessage': 'Mark this user as pending verification again.',
    'users.confirm.deleteTitle': 'Delete User',
    'users.confirm.deleteMessage': 'Are you sure you want to delete this user?',

    // Invitation
    'users.invitation.copyLink': 'Copy Invitation Link',
    'users.invitation.linkCopied': 'Invitation link copied to clipboard',
    'users.invitation.copyFailed': 'Failed to copy invitation link',
    'users.invitation.sendEmail': 'Send Invitation Email',
    'users.invitation.emailSent': 'Invitation email sent',
    'users.invitation.sendFailed': 'Failed to send invitation email',
    'users.invitation.regenerate': 'Regenerate Invitation Link',
    'users.invitation.regenerated': 'Invitation link regenerated',
    'users.invitation.regeneratedAndCopied': 'Invitation link regenerated and copied',
    'users.invitation.regenerateFailed': 'Failed to regenerate invitation link',
    'users.invitation.title': 'Invitation',
    'users.invitation.invalidToken': 'Invalid or expired form token',
    'users.invitation.completed': 'Account verified successfully! You can now log in.',
    'users.invitation.completeFailed': 'Failed to complete invitation',
    'users.invitation.error': 'Error',
    'users.invitation.backToLogin': 'Back to Login',
    'users.invitation.setPassword': 'Set Your Password',
    'users.invitation.welcome': 'Welcome!',
    'users.invitation.welcomeMessage': 'Please set a password for {{name}} ({{email}})',
    'users.invitation.complete': 'Complete Setup',
    'users.modal.createTitle': 'Add User',
    'users.modal.editTitle': 'Edit User',
    'users.changeHistory': 'Change history',
    'users.versions.title': 'User change history',
    'users.versions.empty': 'No change history yet',
    'users.versions.by': 'Updated by',
    'users.versions.noFields': 'No changed fields captured',
    'users.versions.timelineTitle': 'Timeline',
    'users.versions.compareTitle': 'Compare with current',
    'users.versions.selectVersion': 'Select a version',
    'users.versions.fieldsChanged': 'Fields changed',
    'users.versions.field': 'Field',
    'users.versions.versionValue': 'Version value',
    'users.versions.currentValue': 'Current value',
    'users.versions.current': 'Current',
    'users.versions.before': 'Before',
    'users.versions.after': 'After (Current)',
    'users.versions.status': 'Status',
    'users.versions.changed': 'Changed',
    'users.versions.same': 'Same',
    'users.form.name.label': 'Name',
    'users.form.name.placeholder': 'Enter name',
    'users.form.name.required': 'Please enter the name',
    'users.form.email.label': 'Email',
    'users.form.email.placeholder': 'Enter email',
    'users.form.email.required': 'Please enter the email',
    'users.form.email.invalid': 'Please enter a valid email',
    'users.form.username.label': 'Username',
    'users.form.username.placeholder': 'Enter username',
    'users.form.username.hint': 'Required if the user has no email',
    'users.form.password.label': 'Password',
    'users.form.password.placeholder': 'Enter password',
    'users.form.password.required': 'Please enter the password',
    'users.form.password.invitationHint': 'Leave empty to send invitation link instead',
    'users.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'users.form.password.minLength': 'Password must be at least 8 characters',
    'users.form.password.confirm': 'Confirm Password',
    'users.form.password.confirmRequired': 'Please confirm your password',
    'users.form.password.mismatch': 'Passwords do not match',
    'users.form.password.confirmPlaceholder': 'Confirm your password',
    'users.form.phone.label': 'Phone Number',
    'users.form.phone.placeholder': 'Enter phone number',
    'users.form.whatsapp.label': 'WhatsApp Number',
    'users.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'users.form.address.label': 'Address',
    'users.form.address.placeholder': 'Enter address',
    'users.form.userType.label': 'User Type',
    'users.form.userType.placeholder': 'Select a user type',
    'users.form.userType.required': 'Please select a user type',
    'users.resetPassword.button': 'Reset password',
    'users.resetPassword.confirmTitle': 'Reset to temporary password?',
    'users.resetPassword.confirmMessage': 'This sets the password to temp123. Share it with the user so they can log in and change it.',
    'users.resetPassword.successTitle': 'Temporary password ready',
    'users.resetPassword.successHint': 'Give this password to the user. They should log in and change it from their profile.',
    'users.resetPassword.failed': 'Unable to reset the password',
    'users.form.client.label': 'Client',
    'users.form.client.required': 'Please select a client for dentist users',
    'users.form.permissions.label': 'Permissions',
    'users.form.permissions.placeholder': 'Select permissions',
    'users.form.permissions.selectAll': 'Select all',
    'users.permissions.groups.asset': 'Assets',
    'users.permissions.groups.branch': 'Branches',
    'users.permissions.groups.delivery_center': 'Delivery Centers',
    'users.permissions.groups.color': 'Colors',
    'users.permissions.groups.dentist': 'Dentists',
    'users.permissions.groups.expense': 'Expenses',
    'users.permissions.groups.expense_type': 'Expense Types',
    'users.permissions.groups.invoice': 'Invoices',
    'users.permissions.groups.formula_type': 'Formula Types',
    'users.permissions.groups.order': 'Orders',
    'users.permissions.groups.order_phase': 'Order Phases',
    'users.permissions.groups.client': 'Clients',
    'users.permissions.groups.transaction': 'Transactions',
    'users.permissions.groups.unit': 'Units',
    'users.permissions.groups.unit_type': 'Unit Types',
    'users.permissions.groups.user': 'Users',
    'users.permissions.groups.dashboard': 'Dashboard',
    'users.permissions.groups.vendor': 'Vendors',
    'users.permissions.groups.vendor_bank_accounts': 'Bank Accounts',
    'users.permissions.groups.vendor_money_transfer_channels': 'Money Transfer Channels',
    'users.permissions.groups.setting': 'Settings',
    'users.permissions.groups.client_settings': 'Dentist Settings',
    'users.permissions.groups.client_transactions': 'Dentist Transactions',

    'users.permissions.items.view_dashboard_kpi_orders': 'View Orders KPI',
    'users.permissions.items.view_dashboard_kpi_invoices': 'View Invoices KPI',
    'users.permissions.items.view_dashboard_kpi_clients': 'View Clients KPI',
    'users.permissions.items.view_dashboard_kpi_units': 'View Units KPI',
    'users.permissions.items.view_dashboard_kpi_expenses': 'View Expenses KPI',
    'users.permissions.items.view_dashboard_revenue_tracker': 'View Revenue Tracker',
    'users.permissions.items.view_dashboard_latest_orders': 'View Latest Orders',
    'users.permissions.items.view_dashboard_orders_tracker': 'View Orders Tracker',
    'users.permissions.items.view_dashboard_latest_invoices': 'View Latest Invoices',
    'users.permissions.items.view_dashboard_invoices_tracker': 'View Invoices Tracker',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'View Formula Types Tracker',
    'users.permissions.items.view_dashboard_active_clients': 'View Active Clients',
    'users.permissions.items.view_dashboard_active_orders': 'View Active Orders',
    'users.permissions.items.view_dashboard_active_invoices': 'View Active Invoices',
    'users.permissions.items.view_dashboard_active_expenses': 'View Active Expenses',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'Download Invoice (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'Send Invoice via WhatsApp',
    'users.permissions.items.send_invoice_email': 'Send Invoice via Email',
    'users.permissions.items.detach_order_from_invoice': 'Detach Order from Invoice',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'View Vendors',
    'users.permissions.items.add_vendor': 'Add Vendors',
    'users.permissions.items.edit_vendor': 'Edit Vendors',
    'users.permissions.items.delete_vendor': 'Delete Vendors',

    'users.permissions.items.view_vendor_bank_accounts': 'View Bank Accounts',
    'users.permissions.items.add_vendor_bank_accounts': 'Add Bank Accounts',
    'users.permissions.items.edit_vendor_bank_accounts': 'Edit Bank Accounts',
    'users.permissions.items.delete_vendor_bank_accounts': 'Delete Bank Accounts',

    'users.permissions.items.view_vendor_money_transfer_channels': 'View Money Transfer Channels',
    'users.permissions.items.add_vendor_money_transfer_channels': 'Add Money Transfer Channels',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'Edit Money Transfer Channels',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'Delete Money Transfer Channels',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'View Settings',
    'users.permissions.items.edit_settings': 'Edit Settings',

    // Dentist portal settings
    'users.permissions.items.view_client_settings_client_info': 'View client info (Settings)',
    'users.permissions.items.view_client_settings_wallet_balance': 'View wallet balance (Settings)',
    'users.permissions.items.view_client_settings_wallet_history': 'View wallet history (Settings)',
    'users.permissions.items.view_client_settings_transactions': 'View transactions (Settings)',
    'users.permissions.items.view_client_transactions': 'View client transactions',

    'clientTransactions.title': 'Transactions',
    'clientTransactions.alert.noAccess': 'You do not have access to transactions.',
    'users.permissions.items.view_client_settings_wallet': 'View client wallet (Settings)',

    'clientSettings.title': 'Settings',
    'clientSettings.alert.noAccess': 'You do not have access to settings.',
    'clientSettings.alert.noClientAssigned': 'No client is assigned to your account. Contact your lab administrator.',
    'clientSettings.clientInfo.title': 'Client info',
    'clientSettings.clientInfo.clientName': 'Client Name',
    'clientSettings.clientInfo.clientType': 'Client Type',
    'clientSettings.clientInfo.phone': 'Phone Number',
    'clientSettings.clientInfo.whatsapp': 'WhatsApp Number',
    'clientSettings.clientInfo.email': 'Email',
    'clientSettings.clientInfo.assignedDentists': 'Assigned Dentists',
    'clientSettings.clientInfo.assignedLabContacts': 'Assigned Lab Contacts',
    'clientSettings.clientInfo.deliveryCenters': 'Delivery Centers',
    'clientSettings.accounts.title': 'Accounts',
    'clientSettings.accounts.titleDentists': 'Client accounts',
    'clientSettings.accounts.titleLabContacts': 'Lab contact accounts',
    'clientSettings.accounts.description': 'Other accounts linked to this client. Only the main account can view this list.',
    'clientSettings.accounts.you': 'You',
    'clientSettings.accounts.status': 'Status',
    'clientSettings.accounts.statusActive': 'Active',
    'clientSettings.accounts.statusInactive': 'Inactive',
    'clientSettings.wallet.title': 'Wallet',
    'clientSettings.transactions.title': 'Transactions',

    'users.permissions.items.view_asset': 'View Assets',
    'users.permissions.items.add_asset': 'Add Assets',
    'users.permissions.items.edit_asset': 'Edit Assets',
    'users.permissions.items.delete_asset': 'Delete Assets',
    'users.permissions.items.view_branch': 'View Branches',
    'users.permissions.items.add_branch': 'Add Branches',
    'users.permissions.items.edit_branch': 'Edit Branches',
    'users.permissions.items.delete_branch': 'Delete Branches',
    'users.permissions.items.view_delivery_center': 'View Delivery Centers',
    'users.permissions.items.add_delivery_center': 'Add Delivery Centers',
    'users.permissions.items.edit_delivery_center': 'Edit Delivery Centers',
    'users.permissions.items.delete_delivery_center': 'Delete Delivery Centers',
    'users.permissions.items.view_color': 'View Colors',
    'users.permissions.items.add_color': 'Add Colors',
    'users.permissions.items.edit_color': 'Edit Colors',
    'users.permissions.items.delete_color': 'Delete Colors',
    'users.permissions.items.view_dentist': 'View Dentists',
    'users.permissions.items.add_dentist': 'Add Dentists',
    'users.permissions.items.edit_dentist': 'Edit Dentists',
    'users.permissions.items.delete_dentist': 'Delete Dentists',
    'users.permissions.items.view_expense': 'View Expenses',
    'users.permissions.items.add_expense': 'Add Expenses',
    'users.permissions.items.edit_expense': 'Edit Expenses',
    'users.permissions.items.delete_expense': 'Delete Expenses',
    'users.permissions.items.view_expense_type': 'View Expense Types',
    'users.permissions.items.add_expense_type': 'Add Expense Types',
    'users.permissions.items.edit_expense_type': 'Edit Expense Types',
    'users.permissions.items.delete_expense_type': 'Delete Expense Types',
    'users.permissions.items.view_invoice': 'View Invoices',
    'users.permissions.items.add_invoice': 'Add Invoices',
    'users.permissions.items.edit_invoice': 'Edit Invoices',
    'users.permissions.items.delete_invoice': 'Delete Invoices',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'Create Invoice From Order',
    'users.permissions.items.attach_order_to_invoice': 'Attach Order To Existing Invoice',
    'users.permissions.items.create_work_order': 'Work Order',
    'users.permissions.items.view_assigned_orders': 'View Assigned Orders',
    'users.permissions.items.view_order_public_page': 'View Order Public Page',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'Create Invoice',
    'orders.actions.createInvoice.description': 'Create an invoice using the current order.',
    'orders.actions.createInvoice.cta': 'Create Invoice',
    'orders.actions.createInvoice.success': 'Invoice created successfully',
    'orders.actions.createInvoice.error': 'Failed to create invoice',

    'orders.actions.attach.title': 'Attach to Existing Invoice',
    'orders.actions.attach.selectPlaceholder': 'Select an invoice',
    'orders.actions.attach.cta': 'Attach',
    'orders.actions.attach.success': 'Order attached to invoice',
    'orders.actions.attach.error': 'Failed to attach to invoice',

    'orders.actions.workOrder.title': 'Work Order',
    'orders.actions.workOrder.assignedTo': 'Assign To',
    'orders.actions.workOrder.notes': 'Notes',
    'orders.actions.workOrder.cta': 'Work Order',
    'orders.actions.workOrder.success': 'Work order created',
    'orders.actions.workOrder.error': 'Failed to create work order',
    'users.permissions.items.view_formula_type': 'View Formula Types',
    'users.permissions.items.add_formula_type': 'Add Formula Types',
    'users.permissions.items.edit_formula_type': 'Edit Formula Types',
    'users.permissions.items.delete_formula_type': 'Delete Formula Types',
    'users.permissions.items.view_all_formula_types': 'View All Formula Types',
    'users.permissions.items.view_client': 'View Clients',
    'users.permissions.items.add_client': 'Add Clients',
    'users.permissions.items.edit_client': 'Edit Clients',
    'users.permissions.items.delete_client': 'Delete Clients',
    'users.permissions.items.view_order': 'View Orders',
    'users.permissions.items.add_order': 'Add Orders',
    'users.permissions.items.edit_order': 'Edit Orders',
    'users.permissions.items.delete_order': 'Delete Orders',
    'users.permissions.items.view_order_phase': 'View Order Phases',
    'users.permissions.items.add_order_phase': 'Add Order Phases',
    'users.permissions.items.edit_order_phase': 'Edit Order Phases',
    'users.permissions.items.delete_order_phase': 'Delete Order Phases',
    'users.permissions.items.view_transaction': 'View Transactions',
    'users.permissions.items.add_transaction': 'Add Transactions',
    'users.permissions.items.edit_transaction': 'Edit Transactions',
    'users.permissions.items.delete_transaction': 'Delete Transactions',
    'users.permissions.items.view_unit': 'View Units',
    'users.permissions.items.add_unit': 'Add Units',
    'users.permissions.items.edit_unit': 'Edit Units',
    'users.permissions.items.delete_unit': 'Delete Units',
    'users.permissions.items.view_unit_type': 'View Unit Types',
    'users.permissions.items.add_unit_type': 'Add Unit Types',
    'users.permissions.items.edit_unit_type': 'Edit Unit Types',
    'users.permissions.items.delete_unit_type': 'Delete Unit Types',
    'users.permissions.items.view_user': 'View Users',
    'users.permissions.items.add_user': 'Add Users',
    'users.permissions.items.edit_user': 'Edit Users',
    'users.permissions.items.delete_user': 'Delete Users',
    'users.permissions.groups.delivery_type': 'Delivery Types',
    'users.permissions.groups.activity_logs': 'Activity Logs',
    'users.permissions.groups.change_history': 'Change History',
    'users.permissions.actions.view': 'View',
    'users.permissions.actions.add': 'Add',
    'users.permissions.actions.edit': 'Edit',
    'users.permissions.actions.delete': 'Delete',
    'users.permissions.actions.change': 'Change',
    'users.permissions.actions.create': 'Create',
    'users.permissions.actions.view_all': 'View All',
    'users.permissions.items.view_delivery_type': 'View Delivery Types',
    'users.permissions.items.add_delivery_type': 'Add Delivery Types',
    'users.permissions.items.edit_delivery_type': 'Edit Delivery Types',
    'users.permissions.items.delete_delivery_type': 'Delete Delivery Types',
    'users.permissions.items.view_assigned_technician': 'View Assigned Technician',
    'users.permissions.items.change_assigned_technician': 'Change Assigned Technician',
    'users.permissions.items.view_assigned_courier': 'View Assigned Courier',
    'users.permissions.items.change_assigned_courier': 'Change Assigned Courier',
    'users.permissions.items.view_order_status': 'View Order Status',
    'users.permissions.items.change_order_status': 'Change Order Status',
    'users.permissions.items.view_activity_logs': 'View Activity Logs',
    'users.permissions.items.view_change_history': 'View Change History',
    'users.permissions.items.view_all_colors': 'View All Colors',
    'users.form.submit.add': 'Add',
    'users.form.submit.edit': 'Update',
    'users.alert.noAccess': 'You do not have access to view users.',

    // Invoice page
    'invoice.title': 'Invoice',
    'invoice.detailsTitle': 'Invoice Details',
    'invoice.placeholder': 'Invoice view placeholder — awaiting layout specification.',
    'invoice.alert.noView': 'You do not have access to view this invoice.',
    'invoice.button.print': 'Print',
    'invoice.button.addOrder': 'Add Order',
    'invoice.field.dentistName': "Dentist's Name",
    'invoice.field.date': 'Invoice Date',
    'invoice.field.client': 'Client',
    'invoice.field.status': 'Status',
    'invoice.field.units': 'Units Count',
    'invoice.field.orders': 'Orders',
    'invoice.field.unitCost': 'Unit Cost',
    'invoice.field.issueDate': 'Issue Date',
    'invoice.field.dueDate': 'Due Date',
    'invoice.field.paidAt': 'Paid At',
    'invoice.field.paymentMethod': 'Payment Method',
    'invoice.field.paymentStatus': 'Payment Status',
    'invoice.field.transferReference': 'Transfer reference',
    'invoice.field.moneyTransferChannel': 'Money Transfer Channel',
    'invoice.field.deliveredAt': 'Delivered At',
    'invoice.orders.viewFormulas': 'View Formulas',
    'invoice.orders.hideFormulas': 'Hide Formulas',
    'invoice.orders.expandAll': 'Expand All Formulas',
    'invoice.orders.collapseAll': 'Collapse All Formulas',
    'invoice.orders.formulasCount': '{{count}} Formulas',
    'invoice.orders.unitsCount': '{{count}} Units',
    'invoice.orders.formulaList': 'Formulas & Shades',
    'invoice.orders.financialSummary': 'Financial Details',
    'invoice.orders.teeth': 'Teeth',
    'invoice.button.detach': 'Detach from invoice',
    'invoice.detach.confirmMessage': 'Are you sure you want to detach this order from the invoice?',
    'invoice.detach.success': 'Order detached successfully',


    'invoice.detach.error': 'Failed to detach order',
    'invoice.cancel.confirmMessage': 'Detaching the last order will convert this invoice to a draft. Continue?',
    'invoice.cancel.success': 'Invoice converted to draft',
    'invoice.cancel.error': 'Failed to cancel invoice',
    'invoice.alert.draft': 'This invoice is a draft',
    'invoice.alert.paidReadOnly': 'This invoice is paid. Editing is disabled; use Undo Payment below if it was marked paid by mistake, or Refund to credit the client wallet.',
    'invoice.button.cancel': 'Cancel Invoice',
    'invoice.button.downloadPdf': 'Download PDF',
    'invoice.button.downloadSummaryPdf': 'Download Summary Invoice PDF',
    'invoice.button.sendWhatsapp': 'Send WhatsApp',
    'invoice.button.sendEmail': 'Send Email',
    'invoice.changeHistory': 'Change history',
    'invoice.versions.title': 'Invoice change history',
    'invoice.versions.empty': 'No change history yet',
    'invoice.versions.timelineTitle': 'Timeline',
    'invoice.versions.by': 'Updated by',
    'invoice.versions.fieldsChanged': 'Fields changed',
    'invoice.versions.compareTitle': 'Compare with current',
    'invoice.versions.selectVersion': 'Select a version',
    'invoice.versions.noFields': 'No changed fields captured',
    'invoice.versions.currentVersion': 'Current version',
    'invoice.versions.before': 'Before',
    'invoice.versions.after': 'After (Current)',
    'invoice.field.phone': 'Phone',
    'invoice.field.message': 'Message',
    'invoice.button.markPaid': 'Mark as Paid',
    'invoice.markPaid.title': 'Record Payment',
    'invoice.markPaid.paymentMethod': 'Payment Method',
    'invoice.markPaid.channel': 'Money Transfer Channel',
    'invoice.markPaid.channelOther': 'Other Channel',
    'invoice.markPaid.notes': 'Notes',
    'invoice.markPaid.attachment': 'Attachment (image)',
    'invoice.markPaid.success': 'Invoice marked as paid',
    'invoice.markPaid.error': 'Failed to mark invoice as paid',
    'invoice.button.refund': 'Refund',
    'invoice.refund.confirmTitle': 'Refund invoice?',
    'invoice.refund.confirmMessage': 'The paid amount will be credited to the client wallet and the invoice will be marked as unpaid.',
    'invoice.refund.success': 'Invoice refunded successfully',
    'invoice.refund.error': 'Failed to refund invoice',
    'invoice.button.undoMarkPaid': 'Undo Payment',
    'invoice.undoMarkPaid.confirmTitle': 'Undo payment?',
    'invoice.undoMarkPaid.confirmMessage': 'This will reverse the mark-as-paid action as if it never happened. Related payment transactions will be soft-deleted and the invoice will return to unpaid.',
    'invoice.undoMarkPaid.success': 'Invoice payment undone',
    'invoice.undoMarkPaid.error': 'Failed to undo invoice payment',
    'invoice.paymentSummary.toggle': 'Amounts',
    'invoice.paymentSummary.hide': 'Hide Amounts',
    'invoice.paymentSummary.show': 'Show Amounts',
    'invoice.seller.title': 'Seller',
    'invoice.dentist.title': 'Dentist',
    'invoice.deliveryCenter.title': 'Delivery Centers',
    'invoice.customer.title': 'Customer',
    'invoice.client.title': 'Client',
    'invoice.paymentSummary.title': 'Payment Summary',
    'invoice.notes.title': 'Notes',
    'invoice.notes.edit': 'Edit',
    'invoice.notes.save': 'Save',
    'invoice.notes.cancel': 'Cancel',
    'invoice.summary.title': 'Invoice Summary',
    'invoice.summary.subtotal': 'Subtotal',
    'invoice.summary.vat': 'VAT ({{percent}}%)',
    'invoice.summary.totalVat': 'Total VAT',
    'invoice.summary.discount': 'Discount',
    'invoice.summary.delivery': 'Delivery',
    'invoice.summary.total': 'Total',
    'invoice.attachments.title': 'Attachments',
    'invoice.addOrder.selectRequired': 'Please select at least one order',

    // UI invoice labels (used by public invoice view)
    'ui.invoice.number': 'Invoice',
    'ui.invoice.status': 'Status',
    'ui.invoice.issue_date': 'Issue Date',
    'ui.invoice.due_date': 'Due Date',
    'ui.invoice.section_vendor': 'Seller',
    'ui.invoice.section_client': 'Client',
    'ui.invoice.section_dentist': 'Dentist',
    'ui.invoice.section_delivery_center': 'Delivery Center',
    'ui.delivery_cost': 'Delivery Cost',
    'ui.invoice.table.order_ref': 'Order Ref',
    'ui.invoice.table.formula_type': 'Formula Type',
    'ui.invoice.table.units': 'Units',
    'ui.invoice.table.shipment_date': 'Shipment Date',
    'ui.invoice.table.patient': 'Patient',
    'ui.invoice.table.amount': 'Amount',
    'ui.invoice.table.discount': 'Discount',
    'ui.invoice.table.vat': 'VAT',
    'ui.invoice.table.total': 'Total',
    'ui.invoice.status_paid': 'Paid',
    'ui.invoice.status_past_due': 'Past Due',
    'ui.invoice.status_unpaid': 'Unpaid',

    // Generic error messages
    'errors.fetchFailed': 'Failed to load data',
    'invoice.addOrder.added': 'Orders added to invoice',
    'invoice.addOrder.fetchError': 'Unable to fetch orders',
    'invoice.addOrder.attachedHint': 'Attached to Invoice #{id} ({status}) — will be detached if selected',
    'invoice.addOrder.attachedWillDetach': 'Will be detached if selected',
    'invoice.addOrder.noOrders': 'No unpaid orders for this client',
    'invoice.addOrder.detachConfirmTitle': 'Detach orders from other invoices?',
    'invoice.addOrder.detachConfirmMessage': 'Some selected orders belong to other invoices. Selecting them will detach them from their current invoice(s). Do you want to continue?',

    'invoices.detach.title': 'Detach Orders',
    'invoices.detach.noInvoice': 'Invoice not found',
    'invoice.addOrder.attachError': 'Unable to attach orders',
    'invoice.addOrder.issueDateFrom': 'Issue date from',
    'invoice.addOrder.issueDateTo': 'Issue date to',
    'invoice.addOrder.loadByIssueDate': 'Load by issue date',
    'invoice.addOrder.selectAllInRange': 'Select all',
    'invoice.addOrder.clearIssueDateFilter': 'Clear date filter',
    'invoice.addOrder.issueDateRangeRequired': 'Please select an issue date range',
    'invoice.addOrder.noMatches': 'No matching unpaid invoices found for this client/dentist',

    'invoices.button.add': 'Add Invoice',
    'invoices.button.summary': 'Summary Invoice',
    'invoice.create.title': 'Create Invoice',
    'invoice.create.subtitle': 'Select a client, optionally a dentist and date range, then the unpaid orders to include',
    'invoice.create.backToInvoices': 'Back to invoices',
    'invoice.create.backToOrders': 'Back to orders',
    'invoice.create.setupTitle': 'Client, dentist & filters',
    'invoice.create.ordersTitle': 'Unpaid orders',
    'invoice.create.ordersHint': 'Select the orders to bill. Orders already on another unpaid invoice will be detached if selected.',
    'invoice.create.selectedCount': '{{count}} selected',
    'invoice.create.selected': 'Selected',
    'invoice.create.ordersCount': '{{count}} orders',
    'invoice.create.totalDue': 'Total due',
    'invoice.create.emptyClient': 'Select a client to load unpaid orders',
    'invoice.create.narrowByDate': 'Issue date range',
    'invoice.created': 'Invoice created',
    'invoice.form.clientPlaceholder': 'Select a client to load unpaid orders',
    'invoice.summary.pageTitle': 'Summary Invoice',
    'invoice.summary.dentistPlaceholder': 'Select a dentist (optional)',
    'invoice.summary.clientOrDentistRequired': 'Select a client and/or dentist',
    'invoice.summary.dateRangeRequired': 'Select a date range',
    'invoice.summary.preview': 'Preview',
    'invoice.summary.downloadPdf': 'Download PDF',
    'invoice.summary.loadError': 'Unable to load summary invoice',
    'invoice.summary.downloadError': 'Unable to download summary invoice',
    'invoice.summary.caseDescription': 'Case description',
    'invoice.summary.caseType': 'Case type',
    'invoice.summary.quantity': 'Quantity',
    'invoice.summary.date': 'Date',
    'invoice.summary.patient': 'Patient',
    'invoice.summary.status': 'Status',
    'invoice.summary.unitPrice': 'Unit price',
    'invoice.summary.numberOfUnits': 'Number of restorations',
    'invoice.summary.periodTotal': 'Period total',
    'invoice.summary.paidDuringPeriod': 'Paid during period',
    'invoice.summary.previousBalance': 'Previous balance',
    'invoice.summary.totalAmountDue': 'Total amount due',
    'invoice.summary.noCases': 'No cases in the selected period',
    'invoice.summary.filterTitle': 'Filter Parameters',
    'invoice.summary.resultsTitle': 'Summary Results',
    'invoice.summary.totalCases': 'Cases',
    'invoice.button.downloading': 'Downloading...',
    'invoice.field.formula_type': 'Formula Type Type',
    'invoice.field.color': 'Color',
    'invoice.field.subtotal': 'Subtotal',
    'invoice.field.discountType': 'Discount Type',
    'invoice.field.discountValue': 'Discount Value',
    'invoice.field.total': 'Total Due',
    'invoice.field.paid': 'Total Paid',

    // Payment / bank accounts (settings + invoice payment section)
    'lab.payment.title': 'Payment Settings',
    'lab.payment.bank_accounts_title': 'Bank Accounts',
    'lab.payment.addAccount': 'Add Bank Account',
    'lab.payment.editAccount': 'Edit Bank Account',
    'lab.payment.accountHolder': 'Account Holder',
    'lab.payment.accountHolder.required': 'Account holder is required',
    'lab.payment.accountHolder.max': 'Account holder name is too long',
    'lab.payment.accountNumber': 'Account Number',
    'lab.payment.accountNumber.required': 'Account number is required',
    'lab.payment.accountNumber.invalid': 'Invalid account number',
    'lab.payment.accountNumber.min': 'Account number is too short',
    'lab.payment.iban': 'IBAN',
    'lab.payment.iban.invalid': 'Invalid IBAN',
    'lab.payment.swiftCode': 'Swift Code',
    'lab.payment.swiftCode.invalid': 'Invalid SWIFT/BIC',
    'lab.payment.bankName': 'Bank Name',
    'lab.payment.bankName.required': 'Bank name is required',
    'lab.payment.bankName.max': 'Bank name is too long',
    'lab.payment.branch': 'Bank Branch',
    'lab.payment.branch.max': 'Branch details are too long',
    'lab.payment.no_accounts': 'No bank accounts',
    'lab.payment.no_transfer': 'No active transfer channels',
    'lab.payment.addTransfer': 'Add Transfer Channel',
    'lab.payment.editTransfer': 'Edit Transfer Channel',
    'lab.payment.channel': 'Transfer Channel',
    'lab.payment.deactivate': 'Deactivate',
    'lab.payment.channel.required': 'Please select a transfer channel',
    'lab.payment.phone.invalid': 'Invalid phone number',
    'lab.payment.transfer_title': 'Money Transfer',
    'lab.payment.activate': 'Activate',
    'lab.payment.activated': 'Activated',
    'lab.payment.deactivated': 'Deactivated',
    'ui.invoice.bank_account': 'Bank Account',
    'ui.invoice.bank_account_numbered': 'Bank Account {{n}}',
    'ui.invoice.bank_name': 'Bank Name',
    'ui.invoice.bank_swift': 'Swift Code',
    'ui.invoice.bank_iban': 'IBAN',
    'ui.invoice.account_holder': 'Account Holder',
    'ui.invoice.account_number': 'Account Number',
    'ui.invoice.vendor_payment_data': 'Vendor Payment Data',
    'ui.invoice.money_transfer_channels': 'Money Transfer Channels',
    'ui.invoice.channel.instapay': 'Instapay',
    'ui.invoice.channel.vodafone_cash': 'Vodafone Cash',
    'ui.invoice.channel.vodafone-cash': 'Vodafone Cash',
    'ui.invoice.channel.etisalat_cash': 'Etisalat Cash',
    'ui.invoice.channel.etisalat-cash': 'Etisalat Cash',
    'ui.invoice.channel.we_pay': 'WE Pay',
    'ui.invoice.channel.we-pay': 'WE Pay',
    'ui.invoice.channel.fawry': 'Fawry',
    'ui.invoice.channel.bank_transfer': 'Bank Transfer',
    'ui.invoice.channel.bank-transfer': 'Bank Transfer',
    'ui.invoice.channel.meeza': 'Meeza',
    'ui.invoice.channel.masary': 'Masary',

    // Enhanced Public Invoice UI
    'ui.invoice.view_title': 'Invoice',
    'ui.invoice.loading_details': 'Loading invoice details...',
    'ui.invoice.financial_summary': 'Financial Summary',
    
    'ui.invoice.payment_details': 'Payment & Bank Instructions',
    'ui.invoice.scan_qr_hint': 'Scan QR code to view and verify invoice online',
    'ui.invoice.copy_iban': 'Copy IBAN',
    'ui.invoice.copy_account': 'Copy Account Number',
    'ui.invoice.copy_number': 'Copy Number',
    'ui.invoice.copied': 'Copied to clipboard',
    'ui.invoice.public_disclaimer': 'This official dental laboratory invoice is provided for clinical and financial verification. No login required.',
    'ui.invoice.included_orders': 'Included Orders',
    'ui.invoice.orders_count': '{{count}} Orders',
    'ui.invoice.total_restorations': '{{count}} Restorations',
    'ui.invoice.paid_in_full': 'Paid in Full',
    'ui.invoice.remaining_balance': 'Remaining Due',
    'ui.invoice.billing_signoff': 'Billing Approval & Lab Sign-off',
    'ui.invoice.accountant_signature': 'Authorized Signature / Stamp',
    'ui.invoice.accountant_name': 'Prepared By',
    'ui.invoice.verification_date': 'Verification Date',
    'ui.invoice.channel_transfer_notice': 'Please reference the invoice number when submitting payments.',
    'ui.invoice.bank_details': 'Bank Details',
    'ui.invoice.no_bank_accounts': 'No bank account details provided.',
    'ui.invoice.no_transfer_channels': 'No money transfer channels provided.',
    'ui.invoice.balance_cleared': 'Balance Cleared',
    'ui.invoice.unpaid_balance_alert': 'Payment is pending. Please use the payment details below to settle.',
    'ui.invoice.past_due_alert': 'This invoice is past due. Please settle the remaining amount as soon as possible.',

    // Synced missing keys
    'activities.fields.formula_type': 'Formula type',
    'assets.title': 'Assets',
    'common.deleted': 'Deleted',
    'common.download_success': 'Downloaded successfully',
    'common.error': 'Something went wrong',
    'common.noAccess': 'You do not have access',
    'common.noData': 'No data',
    'common.popupBlocked': 'Popup blocked. Please allow popups for this site.',
    'common.unauthorized': 'Please log in',
    'errors.notFound': 'Not found',
    'errors.noViewPermission': 'You do not have permission to view this',
    'entity.generic': 'Record',
    'entity.notFound': '{entity} Not Found',
    'entity.notFoundDescription': '{entity} #{id} was not found.',
    'entity.notFoundHint': 'The record you are looking for does not exist or was removed.',
    'entity.backToList': 'Back to list',
    'entity.order': 'Order',
    'entity.invoice': 'Invoice',
    'entity.client': 'Client',
    'entity.dentist': 'Dentist',
    'entity.user': 'User',
    'entity.wallet': 'Wallet',
    'home.no_data': 'No data',
    'home.tracker_description': 'Order tracking details',
    'invoices.pdf.client': 'Client',
    'invoices.pdf.dentist': 'Dentist',
    'lab.field.notes': 'Lab description',
    'orders.actions.noInvoiceAttached': 'No invoice attached to this order yet',
    'orders.actions.operationalBlocked': 'Operational actions are locked for this order',
    'orders.form.unitsCount.label': 'Units count',
    'orders.summary.discountDentistFormulaType': 'Dentist formula type discount',
    'orders.table.deliveryCost': 'Delivery cost',
    'orders.table.reference': 'Reference',
    'orders.update.section.invoicing': 'Invoice & Billing',
    'orders.update.section.quickActions': 'Quick Actions',
    'orders.update.section.workflow': 'Workflow & Operations',
    'responses.common.locale_updated': 'Language updated',
    'ui.invoice.money_transfer_channel': 'Money transfer channel',
    'ui.invoice.paid_at': 'Paid at',
    'ui.invoice.payment_method': 'Payment method',
    'ui.invoice.payment_method_cash_on_delivery': 'Cash on delivery',
    'ui.invoice.payment_method_credit_card': 'Credit card',
    'ui.invoice.payment_method_money_transfer': 'Bank transfer',
    'ui.invoice.payment_method_wallet': 'Wallet',
    'ui.invoice.public_link': 'View invoice',
    'ui.invoice.view_order': 'View order',
    'ui.order.dates_and_timeline': 'Timeline & Dates',
    'ui.order.formula_type': 'Formula type',

    // Subscription
    'subscription.title': 'Subscription',
    'subscription.loadError': 'Could not load subscription details',
    'subscription.adminOnly': 'Only lab admins can manage the subscription plan.',
    'subscription.currentPlan': 'Current plan',
    'subscription.noPlan': 'No subscription plan assigned.',
    'subscription.choosePlan': 'Choose a plan',
    'subscription.choosePlanHint': 'Request a paid plan. Our team will review your request and activate the new plan once approved.',
    'subscription.popular': 'Popular',
    'subscription.month': 'month',
    'subscription.current': 'Current plan',
    'subscription.requestPlan': 'Request plan',
    'subscription.requestConfirm': 'Send a request to switch to the {plan} plan?',
    'subscription.requestSubmitted': 'Plan change request sent. We will activate it once approved.',
    'subscription.requestError': 'Could not send the plan change request',
    'subscription.awaitingApproval': 'Awaiting approval',
    'subscription.requestPending': 'Your request to switch to the {plan} plan is awaiting approval.',
    'subscription.requestPendingHint': 'Your current plan stays active until our team approves the request.',
    'subscription.cancelRequest': 'Cancel request',
    'subscription.cancelRequestConfirm': 'Cancel this plan change request?',
    'subscription.requestCancelled': 'Plan change request cancelled',
    'subscription.requestCancelError': 'Could not cancel the plan change request',
    'subscription.requestRejected': 'Your request to switch to the {plan} plan was rejected.',
    'subscription.rejectionReason': 'Reason',
    'subscription.noPaidPlans': 'No paid plans are available right now.',
    'subscription.trialEndsAt': 'Trial ends',
    'subscription.trialActive': 'Free trial active — {days} day(s) remaining.',
    'subscription.trialEndingSoon': 'Your free trial ends in {days} day(s). Choose a plan to keep access.',
    'subscription.trialExpired': 'Your free trial has ended. Choose a plan to restore access.',
    'subscription.billing.trialing': 'Trialing',
    'subscription.billing.active': 'Active',
    'subscription.billing.past_due': 'Past due',
    'subscription.billing.cancelled': 'Cancelled',
    'subscription.billing.manual': 'Manual',
    'subscription.status.pending': 'Pending',
    'subscription.status.under_review': 'Under review',
    'subscription.status.active': 'Active',
    'subscription.status.suspended': 'Suspended',
    'subscription.status.cancelled': 'Cancelled',
    'subscription.status.rejected': 'Rejected',

    // Not Found
    'notFound.title': 'Page Not Found',
  },
  ar: {
    'common.add': 'إضافة',
    'common.edit': 'تعديل',
    'common.update': 'تحديث',
    'common.delete': 'حذف',
    'common.remove': 'إزالة',
    'common.view': 'عرض',
    'common.hide': 'إخفاء',
    'common.viewOrders': 'عرض الطلبات',
    'common.viewInvoices': 'عرض الفواتير',
    'common.cancel': 'إلغاء',
    'common.close': 'إغلاق',
    'common.actions': 'العمليات',
    'common.refresh': 'تحديث',
    'common.confirmDeleteTitle': 'حذف عنصر',
    'common.confirmDeleteMessage': 'هل تريد حذف هذا العنصر؟',
    'common.back': 'رجوع',
    'common.deleteConfirm': 'حذف',
    'common.added': 'مضاف',
    'common.zeroPlaceholder': '٠',
    'common.notes': 'ملاحظات',
    'common.phone': 'رقم التليفون',
    'common.whatsapp': 'رقم الواتساب',
    'common.address': 'العنوان',
    'common.email': 'البريد الإلكتروني',
    'common.subject': 'الموضوع',
    'common.required': 'هذا الحقل مطلوب',
    'common.confirm': 'تأكيد',
    'common.validationError': 'خطأ في التحقق',
    'api.errors.validation_error': 'خطأ في التحقق من البيانات',
    'api.errors.invalid_credentials': 'بيانات الدخول غير صحيحة',
    'api.errors.unauthenticated': 'غير مصرح لك',
    'api.errors.permission_denied': 'ليس لديك صلاحية القيام بهذا الإجراء',
    'api.errors.invalid_current_password': 'كلمة المرور الحالية غير صحيحة',
    'api.errors.login_identifier_required': 'يرجى إدخال بريد إلكتروني أو اسم مستخدم.',
    'api.errors.email_invalid': 'يرجى إدخال بريد إلكتروني صالح.',
    'api.errors.email_taken': 'هذا البريد الإلكتروني مسجل بالفعل.',
    'api.errors.username_taken': 'اسم المستخدم مستخدم بالفعل.',
    'api.errors.already_taken': 'هذه القيمة مستخدمة بالفعل.',
    'api.errors.backoffice_access_denied': 'لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.',
    'api.errors.vendor_portal_only': 'يجب تسجيل الدخول عبرصفحة دخول المعمل.',
    'api.errors.not_found': 'غير موجود',
    'api.errors.request_failed': 'حدث خطأ ما',
    'forms.whatsappSameAsPhone': 'الواتساب نفس رقم الهاتف',
    'forms.phone.placeholder': 'ادخل رقم الهاتف',
    'forms.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'forms.copyFromVendor.label': 'استخدام بيانات التواصل للمختبر',
    'forms.copyFromVendor.phone': 'هاتف المختبر',
    'forms.copyFromVendor.whatsapp': 'واتساب المختبر',
    'forms.copyFromVendor.address': 'عنوان المختبر',
    'forms.copyFromClient.label': 'استخدام بيانات التواصل للعميل',
    'forms.copyFromClient.phone': 'هاتف العميل',
    'forms.copyFromClient.whatsapp': 'واتساب العميل',
    'forms.copyFromClient.address': 'عنوان العميل',
    'common.clear': 'مسح',
    'common.resetFilters': 'إعادة تعيين عوامل التصفية',
    'common.filters': 'تصفية',
    'common.general': 'عام',
    'validation.name.required': 'الاسم مطلوب',
    'validation.name.min': 'يجب أن يكون الاسم حرفين على الأقل',
    'validation.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'validation.email.required': 'البريد الإلكتروني مطلوب',
    'validation.email.invalid': 'يرجى إدخال بريد إلكتروني صالح',
    'validation.email.max': 'يجب ألا يزيد البريد الإلكتروني عن 255 حرفًا',
    'validation.username.required': 'اسم المستخدم مطلوب',
    'validation.username.min': 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
    'validation.username.max': 'يجب ألا يزيد اسم المستخدم عن 50 حرفًا',
    'validation.username.invalid': 'اسم المستخدم يمكن أن يحتوي على حروف وأرقام ونقاط وشرطات سفلية وشرطات فقط',
    'validation.login.identifierRequired': 'أدخل بريدًا إلكترونيًا أو اسم مستخدم',
    'validation.phone.required': 'رقم الهاتف مطلوب',
    'validation.phone.invalid': 'يرجى إدخال رقم هاتف صالح',
    'validation.phone.max': 'يجب ألا يزيد رقم الهاتف عن 50 حرفًا',
    'validation.whatsapp.required': 'رقم الواتساب مطلوب',
    'validation.whatsapp.invalid': 'يرجى إدخال رقم واتساب صالح',
    'validation.whatsapp.max': 'يجب ألا يزيد رقم الواتساب عن 50 حرفًا',
    'common.loading': 'جاري التحميل...',
    'common.saved': 'تم الحفظ بنجاح',

    'sidebar.dashboard': 'لوحة التحكم',
    'sidebar.reports': 'التقارير',
    'sidebar.settings': 'الإعدادات',
    'sidebar.client_settings': 'الإعدادات',
    'sidebar.client_transactions': 'المعاملات',
    'sidebar.setting': 'اعدادات المعمل',
    'sidebar.setting_lab_info': 'المعمل',
    'sidebar.setting_subscription': 'الاشتراك',
    'sidebar.setting_payment': 'إعدادات الدفع',
    'sidebar.setting_delivery': 'إعدادات التوصيل',
    'sidebar.setting_vacations': 'الأجازات',
    'sidebar.orders': 'الطلبات',
    'sidebar.orders_calendar': 'التقويم',
    'sidebar.invoices': 'الفواتير',

    // Invoices
    'invoices.header.title': 'الفواتير',
    'invoices.header.subtitle': 'إدارة فواتير المعمل ومتابعة التحصيلات وحالات الدفع والسجلات المالية',
    'invoices.filter.title': 'تصفية الفواتير',
    'invoices.filter.active': 'مفعل',
    'invoices.filter.clear': 'إعادة تعيين عوامل التصفية',
    'invoices.table.refresh': 'تحديث',
    'invoices.table.ordersCount': 'الطلبات',
    'invoices.table.number': 'رقم الفاتورة',
    'invoices.table.status': 'الحالة',
    'invoices.table.issueDate': 'تاريخ الإصدار',
    'invoices.table.client': 'العميل',
    'invoices.table.dentist': 'طبيب الأسنان',
    'invoices.table.dueDate': 'تاريخ الاستحقاق',
    'invoices.table.total': 'الإجمالي',
    'invoices.table.remaining': 'متبقي',
    'invoices.table.actions': 'الاجراءات',
    'invoices.table.draft': 'مسودة',
    'invoices.table.draftLabel': 'مسودة',
    'invoices.search.placeholder': 'بحث برقم الفاتورة، المرجع، العميل، الطبيب أو الملاحظات',
    'invoices.confirm.delete': 'هل أنت متأكد أنك تريد حذف هذه الفاتورة؟',
    'invoices.alert.noAccess': 'ليس لديك صلاحية لعرض الفواتير.',
    'sidebar.formula_types': 'التركيبات والخدمات',
    'sidebar.colors': 'الألوان',
    'sidebar.platform_settings': 'إعدادات المنصة',
    'sidebar.assets': 'الأصول',
    'sidebar.branchs': 'الفروع',
    'sidebar.delivery_centers': 'مراكز التوصيل',
    'sidebar.expenses': 'المصروفات',
    'sidebar.expense_types': 'بنود المصروفات',
    'sidebar.dentists': 'أطباء الأسنان',
    'sidebar.users': 'المستخدمون',
    'sidebar.roles': 'الأدوار والصلاحيات',
    'sidebar.transactions': 'المعاملات',
    'sidebar.activities': 'سجل العمليات',
    'sidebar.units': 'الوحدات',
    'sidebar.unit_types': 'أنواع الوحدات',

    // Activities
    'activities.table.entity_affected': 'السجل المتأثر',
    'activities.table.user': 'اسم المستخدم',
    'activities.table.operation': 'العملية',
    'activities.table.ip': 'عنوان الجهاز',
    'activities.table.date': 'التاريخ',
    'activities.table.properties': 'الخصائص',
    'activities.filters.name': 'الاسم',
    'activities.filters.entity': 'الكيان',
    'activities.filters.operation': 'العملية',
    'activities.operations.create': 'إنشاء',
    'activities.operations.created': 'إنشاء',
    'activities.operations.update': 'تحديث',
    'activities.operations.updated': 'تحديث',
    'activities.operations.delete': 'حذف',
    'activities.operations.deleted': 'حذف',
    'activities.operations.paid_invoice': 'دفع فاتورة',
    'activities.operations.undo_mark_paid': 'التراجع عن تعليم كمدفوعة',
    'activities.operations.refund_invoice': 'استرداد فاتورة',
    'activities.operations.cancel': 'إلغاء',
    'activities.operations.send_email': 'إرسال بريد إلكتروني',
    'activities.operations.send_whatsapp': 'إرسال واتساب',
    'activities.operations.download_invoice_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_invoice_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    // Legacy activity event aliases
    'activities.operations.download_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    'activities.operations.login': 'تسجيل الدخول',
    'activities.operations.logout': 'تسجيل الخروج',
    'activities.operations.password_reset': 'إعادة تعيين كلمة المرور',
    'activities.operations.password_reset_request': 'طلب إعادة تعيين كلمة المرور',
    'activities.operations.impersonate': 'انتحال هوية',
    'activities.properties.field': 'الحقل',
    'activities.properties.old': 'القيمة السابقة',
    'activities.properties.new': 'القيمة الجديدة',
    'activities.properties.no_changes': 'لا توجد بيانات مقارنة قديم/جديد لهذا النشاط.',
    'activities.modal.properties_title': 'الخصائص المتغيرة',
    'activities.fields.id': 'المعرف',
    'activities.fields.name': 'الاسم',
    'activities.fields.email': 'البريد الإلكتروني',
    'activities.fields.phone': 'رقم الهاتف',
    'activities.fields.notes': 'ملاحظات',
    'activities.fields.address': 'العنوان',
    'activities.fields.whatsapp': 'واتساب',
    'activities.fields.client': 'العميل',
    'activities.fields.client_id': 'العميل',
    'activities.fields.client_name': 'العميل',
    'activities.fields.client_address': 'عنوان العميل',
    'activities.fields.dentist': 'الطبيب',
    'activities.fields.dentist_id': 'الطبيب',
    'activities.fields.dentist_name': 'الطبيب',
    'activities.fields.dentist_email': 'البريد الإلكتروني للطبيب',
    'activities.fields.dentist_phone': 'هاتف الطبيب',
    'activities.fields.technician': 'الفني',
    'activities.fields.technician_id': 'الفني',
    'activities.fields.technician_name': 'اسم الفني',
    'activities.fields.technician_email': 'البريد الإلكتروني للفني',
    'activities.fields.courier': 'مندوب التوصيل',
    'activities.fields.courier_id': 'مندوب التوصيل',
    'activities.fields.orders': 'الطلبات',
    'activities.fields.units': 'الوحدات',
    'activities.fields.units_count': 'عدد الوحدات',
    'activities.fields.attachments': 'المرفقات',
    'activities.fields.requested_at': 'تاريخ الطلب',
    'activities.fields.delivered_at': 'تم التسليم',
    'activities.fields.code': 'الكود',
    'activities.fields.color': 'اللون',
    'activities.fields.formula_type': 'نوع التركيبة',
    'activities.fields.delivery_type': 'نوع التوصيل',
    'activities.fields.delivery_type_name': 'نوع التوصيل',
    'activities.fields.user_type': 'نوع المستخدم',
    'activities.fields.payment_method': 'طريقة الدفع',
    'activities.fields.payment_method_id': 'طريقة الدفع',
    'activities.fields.payment_status': 'حالة الدفع',
    'activities.fields.payment_status_id': 'حالة الدفع',
    'activities.fields.order_status': 'حالة الطلب',
    'activities.fields.delivery_center': 'مركز التوصيل',
    'activities.fields.delivery_center_id': 'مركز التوصيل',
    'activities.fields.delivery_center_name': 'اسم مركز التوصيل',
    'activities.fields.delivery_center_address': 'عنوان مركز التوصيل',
    'activities.fields.delivery_center_created_at': 'تاريخ إنشاء مركز التوصيل',
    'activities.fields.delivery_center_updated_at': 'تاريخ تحديث مركز التوصيل',
    'activities.fields.delivery_cost': 'تكلفة التوصيل',
    'activities.fields.discount_amount': 'قيمة الخصم',
    'activities.fields.vat_percentage': 'نسبة الضريبة',
    'activities.fields.unit_price_override': 'تجاوز سعر الوحدة',
    'activities.fields.unit_price_source': 'مصدر سعر الوحدة',
    'activities.fields.reference': 'المرجع',
    'activities.fields.is_draft': 'مسودة',
    'activities.fields.due_date': 'تاريخ الاستحقاق',
    'activities.fields.issue_date': 'تاريخ الإصدار',
    'activities.fields.paid_at': 'تاريخ الدفع',
    'activities.fields.paid_amount': 'المبلغ المدفوع',
    'activities.fields.total_amount': 'الإجمالي',
    'activities.fields.subtotal_amount': 'الإجمالي الفرعي',
    'activities.fields.remaining_amount': 'المبلغ المتبقي',
    'activities.fields.created_at': 'تاريخ الإنشاء',
    'activities.fields.updated_at': 'تاريخ التحديث',

    'auth.login.title': 'مرحبًا بعودتك',
    'auth.login.vendorTitle': 'صفحة دخول المعمل',
    'auth.login.vendorSubtitle': 'سجّل الدخول لإدارة معملك',
    'auth.login.brandLede': 'الطلبات والفواتير والتوصيل — كل شيء لمعملك في مكان واحد.',
    'auth.login.formSubtitle': 'سجّل الدخول بالبريد الإلكتروني أو اسم المستخدم وكلمة المرور',
    'auth.login.secureNotice': 'وصول محمي لموظفي المعمل المصرّح لهم فقط.',
    'auth.login.email.label': 'البريد الإلكتروني',
    'auth.login.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'auth.login.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'auth.login.email.placeholder': 'ادخل البريد الإلكتروني',
    'auth.login.identifier.label': 'البريد الإلكتروني أو اسم المستخدم',
    'auth.login.identifier.required': 'من فضلك ادخل البريد الإلكتروني أو اسم المستخدم',
    'auth.login.identifier.placeholder': 'ادخل البريد الإلكتروني أو اسم المستخدم',
    'auth.login.password.label': 'كلمة المرور',
    'auth.login.password.required': 'من فضلك ادخل كلمة المرور',
    'auth.login.password.placeholder': 'ادخل كلمة المرور',
    'auth.login.submit': 'تسجيل الدخول',
    'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
    'auth.forgotPassword.title': 'إعادة تعيين كلمة المرور',
    'auth.forgotPassword.description': 'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.',
    'auth.forgotPassword.brandHeadline': 'استعد الوصول خلال خطوات بسيطة',
    'auth.forgotPassword.brandLede': 'استخدم بريدك لإرسال رابط إعادة التعيين، أو اعرض بيانات مدير المعمل إذا كنت تسجّل الدخول باسم مستخدم فقط.',
    'auth.forgotPassword.submit': 'إرسال رابط إعادة التعيين',
    'auth.forgotPassword.success': 'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    'auth.forgotPassword.failed': 'تعذر إرسال رابط إعادة التعيين. يرجى المحاولة مرة أخرى.',
    'auth.forgotPassword.backToLogin': 'العودة إلى تسجيل الدخول',
    'auth.forgotPassword.noEmailDivider': 'بدون بريد إلكتروني؟',
    'auth.forgotPassword.noEmailDescription': 'إذا كنت تسجّل الدخول باسم مستخدم وليس لديك بريد إلكتروني، أدخل اسم المستخدم لعرض بيانات التواصل مع مدير المعمل. يمكنه إعادة تعيين كلمة المرور إلى الكلمة المؤقتة.',
    'auth.forgotPassword.contactAdmin': 'عرض بيانات المدير',
    'auth.forgotPassword.usernameRequired': 'من فضلك ادخل اسم المستخدم',
    'auth.forgotPassword.contactFailed': 'تعذر جلب بيانات التواصل. يرجى المحاولة مرة أخرى.',
    'auth.forgotPassword.hasEmail': 'هذا الحساب مرتبط ببريد إلكتروني. استخدم النموذج أعلاه لإرسال رابط إعادة التعيين.',
    'auth.forgotPassword.contactFound': 'تواصل مع مدير المعمل واطلب منه إعادة تعيين كلمة المرور.',
    'auth.forgotPassword.contactAdminGeneric': 'تواصل مع مدير المعمل واطلب منه إعادة تعيين كلمة المرور إلى الكلمة المؤقتة.',
    'auth.resetPassword.title': 'تعيين كلمة مرور جديدة',
    'auth.resetPassword.description': 'اختر كلمة مرور جديدة لحسابك.',
    'auth.resetPassword.brandHeadline': 'اختر كلمة مرور قوية وجديدة',
    'auth.resetPassword.brandLede': 'بعد إعادة التعيين يمكنك تسجيل الدخول مجددًا ببياناتك المحدّثة.',
    'auth.resetPassword.password.label': 'كلمة المرور الجديدة',
    'auth.resetPassword.password.required': 'من فضلك أدخل كلمة مرور جديدة',
    'auth.resetPassword.password.minLength': 'يجب ألا تقل كلمة المرور عن 8 أحرف',
    'auth.resetPassword.password.placeholder': 'أدخل كلمة المرور الجديدة',
    'auth.resetPassword.password.confirm': 'تأكيد كلمة المرور',
    'auth.resetPassword.password.confirmRequired': 'من فضلك أكد كلمة المرور',
    'auth.resetPassword.password.confirmPlaceholder': 'أكد كلمة المرور الجديدة',
    'auth.resetPassword.password.mismatch': 'كلمتا المرور غير متطابقتين',
    'auth.resetPassword.submit': 'إعادة تعيين كلمة المرور',
    'auth.resetPassword.success': 'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'auth.resetPassword.failed': 'تعذر إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    'auth.resetPassword.error': 'رابط غير صالح',
    'auth.resetPassword.invalidLink': 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',

    'assets.table.name': 'الاسم',
    'assets.table.cost': 'القيمة',
    'assets.table.notes': 'ملاحظات',
    'assets.table.actions': 'العمليات',
    'assets.button.add': 'إضافة أصل',
    'assets.modal.title': 'الأصول الثابتة',
    'assets.confirm.deleteTitle': 'حذف أصل',
    'assets.confirm.deleteMessage': 'هل تريد حذف هذا الأصل؟',
    'assets.form.name.label': 'اسم الأصل',
    'assets.form.name.placeholder': 'ادخل اسم الأصل',
    'assets.form.name.required': 'من فضلك أدخل اسم الأصل',
    'assets.form.cost.label': 'التكلفة',
    'assets.form.cost.placeholder': 'أدخل التكلفة',
    'assets.form.cost.required': 'من فضلك أدخل التكلفة',
    'assets.form.cost.min': 'يجب أن تكون التكلفة ١ على الأقل',
    'assets.form.notes.label': 'ملاحظات',
    'assets.form.notes.placeholder': 'ادخل الملاحظات',
    'assets.search.namePlaceholder': 'ابحث بالاسم',
    'assets.search.notesPlaceholder': 'ابحث بالملاحظات',
    'assets.alert.noAccess': 'ليس لديك صلاحية لعرض الأصول.',

    'branchs.table.name': 'اسم الفرع',
    'branchs.table.address': 'العنوان',
    'branchs.table.phone': 'رقم التليفون',
    'branchs.table.whatsapp': 'رقم الواتساب',
    'branchs.table.email': 'البريد الإلكتروني',
    'branchs.table.notes': 'ملاحظات',
    'branchs.table.actions': 'العمليات',
    'branchs.button.add': 'إضافة فرع',
    'branchs.modal.title': 'إعدادت الفروع',
    'branchs.confirm.deleteTitle': 'حذف فرع',
    'branchs.confirm.deleteMessage': 'هل تريد حذف هذا الفرع؟',
    'branchs.form.name.label': 'اسم الفرع',
    'branchs.form.name.placeholder': 'ادخل اسم الفرع',
    'branchs.form.name.required': 'من فضلك ادخل اسم الفرع',
    'branchs.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'branchs.form.address.label': 'العنوان',
    'branchs.form.address.placeholder': 'ادخل العنوان',
    'branchs.form.address.required': 'من فضلك ادخل العنوان',
    'branchs.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'branchs.form.phone.label': 'رقم التليفون',
    'branchs.form.phone.placeholder': 'ادخل رقم التليفون',
    'branchs.form.phone.required': 'من فضلك ادخل رقم التليفون',
    'branchs.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'branchs.form.whatsapp.label': 'رقم الواتساب',
    'branchs.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'branchs.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'branchs.form.email.label': 'البريد الإلكتروني',
    'branchs.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'branchs.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'branchs.form.notes.label': 'ملاحظات',
    'branchs.form.notes.placeholder': 'ادخل الملاحظات',
    'branchs.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'branchs.alert.noAccess': 'ليس لديك صلاحية لعرض الفروع.',

    'deliveryCenters.table.name': 'اسم المركز',
    'deliveryCenters.table.address': 'العنوان',
    'deliveryCenters.table.phone': 'رقم التليفون',
    'deliveryCenters.table.whatsapp': 'رقم الواتساب',
    'deliveryCenters.table.email': 'البريد الإلكتروني',
    'deliveryCenters.table.client': 'العميل المعين',
    'deliveryCenters.table.noClient': 'لا يوجد عميل معين',
    'deliveryCenters.table.actions': 'العمليات',
    'deliveryCenters.button.add': 'إضافة مركز توصيل',
    'deliveryCenters.modal.title': 'مراكز التوصيل',
    'deliveryCenters.confirm.deleteTitle': 'حذف مركز توصيل',
    'deliveryCenters.confirm.deleteMessage': 'هل تريد حذف هذا المركز؟',
    'deliveryCenters.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'deliveryCenters.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'deliveryCenters.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'deliveryCenters.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'deliveryCenters.form.client.label': 'العميل',
    'deliveryCenters.form.client.placeholder': 'اختر العميل',
    'deliveryCenters.form.client.required': 'من فضلك اختر العميل',
    'deliveryCenters.alert.noAccess': 'ليس لديك صلاحية لعرض مراكز التوصيل.',
    'deliveryCenters.filter.title': 'تصفية مراكز التوصيل',
    'deliveryCenters.filter.active': 'مفعل',
    'deliveryCenters.filter.clear': 'إعادة تعيين عوامل التصفية',
    'responses.delivery_center.updated': 'تم تحديث مركز التوصيل بنجاح',

    'clients.header.title': 'العملاء',
    'clients.header.subtitle': 'إدارة العيادات والمستشفيات والمعامل مع جهات الاتصال والأطباء ومراكز التسليم',
    'clients.filter.title': 'تصفية العملاء',
    'clients.filter.active': 'مفعل',
    'clients.filter.clear': 'إعادة تعيين عوامل التصفية',
    'clients.wallet.historyEmpty': 'لا توجد معاملات محفظة بعد',
    'clients.alert.noAccess': 'ليس لديك صلاحية لعرض العملاء.',
    'clients.table.name': 'اسم العميل',
    'clients.table.type': 'نوع العميل',
    'clients.table.phone': 'رقم التليفون',
    'clients.table.whatsapp': 'رقم الواتساب',
    'clients.table.email': 'البريد الإلكتروني',
    'clients.table.dentists': 'الأطباء المسؤولون ',
    'clients.table.noDentists': 'لا يوجد أطباء معينون',
    'clients.table.noLabContacts': 'لا توجد جهات اتصال مختبر معينة',
    'clients.table.showMore': 'عرض المزيد',
    'clients.table.showLess': 'عرض أقل',
    'clients.table.deliveryCenters': 'مراكز التسليم',
    'clients.table.noDeliveryCenters': 'لا توجد مراكز تسليم معينة',
    'clients.table.actions': 'العمليات',
    'clients.formulaTypePrices.button': 'أسعار أنواع التركيبات',
    'clients.formulaTypePrices.title': 'أسعار أنواع التركيبات لـ',
    'clients.formulaTypePrices.help': 'حدد سعر الوحدة المخصص لكل نوع تركيبة لهذا العميل. اتركه فارغًا لاستخدام سعر البيع الافتراضي.',
    'clients.formulaTypePrices.formulaType': 'نوع التركيبة',
    'clients.formulaTypePrices.defaultPrice': 'السعر الافتراضي',
    'clients.formulaTypePrices.customPrice': 'سعر الوحدة المخصص',
    'clients.formulaTypePrices.noChanges': 'لا توجد تغييرات للحفظ',
    'clients.button.add': 'إضافة عميل',
    'clients.title': 'العميل',
    'clients.modal.title': 'العملاء',
    'clients.confirm.deleteTitle': 'حذف عميل',
    'clients.confirm.deleteMessage': 'هل تريد حذف هذا العميل؟',
    'clients.form.name.label': 'اسم العميل',
    'clients.form.name.placeholder': 'اسم العميل',
    'clients.form.name.required': 'من فضلك ادخل اسم العميل',
    'clients.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'clients.form.type.label': 'نوع العميل',
    'clients.form.type.placeholder': 'اختر نوع العميل',
    'clients.form.type.required': 'من فضلك اختر نوع العميل',
    'clients.form.type.options.clinic': 'عيادة',
    'clients.form.type.options.hospital': 'مستشفى',
    'clients.form.type.options.lab': 'معمل',
    'clients.form.search.placeholder': 'ابحث بالاسم أو البريد أو الهاتف',
    'clients.form.phone.label': 'رقم الهاتف',
    'clients.form.phone.placeholder': 'ادخل رقم الهاتف',
    'clients.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'clients.form.whatsapp.label': 'رقم الواتساب',
    'clients.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'clients.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'clients.form.email.label': 'البريد الإلكتروني',
    'clients.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'clients.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'clients.form.dentists.label': 'الأطباء',
    'clients.form.dentists.placeholder': 'اختر الأطباء',
    'clients.form.dentists.empty': 'لا يوجد أطباء متاحون',
    'clients.form.dentists.labelLab': 'جهات اتصال المختبر',
    'clients.form.dentists.placeholderLab': 'اختر جهات اتصال المختبر',
    'clients.form.dentists.emptyLab': 'لا توجد جهات اتصال مختبر متاحة',
    'clients.form.deliveryCenters.label': 'مراكز التسليم',
    'clients.form.deliveryCenters.placeholder': 'اختر أو أضف مراكز التسليم',
    'clients.form.deliveryCenters.empty': 'لا توجد مراكز تسليم متاحة',
    'clients.form.submit.edit': 'تحديث',
    'clients.form.submit.createThenContacts': 'إنشاء العميل ثم إضافة جهات الاتصال',
    'clients.form.submit.createWithContacts': 'إنشاء العميل مع جهات الاتصال',
    'clients.form.contactMode.label': 'جهات الاتصال لهذا العميل',
    'clients.form.contactMode.required': 'من فضلك اختر طريقة إضافة جهات الاتصال',
    'clients.form.contactMode.mirror': 'إنشاء طبيب بنفس بيانات العميل',
    'clients.form.contactMode.mirrorLab': 'إنشاء جهة اتصال مختبر بنفس بيانات العميل',
    'clients.form.contactMode.mirrorHelp': 'مناسب عندما يكون للعيادة/المستشفى طبيب واحد — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.mirrorHelpLab': 'مناسب عندما يكون للمعمل جهة اتصال واحدة — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.list': 'إضافة عدة أطباء',
    'clients.form.contactMode.listLab': 'إضافة عدة جهات اتصال مختبر',
    'clients.form.contactMode.listHelp': 'سيتم توسيع هذا النموذج لإضافة طبيب أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.listHelpLab': 'سيتم توسيع هذا النموذج لإضافة جهة اتصال أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.dentistTypeMissing': 'نوع مستخدم الطبيب غير متاح. حدّث الصفحة وحاول مرة أخرى.',
    'clients.form.mirror.sectionTitle': 'بيانات دخول الطبيب',
    'clients.form.mirror.sectionTitleLab': 'بيانات دخول جهة اتصال المختبر',
    'clients.form.mirror.hint': 'يتم أخذ الاسم والهاتف والواتساب والبريد من العميل. أضف اسم مستخدم و/أو بريدًا لتسجيل الدخول للصفحة دخول.',
    'clients.form.mirror.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء الطبيب. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.mirror.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء جهة اتصال المختبر. يمكنك الإضافة من صفحة العميل.',
    'clients.form.list.sectionTitle': 'الأطباء',
    'clients.form.list.sectionTitleLab': 'جهات اتصال المختبر',
    'clients.form.list.clientCreated': 'تم إنشاء العميل "{{name}}"',
    'clients.form.list.stepTitle': 'إضافة أطباء — {{name}}',
    'clients.form.list.stepTitleLab': 'إضافة جهات اتصال مختبر — {{name}}',
    'clients.form.list.stepHelp': 'أضف طبيبًا أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.stepHelpLab': 'أضف جهة اتصال أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.addAnother': 'إضافة طبيب آخر',
    'clients.form.list.addAnotherLab': 'إضافة جهة اتصال أخرى',
    'clients.form.list.saveContacts': 'حفظ الأطباء',
    'clients.form.list.saveContactsLab': 'حفظ جهات اتصال المختبر',
    'clients.form.list.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء بعض الأطباء. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء بعض جهات الاتصال. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.done': 'تم',
    'clients.type.clinic': 'عيادة',
    'clients.type.hospital': 'مستشفى',
    'clients.type.lab': 'معمل',
    'clients.wallet.title': 'محفظة العميل',
    'clients.tabs.overview': 'نظرة عامة',
    'clients.tabs.wallet': 'المحفظة',
    'clients.tabs.deliveryCenters': 'مراكز التوصيل',
    'clients.tabs.dentists': 'الأطباء',
    'clients.tabs.labContacts': 'جهات اتصال المختبر',
    'clients.tabs.customPrices': 'الأسعار المخصوصة',
    'clients.wallet.balance': 'الرصيد',
    'clients.wallet.recharge': 'إعادة الشحن',
    'clients.wallet.amount': 'المبلغ',
    'clients.wallet.amountPlaceholder': 'أدخل المبلغ',
    'clients.wallet.notes': 'ملاحظات',
    'clients.wallet.notesPlaceholder': 'ملاحظات اختيارية لعملية الشحن',
    'clients.wallet.rechargeSuccess': 'تم شحن المحفظة بنجاح',
    'clients.wallet.rechargeError': 'فشل في شحن المحفظة',
    'clients.wallet.amountRequired': 'المبلغ مطلوب',
    'clients.wallet.amountMin': 'يجب أن يكون المبلغ 0.01 على الأقل',
    'clients.wallet.paymentMethod': 'طريقة الدفع',
    'clients.wallet.paymentMethodPlaceholder': 'اختر طريقة الدفع',
    'clients.wallet.attachments': 'المرفقات',
    'clients.wallet.uploadImage': 'رفع صورة',
    'clients.wallet.history': 'سجل المحفظة',
    'clients.wallet.historyDate': 'التاريخ',
    'clients.wallet.transactionType': 'النوع',
    'sidebar.clients': 'العملاء والأطباء',
    'sidebar.wallets': 'المحافظ',
    'wallets.title': 'المحافظ',
    'wallets.column.walletId': 'رقم المحفظة',
    'wallets.column.clientName': 'اسم العميل',
    'wallets.column.balance': 'الرصيد',
    'wallets.viewTitle': 'المحفظة #{{id}}',
    'wallets.backToList': 'العودة إلى المعاملات',
    'wallets.openClient': 'إعدادت العميل',
    'wallets.walletIdLabel': 'رقم المحفظة',
    'wallets.alert.noAccess': 'ليس لديك صلاحية لعرض المحافظ.',

    'colors.table.name': 'اللون',
    'colors.table.actions': 'العمليات',
    'colors.button.add': 'إضافة لون',
    'colors.modal.title': 'الألوان',
    'colors.confirm.deleteTitle': 'حذف لون',
    'colors.confirm.deleteMessage': 'هل تريد حذف هذا اللون؟',
    'colors.search.placeholder': 'بحث باسم اللون',
    'colors.form.code.placeholder': 'ادخل الكود',
    'colors.form.preview.label': 'معاينة لون السن',
    'colors.alert.noAccess': 'ليس لديك صلاحية لعرض الألوان.',

    'dentists.label.singular': 'طبيب أسنان',
    'dentists.label.singular.lab': 'جهة اتصال المختبر',
    'dentists.label.plural': 'الأطباء',
    'dentists.label.plural.lab': 'جهات اتصال المختبر',
    'dentists.table.name': 'اسم الطبيب',
    'dentists.table.username': 'اسم المستخدم',
    'dentists.table.email': 'البريد الإلكتروني',
    'dentists.table.address': 'العنوان',
    'dentists.table.phone': 'رقم التليفون',
    'dentists.table.whatsapp': 'رقم الواتساب',
    'dentists.table.client': 'العميل',
    'dentists.table.accountRole': 'الحساب',
    'dentists.table.accountRoleMain': 'رئيسي',
    'dentists.table.accountRoleSub': 'فرعي',
    'dentists.table.noClient': 'بدون عميل',
    'dentists.table.actions': 'العمليات',
    'dentists.filter.title': 'تصفية الأطباء',
    'dentists.filter.titleLab': 'تصفية جهات اتصال المختبر',
    'dentists.filter.active': 'مفعل',
    'dentists.button.add': 'إضافة طبيب أسنان',
    'dentists.button.addLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.modal.title': 'الأطباء',
    'dentists.modal.titleLabContact': 'جهات اتصال المختبر',
    'dentists.confirm.deleteTitle': 'حذف طبيب',
    'dentists.confirm.deleteMessage': 'هل تريد حذف هذا الطبيب؟',
    'dentists.confirm.removeTitle': 'إزالة الطبيب',
    'dentists.confirm.removeMessage': 'سيتم فصل هذا الطبيب عن هذا العميل وإلغاء تفعيله.',
    'dentists.confirm.deleteTitleLabContact': 'حذف جهة اتصال المختبر',
    'dentists.confirm.deleteMessageLabContact': 'هل تريد حذف جهة اتصال المختبر هذه؟',
    'dentists.confirm.removeTitleLabContact': 'إزالة جهة اتصال المختبر',
    'dentists.confirm.removeMessageLabContact': 'سيتم فصل جهة اتصال المختبر عن هذا العميل وإلغاء تفعيلها.',
    'dentists.form.accountRole.label': 'نوع الحساب',
    'dentists.form.accountRole.main': 'حساب رئيسي',
    'dentists.form.accountRole.sub': 'حساب فرعي',
    'dentists.form.accountRole.hint': 'الحساب الرئيسي يمكنه الوصول إلى كل موارد العميل. الحساب الفرعي يصل فقط إلى طلباته وملفه الشخصي.',
    'dentists.form.accountRole.labLocked': 'جهات اتصال المختبر تكون دائماً حسابات رئيسية.',
    'dentists.form.client.label': 'العميل',
    'dentists.form.client.placeholder': 'اختر أو أضف عميلًا',
    'dentists.alert.noAccess': 'ليس لديك صلاحية لعرض الأطباء.',
    'dentists.alert.noDentistType': 'نوع مستخدم الطبيب غير متوفر، يرجى مراجعة الإعدادات.',
    'dentists.changeHistory': 'سجل التغييرات',
    'dentists.versions.title': 'سجل تغييرات الطبيب',
    'dentists.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'dentists.versions.timelineTitle': 'الخط الزمني',
    'dentists.versions.by': 'تم التحديث بواسطة',
    'dentists.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'dentists.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'dentists.versions.selectVersion': 'اختر إصدارًا',
    'dentists.versions.noFields': 'لا توجد حقول تغيّرت',
    'dentists.versions.before': 'قبل',
    'dentists.versions.after': 'بعد (الحالية)',

    'expenses.table.expenseType': 'بند المصروفات',
    'expenses.table.cost': 'التكلفة',
    'expenses.table.date': 'التاريخ',
    'expenses.table.notes': 'ملاحظات',
    'expenses.table.assignedUser': 'مُعيَّن إلى',
    'expenses.table.actions': 'العمليات',
    'expenses.button.add': 'إضافة مصروف',
    'expenses.modal.title': 'إعدادت المصروفات',
    'expenses.confirm.deleteTitle': 'حذف مصروف',
    'expenses.confirm.deleteMessage': 'هل تريد حذف هذا المصروف؟',
    'expenses.form.type.label': 'بند المصروفات',
    'expenses.form.expense_type_id': 'نوع المصروف',
    'expenses.form.type.placeholder': 'اختر بند المصروفات',
    'expenses.form.type.required': 'من فضلك اختر بند المصروفات',
    'expenses.form.cost.label': 'التكلفة',
    'expenses.form.cost.placeholder': '٠',
    'expenses.form.cost.required': 'من فضلك ادخل التكلفة',
    'expenses.form.notes.label': 'ملاحظات',
    'expenses.form.notes.placeholder': 'ادخل الملاحظات',
    'expenses.form.assignedUser.label': 'المستخدم المعيّن',
    'expenses.form.assignedUser.placeholder': 'اختر مندوب توصيل أو فني أو مسؤول',
    'expenses.form.assignedUser.unassigned': 'غير معيّن',
    'expenses.search.notesPlaceholder': 'ابحث بالملاحظات',
    'expenses.filter.assignedUser.placeholder': 'تصفية حسب المستخدم المعيّن',
    'expenses.alert.noAccess': 'ليس لديك صلاحية لعرض المصروفات.',

    'expenseTypes.table.name': 'اسم البند',
    'expenseTypes.table.description': 'الوصف',
    'expenseTypes.table.actions': 'العمليات',
    'expenseTypes.button.add': 'إضافة بند مصروف',
    'expenseTypes.modal.title': 'إعدادت بنود المصروفات',
    'expenseTypes.confirm.deleteTitle': 'حذف بند',
    'expenseTypes.confirm.deleteMessage': 'هل تريد حذف هذا البند؟',
    'expenseTypes.form.name.label': 'اسم البند',
    'expenseTypes.form.name.placeholder': 'ادخل اسم البند',
    'expenseTypes.form.name.required': 'من فضلك ادخل اسم البند',
    'expenseTypes.form.description.label': 'وصف البند',
    'expenseTypes.form.description.placeholder': 'ادخل وصف البند',
    'expenseTypes.search.namePlaceholder': 'ابحث بالاسم',
    'expenseTypes.search.descriptionPlaceholder': 'ابحث بالوصف',
    'expenseTypes.alert.noAccess': 'ليس لديك صلاحية لعرض بنود المصروفات.',

    'orders.header.title': 'الطلبات',
    'orders.header.subtitle': 'متابعة طلبات المعمل ومراحل الإنتاج وجداول التسليم',
    'orders.search.placeholder': 'بحث باسم المريض أو رقم الطلب أو المرجع',
    'orders.filter.title': 'تصفية الطلبات',
    'orders.filter.clear': 'إعادة تعيين عوامل التصفية',
    'orders.filter.active': 'مفعل',
    'orders.table.refresh': 'تحديث',
    'orders.table.notInvoiced': 'غير مفوتر',
    'orders.table.id': 'رقم الطلب',
    'orders.table.patientName': 'اسم المريض',
    'orders.table.client': 'العميل',
    'orders.table.invoice': 'الفاتورة',
    'orders.table.dentistName': 'اسم الطبيب',
    'orders.table.color': 'اللون',
    'orders.table.formulaType': 'نوع التركيبة',
    'orders.table.total': 'إجمالي التكلفة',
    'orders.table.paid': 'المدفوع',
    'orders.table.remaining': 'المتبقي',
    'orders.table.paymentStatus': 'حالة الدفع',
    'orders.table.status': 'حالة الطلب',
    'orders.table.delivery': 'التوصيل',
    'orders.table.createdAt': 'تاريخ التسجيل',
    'orders.table.requestedAt': 'تاريخ الطلب',
    'orders.table.deliveredAt': 'تم التسليم',
    'orders.table.units': 'عدد الوحدات',
    'orders.table.actions': 'العمليات',
    'orders.table.technician': 'الفني',
    'orders.table.courier': 'المندوب',
    'orders.status.delivered': 'تم التوصيل',
    'orders.status.pendingDelivery': 'لم يتم التوصيل',
    'orders.status.paid': 'مدفوع',
    'orders.status.unpaid': 'غيرمدفوع',
    'orders.status.unknown': 'غير محدد',
    'orders.form.patientName.label': 'اسم المريض',
    'orders.form.patientName.placeholder': 'ادخل اسم المريض',
    'orders.form.patientName.required': 'من فضلك ادخال اسم المريض',
    'orders.form.dentist.label': 'اسم طبيب الأسنان',
    'orders.form.dentist.placeholder': 'اختر أو أضف طبيبًا',
    'orders.form.dentist.required': 'من فضلك اختر الطبيب',
    'orders.form.dentist.clientRequired': 'من فضلك اختر العميل أولاً لاختيار الطبيب.',
    'orders.form.dentist.labelLabContact': 'جهة اتصال المختبر',
    'orders.form.dentist.placeholderLabContact': 'اختر أو أضف جهة اتصال مختبر',
    'orders.form.dentist.requiredLabContact': 'من فضلك اختر جهة اتصال المختبر',
    'orders.form.dentist.clientRequiredLabContact': 'من فضلك اختر العميل أولاً لاختيار جهة اتصال المختبر.',
    'orders.form.client.label': 'اختر العميل',
    'orders.form.client.placeholder': 'اختر أو أضف عميلًا',
    'orders.form.client.required': 'من فضلك اختر العميل',
    'orders.form.color.label': 'اختار اللون',
    'orders.form.color.defaultLabel': 'اللون الافتراضي (لل وحدات الجديدة)',
    'orders.form.color.defaultHelp': 'يُطبق عند إضافة وحدة جديدة',
    'orders.form.color.placeholder': 'اختر أو أضف لونًا',
    'orders.form.color.required': 'من فضلك اختر اللون',
    'orders.form.unitColors.label': 'لون لكل وحدة',
    'orders.form.formulaType.defaultLabel': 'نوع التركيبة الافتراضي (للوحدات الجديدة)',
    'orders.form.formulaType.defaultHelp': 'تطبق عند إضافة وحدة جديدة',
    'orders.form.unitFormulaTypes.label': 'نوع التركيبة لكل وحدة',
    'orders.form.unitPriceOverride.placeholder': 'تخصيص سعر الوحدة',
    'orders.form.discountAmount.label': 'خصم الطلب (مبلغ)',
    'orders.form.discountAmount.help': 'يُخصم هذا المبلغ من المجموع الفرعي للطلب.',
    'orders.form.discountAmount.placeholder': '٠',
    'orders.form.formulaType.label': 'نوع التركيبة',
    'orders.form.formulaType.placeholder': 'اختر نوع التركيبة',
    'orders.form.formulaType.required': 'من فضلك اختر نوع التركيبة',
    'orders.form.requestedAt.label': 'تاريخ الطلب',
    'orders.form.requestedAt.placeholder': 'اختر التاريخ',
    'orders.form.issueDate.label': 'تاريخ الإصدار',
    'orders.form.issueDate.placeholder': 'اختر التاريخ',
    'orders.form.deliveryDate.label': 'تاريخ التسليم',
    'orders.form.deliveryDate.placeholder': 'اختر التاريخ',
    'orders.form.additionalCostItems.title': 'بنود تكلفة إضافية',
    'orders.form.additionalCostItems.help': 'أضف رسوماً إضافية (مثل أولوية، درجة لون خاصة). لكل بند وصف ومبلغ.',
    'orders.form.additionalCostItems.labelPlaceholder': 'وصف البند',
    'orders.form.additionalCostItems.amountPlaceholder': 'التكلفة',
    'orders.form.additionalCostItems.add': 'إضافة بند تكلفة',
    'orders.form.additionalCostItems.remove': 'حذف',
    'orders.form.additionalCostItems.labelRequired': 'أدخل وصف البند',
    'orders.form.additionalCostItems.amountRequired': 'أدخل مبلغ التكلفة',
    'orders.summary.additionalCostsTitle': 'تكاليف إضافية',
    'orders.summary.additionalCostItemFallback': 'بند إضافي',
    'orders.summary.additionalCosts': 'إجمالي التكاليف الإضافية',
    'orders.form.notes.label': 'ملاحظات',
    'orders.form.notes.placeholder': 'ملاحظات',
    'orders.form.technician.label': 'الفنيين',
    'orders.form.technician.placeholder': 'اختر فنيين',
    'orders.form.technician.required': 'من فضلك اختر فنيًا واحدًا على الأقل',
    'orders.form.selectUnits.label': 'اختر الوحدات',
    'orders.form.selectUnits.required': 'من فضلك اختر وحدة واحدة على الأقل',
    'orders.form.orderFormulas.title': 'تركيبات الطلب',
    'orders.form.orderFormulas.help': 'يمكن أن يتضمن الطلب عدة تركيبات. في كل سطر، اختر أولًا نوع التركيبة ثم الوحدات (الأسنان لنطاق الوحدة، أو الفك العلوي و/أو السفلي لنطاق الفك). تُعرض فقط أنواع الوحدات المطابقة لنوع التركيبة.',
    'orders.form.orderFormulas.lineTitle': 'تركيبة {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'رقم التركيبة',
    'orders.form.orderFormulas.material': 'المادة',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.stepFormulaType': 'الخطوة 1: نوع التركيبة',
    'orders.form.orderFormulas.colorLabel': 'اللون (لهذه التركيبة)',
    'orders.form.orderFormulas.stepUnits': 'الخطوة 2: الوحدات',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'اختر نوع التركيبة أولًا',
    'orders.form.orderFormulas.addLine': 'إضافة تركيبة أخرى',
    'orders.form.orderFormulas.removeLine': 'إزالة هذه التركيبة',
    'orders.form.orderFormulas.formulaType': 'نوع التركيبة',
    'orders.form.orderFormulas.selectUnits': 'الأسنان / الوحدات',
    'orders.form.orderFormulas.archChoice': 'الفك',
    'orders.form.orderFormulas.archUpper': 'الفك العلوي',
    'orders.form.orderFormulas.archLower': 'الفك السفلي',
    'orders.form.orderFormulas.pickTypeFirst': 'اختر نوع التركيبة لتحميل الوحدات المطابقة.',
    'orders.form.orderFormulas.required': 'أضف سطر تركيبة واحد على الأقل مع النوع والوحدات المختارة.',
    'orders.form.orderFormulas.incompleteLine': 'يجب أن يتضمن كل سطر تركيبة مع نوع مختار وحدة واحدة على الأقل (سن أو فك).',
    'orders.form.orderFormulas.duplicateFormulaType': 'يمكنك إضافة سطر واحد فقط لكل نوع تركيبة في الطلب.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'يجب أن يكون لكل وحدة مختارة نوع تركيبة قبل الحفظ.',
    'orders.form.orderFormulas.summaryUnits': 'وحدات هذا الطلب',
    'orders.form.persistedFormulas.title': 'تركيبات هذا الطلب',
    'orders.form.persistedFormulas.help': 'كل سطر هو تركيبة محفوظة (النوع، الوحدة، واللون). عند التعديل يمكن ضبط نوع التركيبة والأسعار لكل وحدة من الملخص.',
    'orders.form.persistedFormulas.unit': 'الوحدة (FDI)',
    'orders.form.persistedFormulas.color': 'اللون',
    'orders.form.persistedFormulas.detach': 'إزالة من الطلب',
    'orders.form.persistedFormulas.detachConfirm': 'إزالة سطر التركيبة هذا من الطلب؟ ستفقد الأسنان المرتبطة هذه التركيبة حتى تضيف سطرًا جديدًا أو تضبط الأنواع من الملخص.',
    'orders.form.persistedFormulas.detachSuccess': 'تمت إزالة سطر التركيبة من الطلب.',
    'orders.form.persistedFormulas.detachError': 'تعذرت إزالة سطر التركيبة. حاول مرة أخرى.',
    'orders.form.toothPreview.title': 'معاينة الأسنان',
    'orders.form.toothPreview.help': 'نفس مخطط الأسنان كما في إنشاء الطلب. عند التعديل، انقر الأسنان لتغيير الاختيار ثم احفظ.',
    'toothPicker.selectUpper': 'اختيار الفك العلوي',
    'toothPicker.selectLower': 'اختيار الفك السفلي',
    'toothPicker.clear': 'مسح',
    'orders.form.deliveryCenter.label': 'مركز التسليم',
    'orders.form.deliveryCenter.placeholder': 'اختر أو أضف مركز تسليم',
    'orders.form.deliveryCenter.required': 'من فضلك اختر مركز تسليم',
    'orders.form.deliveryCenter.clientRequired': 'من فضلك اختر العميل أولاً لاختيار مركز التسليم.',
    'orders.form.deliveryType.label': 'نوع التوصيل',
    'orders.form.deliveryType.placeholder': 'اختر نوع التوصيل',
    'orders.form.attachment.label': 'مرفقات',
    'orders.form.attachments.label': 'المرفقات',
    'orders.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'orders.form.attachments.choose': 'اختر ملفات',
    'orders.form.attachments.existing': 'المرفقات الموجودة:',
    'orders.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'orders.form.attachments.empty': 'لا توجد مرفقات',
    'orders.form.attachments.download': 'تنزيل',
    'orders.form.attachments.commentPlaceholder': 'تعليق',
    'orders.form.attachments.col.id': 'المعرف',
    'orders.form.attachments.col.name': 'الاسم',
    'orders.form.attachments.col.url': 'الرابط',
    'orders.form.attachments.col.file': 'الملف',
    'orders.form.attachments.col.comment': 'تعليق',
    'orders.form.attachments.col.preview': 'معاينة',
    'orders.form.attachments.col.download': 'تنزيل',
    'orders.form.attachments.col.delete': 'حذف',
    'orders.form.attachments.col.edit': 'تعديل',
    'orders.form.attachments.edit': 'تعديل',
    'orders.form.attachments.editTitle': 'تعديل المرفق',
    'orders.form.attachments.viewTitle': 'تفاصيل المرفق',
    'orders.form.attachments.namePlaceholder': 'اسم المرفق',
    'orders.form.attachments.replaceFile': 'استبدال الملف',
    'orders.form.attachments.replaceFileHint': 'اتركه فارغًا للاحتفاظ بالملف الحالي.',
    'orders.form.attachments.chooseReplacement': 'اختر ملفًا بديلًا',
    'orders.form.submit.create': 'إنشاء حالة',
    'orders.form.submit.save': 'حفظ التغييرات',
    'orders.create.header.title': 'طلب جديد',
    'orders.create.header.subtitle': 'اختر العميل والطبيب، وأضف تركيبات الطلب، ثم أكّد مواعيد التسليم.',
    'orders.create.header.backToOrders': 'العودة إلى الطلبات',
    'orders.form.section.parties': 'العميل والطبيب',
    'orders.form.section.schedule': 'المريض والمواعيد',
    'orders.form.section.notesAttachments': 'الملاحظات والمرفقات',
    'orders.create.section.primaryTitle': 'تفاصيل الطلب',
    'orders.create.section.secondaryTitle': 'التفاصيل المالية',
    'orders.create.section.secondaryPlaceholder': 'سيتم إضافة هذا القسم لاحقاً.',
    'orders.update.section.primaryTitle': 'تفاصيل الطلب',
    'orders.update.section.secondaryTitle': 'إجراءات الطلب',
    'orders.update.section.secondaryPlaceholder': 'سيتم عرض تفاصيل إضافية عن الطلب هنا قريبًا.',
    'orders.actions.technician.label': 'الفنيين',
    'orders.actions.technician.unassigned': 'غير معين',
    'orders.actions.technician.change': 'تغيير الفنيين',
    'orders.actions.viewInvoice': 'عرض الفاتورة',
    'orders.actions.technician.select': 'اختر فنيين',
    'orders.actions.technician.changeSuccess': 'تم تحديث الفنيين',
    'orders.actions.technician.changeError': 'فشل تحديث الفنيين',
    'orders.actions.courier.label': 'المندوب',
    'orders.actions.courier.unassigned': 'غير معين',
    'orders.actions.courier.change': 'تغيير المندوب',
    'orders.actions.courier.select': 'اختر المندوب',
    'orders.actions.courier.changeSuccess': 'تم تحديث المندوب',
    'orders.actions.courier.changeError': 'فشل تحديث المندوب',
    'orders.actions.courier.unassign': 'إلغاء التعيين',
    'orders.actions.disableClientEdit.label': 'تعطيل تعديل العميل',
    'orders.actions.disableClientEdit.enabled': 'العميل لا يمكنه تعديل هذا الطلب',
    'orders.actions.disableClientEdit.disabled': 'العميل يمكنه تعديل هذا الطلب',
    'orders.actions.disableClientEdit.lockedMessage': 'هذا الطلب مقفل. لا يمكنك تعديله. تواصل مع المختبر إذا احتجت تغييرات.',
    'orders.actions.sharePhasesWithClient.label': 'مشاركة المراحل مع العميل',
    'orders.actions.sharePhasesWithClient.short': 'مشاركة مع العميل',
    'orders.actions.sharePhasesWithClient.enabled': 'يمكن للعميل متابعة مراحل الطلب',
    'orders.actions.sharePhasesWithClient.disabled': 'المراحل مرئية للمعمل فقط',
    'responses.permission.denied': 'ليس لديك صلاحية لإجراء هذا الإجراء.',
    'responses.common.password_reset_link_sent': 'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    'responses.common.password_reset_success': 'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'orders.actions.status.label': 'حالة الطلب',
    'orders.actions.status.change': 'تغيير الحالة',
    'orders.actions.status.changeSuccess': 'تم تحديث الحالة',
    'orders.actions.status.changeError': 'فشل تحديث الحالة',
    'orders.actions.status.cannotCancelPaid': 'لا يمكن تغيير الحالة إلى "ملغى" لأن هناك فاتورة مدفوعة مرتبطة بهذا الطلب.',
    'orders.bulk.status.change': 'تغيير الحالة',
    'orders.bulk.status.title': 'تغيير الحالة ({{count}})',
    'orders.bulk.status.selectPlaceholder': 'اختر الحالة',
    'orders.bulk.status.selectRequired': 'اختر حالة',
    'orders.bulk.status.changeSuccess': 'تم تحديث الحالة لـ {{count}} طلب',
    'orders.bulk.status.partialSuccess': 'تم تحديث {{success}} طلب؛ فشل {{failed}}',
    'orders.bulk.status.noneEligible': 'لا يمكن تغيير حالة أي من الطلبات المحددة.',
    'orders.bulk.status.skipped': 'تم تخطي {{count}} طلب',
    'orders.bulk.attach.cta': 'ربط بفاتورة',
    'orders.bulk.attach.title': 'ربط بفاتورة ({{count}})',
    'orders.bulk.attach.success': 'تم ربط {{count}} طلب بالفاتورة',
    'orders.bulk.attach.sameClientRequired': 'اختر طلبات من نفس العميل للربط بفاتورة واحدة.',
    'orders.bulk.attach.missingClient': 'يجب أن تكون الطلبات المحددة تابعة لعميل.',
    'orders.bulk.attach.noneEligible': 'لا يمكن ربط أي من الطلبات المحددة بفاتورة.',
    'orders.bulk.attach.skipped': 'تم تخطي {{count}} طلب',
    'orders.bulk.attach.loadInvoicesError': 'فشل تحميل الفواتير',
    'orders.actions.downloadWorkCard': 'تنزيل بطاقة العمل',
    'orders.changeHistory': 'سجل التغييرات',
    'orders.comments.title': 'الرسائل',
    'orders.comments.internal.tab': 'داخلي (الفريق)',
    'orders.comments.internal.hint': 'مرئية لفريق المعمل فقط. لا يمكن للعملاء رؤية هذه الرسائل.',
    'orders.comments.external.tab': 'محادثة العميل',
    'orders.comments.external.hint': 'مرئية لأطباء العميل / جهات اتصال المعمل، ومديري المعمل والفنيين المعيّنين.',
    'orders.comments.external.hintClient': 'محادثتك مع المعمل حول هذا الطلب.',
    'orders.comments.empty': 'لا توجد رسائل بعد. ابدأ المحادثة.',
    'orders.comments.placeholder': 'اكتب رسالة… (Ctrl+Enter للإرسال)',
    'orders.comments.send': 'إرسال',
    'orders.comments.edited': 'معدّلة',
    'orders.comments.edit': 'تعديل',
    'orders.comments.delete': 'حذف',
    'orders.comments.save': 'حفظ',
    'orders.comments.deleteConfirm': 'حذف هذه الرسالة؟',
    'orders.comments.sendError': 'فشل إرسال الرسالة',
    'orders.comments.updateError': 'فشل تعديل الرسالة',
    'orders.comments.deleteError': 'فشل حذف الرسالة',
    'orders.comments.loadError': 'فشل تحميل الرسائل',
    'orders.comments.you': 'أنت',
    'orders.comments.role.client': 'العميل',
    'orders.comments.role.admin': 'مدير',
    'orders.comments.role.technician': 'فني',
    'orders.comments.role.courier': 'مندوب توصيل',
    'orders.phases.title': 'المراحل',
    'orders.phases.add': 'إضافة مرحلة',
    'orders.phases.addTitle': 'إضافة مرحلة',
    'orders.phases.editTitle': 'تعديل المرحلة',
    'orders.phases.edit': 'تعديل',
    'orders.phases.delete': 'حذف',
    'orders.phases.save': 'حفظ',
    'orders.phases.empty': 'لا توجد مراحل لهذا الطلب بعد.',
    'orders.phases.noDates': 'لم يتم تحديد تواريخ',
    'orders.phases.deleteConfirm': 'حذف المرحلة "{{title}}"؟',
    'orders.phases.created': 'تمت إضافة المرحلة',
    'orders.phases.updated': 'تم تحديث المرحلة',
    'orders.phases.deleted': 'تم حذف المرحلة',
    'orders.phases.createError': 'فشل إضافة المرحلة',
    'orders.phases.updateError': 'فشل تحديث المرحلة',
    'orders.phases.deleteError': 'فشل حذف المرحلة',
    'orders.phases.loadError': 'فشل تحميل المراحل',
    'orders.phases.type.engine': 'مرحلة أساسية',
    'orders.phases.type.custom': 'مرحلة مخصصة',
    'orders.phases.fields.template': 'البدء من مرحلة قياسية',
    'orders.phases.fields.templateHint': 'اختياري: يملأ العنوان والتفاصيل ويمكنك تعديلها.',
    'orders.phases.fields.templatePlaceholder': 'اختر مرحلة قياسية',
    'orders.phases.fields.title': 'العنوان (إنجليزي)',
    'orders.phases.fields.titleAr': 'العنوان (عربي)',
    'orders.phases.fields.titleRequired': 'يرجى إدخال العنوان',
    'orders.phases.fields.description': 'التفاصيل (إنجليزي)',
    'orders.phases.fields.descriptionAr': 'التفاصيل (عربي)',
    'orders.phases.fields.technician': 'الفني',
    'orders.phases.fields.swap': 'تغيير المرحلة',
    'orders.phases.fields.swapPlaceholder': 'استبدال بمرحلة مطوية',
    'orders.phases.fields.noHiddenPhases': 'جميع المراحل موسّعة',
    'orders.phases.swapped': 'تم تغيير المرحلة',
    'orders.phases.swapError': 'تعذر تغيير المرحلة',
    'orders.phases.visibilityError': 'تعذر تحديث عرض المراحل',
    'orders.phases.fields.dates': 'تاريخ البداية والنهاية',
    'orders.phases.fields.startDate': 'تاريخ البداية',
    'orders.phases.fields.endDate': 'تاريخ النهاية',
    'orders.phases.step': 'الخطوة {{n}}',
    'orders.phases.status.current': 'الحالية',
    'orders.phases.status.done': 'مكتملة',
    'orders.phases.setCurrent': 'تعيين كمرحلة حالية',
    'orders.phases.moveUp': 'نقل لأعلى',
    'orders.phases.moveDown': 'نقل لأسفل',
    'orders.phases.currentSet': 'تم تحديث المرحلة الحالية',
    'orders.phases.currentError': 'فشل تعيين المرحلة الحالية',
    'orders.phases.reorderError': 'فشل تحديث تسلسل المراحل',
    'orders.phases.summary': 'المرحلة الحالية: {{title}} (الخطوة {{n}} من {{total}})',
    'orders.phases.noCurrent': 'لم يتم تعيين مرحلة حالية',
    'orders.phases.completedCount': '{{done}} من {{total}} مكتملة',
    'orders.phases.expand': 'توسيع',
    'orders.phases.collapse': 'طي',
    'orders.phases.collapseAll': 'طي المراحل بعد المرحلة الحالية',
    'orders.versions.title': 'سجل تغييرات الطلب',
    'orders.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'orders.versions.timelineTitle': 'الخط الزمني',
    'orders.versions.by': 'تم التحديث بواسطة',
    'orders.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'orders.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'orders.versions.selectVersion': 'اختر إصدارًا',
    'orders.versions.noFields': 'لا توجد حقول تغيّرت',
    'orders.versions.before': 'قبل',
    'orders.versions.after': 'بعد (الحالية)',
    'orders.versions.unitLabel': 'الوحدة',
    'orders.versions.priceLabel': 'السعر',
    'orders.calendar.title': 'التقويم',
    'orders.calendar.subtitle': 'متابعة تواريخ الطلبات والفواتير عبر عرض الأسبوع والشهر والسنة',
    'orders.calendar.viewList': 'عرض قائمة الطلبات',
    'orders.calendar.more': 'المزيد',
    'orders.calendar.week': 'أسبوع',
    'orders.calendar.month': 'شهر',
    'orders.calendar.year': 'سنة',
    'orders.calendar.ordersCount': 'طلبات',
    'orders.calendar.itemsCount': 'عناصر',
    'orders.calendar.today': 'اليوم',
    'orders.calendar.noOrders': 'لا توجد طلبات',
    'orders.calendar.noItems': 'لا توجد عناصر',
    'orders.calendar.patient': 'المريض',
    'orders.calendar.client': 'العميل',
    'orders.calendar.ref': 'المرجع',
    'orders.calendar.entity.order': 'طلب',
    'orders.calendar.entity.invoice': 'فاتورة',
    'orders.calendar.filter.title': 'عرض في التقويم',
    'orders.calendar.filter.byClientDentist': 'العملاء والأطباء',
    'orders.calendar.filter.orders': 'الطلبات',
    'orders.calendar.filter.invoices': 'الفواتير',
    'orders.calendar.filter.orderDeliveryDate': 'تاريخ التسليم',
    'orders.calendar.filter.orderIssueDate': 'تاريخ الإصدار',
    'orders.calendar.filter.orderRequestedAt': 'تاريخ الطلب',
    'orders.calendar.filter.invoiceIssueDate': 'تاريخ الإصدار',
    'orders.calendar.filter.invoiceDueDate': 'تاريخ الاستحقاق',
    'orders.calendar.weekend': 'أجازة أسبوعية',
    'orders.calendar.vacation': 'إجازة',
    'orders.calendar.legend.closed': 'أيام الإغلاق',

    'vacations.weekend.title': 'أيام أجازة أسبوعية',
    'vacations.weekend.hint': 'اختر أيام الأسبوع التي تُعد نهاية أسبوع. ستظهر مميزة في تقويم الطلبات.',
    'vacations.weekend.save': 'حفظ أيام أجازة أسبوعية',
    'vacations.list.title': 'الأجازات',
    'vacations.list.hint': 'أضف فترات إغلاق المعمل. ستظهر هذه الأيام في التقويم.',
    'vacations.add': 'إضافة إجازة',
    'vacations.edit': 'تعديل إجازة',
    'vacations.table.name': 'الاسم',
    'vacations.table.startsOn': 'من',
    'vacations.table.endsOn': 'إلى',
    'vacations.table.notes': 'ملاحظات',
    'vacations.table.actions': 'إجراءات',
    'vacations.form.name': 'الاسم',
    'vacations.form.nameRequired': 'الاسم مطلوب',
    'vacations.form.namePlaceholder': 'مثال: إجازة العيد',
    'vacations.form.range': 'الفترة',
    'vacations.form.rangeRequired': 'الفترة مطلوبة',
    'vacations.form.notes': 'ملاحظات',
    'vacations.confirm.deleteTitle': 'حذف الإجازة؟',
    'vacations.confirm.deleteMessage': 'لا يمكن التراجع عن هذا الإجراء.',
    'vacations.weekday.sunday': 'الأحد',
    'vacations.weekday.monday': 'الإثنين',
    'vacations.weekday.tuesday': 'الثلاثاء',
    'vacations.weekday.wednesday': 'الأربعاء',
    'vacations.weekday.thursday': 'الخميس',
    'vacations.weekday.friday': 'الجمعة',
    'vacations.weekday.saturday': 'السبت',

    // UI labels for work card modal
    'ui.order.work_card': 'بطاقة العمل',
    'ui.order.order_id': 'رقم الطلب',
    'ui.order.client': 'العميل',
    'ui.order.dentist': 'الطبيب',
    'ui.order.patient': 'المريض',
    'ui.order.formula_type': 'نوع التركيبة',
    'ui.order.formulaType': 'نوع التركيبة',
    'ui.order.color': 'اللون',
    'ui.order.units': 'الوحدات',
    'ui.order.units_positions': 'مواضع الوحدات',
    'ui.order.units_count': 'عدد الوحدات',
    'ui.order.items': 'العناصر',
    'ui.order.unit': 'وحدة',
    'ui.order.no_qr_available': 'لا يوجد QR',
    'ui.order.order_barcode': 'باركود الطلب',
    'ui.order.view_public_note': 'هذه معاينة عامة للطلب. لا يلزم تسجيل دخول.',
    'ui.order.unit_types': 'الوحدات المختارة (حسب الموضع)',
    'ui.order.unit_level': 'المستوى',
    'ui.order.unit_direction': 'الاتجاه',
    'ui.order.unit_order': 'الموضع',
    'ui.order.unit_name': 'النوع',
    'ui.order.tooth_picker': 'محدد الأسنان',
    'ui.order.tooth_previewer': 'عارض الأسنان',
    'ui.order.unit_positions': 'مواضع الوحدات',
    'ui.order.tooth_picker_hint': 'الوحدات المحددة مظللة أدناه',
    'ui.order.note': 'ملاحظة',
    'ui.order.view_title': 'عرض الطلب',
    'ui.order.units_list': 'الوحدات',
    'ui.order.qr': 'QR',
    'ui.order.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.order.switch_to_ar': 'التبديل إلى العربية',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',
    'ui.order.tracking_barcode': 'الباركود والتتبع المعملي',
    'ui.order.scan_instructions': 'امسح الباركود بجهاز المسح أو رمز QR بكاميرا الهاتف لتتبع الطلب.',
    'ui.order.dental_chart': 'مخطط الأسنان (Odontogram)',
    'ui.order.clinical_specifications': 'المواصفات السريرية والتركيبات',
    'ui.order.clinical_notes': 'الملاحظات والتعليمات السريرية',
    'ui.order.no_notes': 'لا توجد ملاحظات سريرية أو تعليمات خاصة مسجلة لهذا الطلب.',
    'ui.order.attachments_title': 'المرفقات والمسوح ثلاثية الأبعاد',
    'ui.order.no_attachments': 'لا توجد ملفات أو مسوح سريرية مرفقة بهذا الطلب.',
    'ui.order.logistics_title': 'التوصيل واللوجستيات',
    'ui.order.linked_invoice': 'الفاتورة المرتبطة',
    'ui.order.view_invoice_action': 'عرض الفاتورة العامة',
    'ui.order.selected_teeth_legend': 'الأسنان المعالجة',
    'ui.order.natural_teeth_legend': 'الأسنان الطبيعية / غير المعالجة',
    'ui.order.qc_signoff': 'مراقبة الجودة واعتماد المعمل',
    'ui.order.qc_passed': 'اجتاز فحص الجودة',
    'ui.order.technician_signature': 'توقيع الفني المسؤول',
    'ui.order.qc_date': 'التاريخ',
    'ui.order.teeth_selected_count': '{{count}} أسنان محددة',
    'ui.order.expected_delivery': 'التسليم المتوقع',
    'ui.order.shade_color': 'درجة الظل / اللون',
    'ui.order.product_type': 'المنتج',
    'ui.order.quadrant_1': 'الربع 1 (علوي يمين)',
    'ui.order.quadrant_2': 'الربع 2 (علوي يسار)',
    'ui.order.quadrant_3': 'الربع 3 (سفلي يسار)',
    'ui.order.quadrant_4': 'الربع 4 (سفلي يمين)',
    'ui.order.scan_modal_title': 'باركود ورمز QR للطلب',
    'ui.order.fullscreen_scan': 'تكبير / مسح',
    'ui.order.download_attachment': 'تحميل',
    'ui.order.preview_attachment': 'معاينة',
    'ui.order.clinic': 'العيادة',
    'ui.order.order_date': 'تاريخ الطلب',
    'ui.order.public_order_disclaimer': 'مواصفات أمر العمل المعملي الرسمية معتمدة للتحقق السريري والمعملي. لا يلزم تسجيل دخول.',
    'ui.order.loading_details': 'جاري تحميل تفاصيل الطلب...',

    // Generic language toggler
    'ui.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.switch_to_ar': 'التبديل إلى العربية',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.order.color_hex': 'رمز اللون',
    'ui.copy_link': 'نسخ الرابط',
    'ui.copy_link_copied': 'تم نسخ الرابط',
    'ui.theme.lightMode': 'الوضع الفاتح',
    'ui.theme.darkMode': 'الوضع الداكن',
    'ui.menu.open': 'فتح القائمة',
    'ui.menu.navigation': 'التنقل',
    'ui.prices.show': 'إظهار الأسعار',
    'ui.prices.hide': 'إخفاء الأسعار',
    'ui.date.startDate': 'تاريخ البداية',
    'ui.date.endDate': 'تاريخ النهاية',

    'cookies.title': 'نستخدم ملفات تعريف الارتباط',
    'cookies.message':
      'نستخدم ملفات تعريف الارتباط لإبقائك مسجّل الدخول، وتذكّر لغتك وتفضيلاتك، وتحسين Dentrist. بالمتابعة فإنك توافق على استخدامنا لملفات تعريف الارتباط.',
    'cookies.accept': 'قبول ملفات تعريف الارتباط',

    'onboarding.menu.start': 'جولة النظام',
    'onboarding.welcome.title': 'مرحبًا بك في Dentrist',
    'onboarding.welcome.description':
      'هذه جولة النظام تمرّ بك على واجهة مساحة العمل وكل صفحة في الشريط الجانبي. يمكنك إعادة تشغيلها في أي وقت من قائمة الملف الشخصي.',
    'onboarding.navigation.title': 'القائمة الرئيسية',
    'onboarding.navigation.description':
      'استخدم الشريط الجانبي لفتح كل الصفحات المتاحة في نظامك. بعد ذلك سنزور كل صفحة منها.',
    'onboarding.controls.title': 'اللغة والمظهر',
    'onboarding.controls.description':
      'بدّل بين العربية والإنجليزية، واختر الوضع الفاتح أو الداكن لمساحة العمل.',
    'onboarding.account.title': 'الحساب والتنبيهات',
    'onboarding.account.description':
      'راجع الإشعارات، أظهر أو أخفِ الأسعار، افتح ملفك الشخصي، أو أعد تشغيل هذه الجولة من قائمة المستخدم.',
    'onboarding.workspace.title': 'مساحة العمل',
    'onboarding.workspace.description':
      'هنا تظهر لوحات المعلومات والقوائم والنماذج. ابدأ من الصفحة الرئيسية لمتابعة نشاط معملك بسرعة.',
    'onboarding.pages.title': 'صفحات النظام',
    'onboarding.pages.description':
      'سنفتح الآن كل صفحة مدرجة في نظامك حتى تعرف أين توجد كل أداة.',
    'onboarding.page.description':
      'هذه صفحة {{page}}. يمكنك فتحها في أي وقت من الشريط الجانبي لمتابعة عملك هنا.',
    'onboarding.finish.title': 'أنت جاهز',
    'onboarding.finish.description':
      'بهذا تكون قد مررت على كل صفحات نظامك. أعد تشغيل هذه الجولة في أي وقت من قائمة الملف الشخصي.',

    'userTypes.dentist': 'طبيب أسنان',
    'userTypes.lab_contact': 'جهة اتصال المختبر',
    'userTypes.technician': 'فني',
    'userTypes.courier': 'مندوب',
    'userTypes.admin': 'مدير',

    'deliveryTypes.standard_delivery': 'التوصيل العادي',
    'deliveryTypes.free_delivery': 'التوصيل المجاني',

    'orders.summary.title': 'ملخص الطلب',

    // General UI
    'common.print': 'طباعة',
    'common.openNew': 'فتح في صفحة جديدة',
    'common.copy': 'نسخ',
    'common.copied': 'تم النسخ',
    'common.save': 'حفظ',
    'common.updated': 'تم التحديث',
    'common.active': 'نشط',
    'common.status': 'الحالة',
    'common.inactive': 'غير نشط',
    'common.export': 'تصدير',
    'common.export.csv': 'تصدير CSV',
    'common.export.excel': 'تصدير Excel',
    'common.export.pdf': 'تصدير PDF',
    'common.export.selectedCount': '{{count}} محدد',
    'common.export.error': 'فشل التصدير',
    'common.export.entity.orders': 'الطلبات',
    'common.export.entity.invoices': 'الفواتير',
    'common.export.entity.clients': 'العملاء',
    'common.export.entity.users': 'المستخدمون',
    'orders.summary.itemsLabel': 'العناصر',
    'orders.summary.subtotal': 'المجموع الفرعي',
    'orders.summary.discountDentistFormulaType': 'خصم الطبيب حسب نوع التركيبة',
    'orders.summary.discountClientFormulaType': 'خصم العميل حسب نوع التركيبة',
    'orders.summary.discountUnitOverride': 'خصم تعديل سعر الوحدة',
    'orders.summary.discountOrderAmount': 'خصم الطلب',
    'orders.summary.totalDiscount': 'إجمالي الخصم',
    'orders.actions.createWorkCard': 'بطاقة العمل',
    'orders.actions.workCardCreated': 'تم إنشاء بطاقة العمل',
    'orders.summary.vat': 'الضريبة ({{percent}}%)',
    'orders.summary.delivery': 'تكلفة التوصيل',
    'orders.summary.deliveryCenter': 'مركز التسليم',
    'orders.summary.noDeliveryCenter': 'لا يوجد مركز تسليم',
    'orders.summary.total': 'الإجمالي',
    'orders.summary.noFormulaType': 'لا يوجد نوع تركيبة محدد',
    'orders.summary.formulaType': 'نوع التركيبة',
    'orders.summary.unitUnknown': 'وحدة',
    'orders.summary.noUnits': 'لا توجد وحدات',
    'orders.summary.color': 'اللون',
    'orders.summary.noColor': '—',
    'orders.summary.unitLabel': 'الوحدة',
    'orders.summary.price': 'السعر',
    'orders.summary.formulaLineTitle': 'التركيبة {{n}}',
    'orders.summary.pricePerUnit': 'السعر لكل وحدة',
    'orders.summary.unitsCount': 'عدد الوحدات',
    'orders.summary.formulaLineTotal': 'سعر التركيبة',
    'orders.summary.vatLabel': 'الضريبة',
    'orders.summary.deliveryLabel': 'تكلفة التوصيل',
    'orders.summary.deliveryLabelWithType': 'تكلفة التوصيل ({type})',
    'orders.summary.free': 'مجاني',
    'orders.orderStatus.requested': 'تم الطلب',
    'orders.orderStatus.review': 'قيد المراجعة',
    'orders.orderStatus.tx-review': 'مراجعة الخطة العلاجية',
    'orders.orderStatus.tx-approved': 'تم اعتماد الخطة',
    'orders.orderStatus.tx-replan': 'إعادة التخطيط',
    'orders.orderStatus.in-progress': 'قيد التنفيذ',
    'orders.orderStatus.in-delivery': 'قيد التسليم',
    'orders.orderStatus.delivered': 'تم التسليم',
    'orders.orderStatus.finished': 'مكتمل',
    'orders.orderStatus.cancelled': 'ملغي',
    'orders.orderStatus.dispute': 'نزاع',
    'orders.orderStatus.on-hold': 'معلق',
    'orders.paymentStatus.draft': 'مسودة',

    'orders.paymentStatus.unpaid': 'غيرمدفوع',
    'orders.paymentStatus.paid': 'مدفوع',
    'orders.paymentStatus.void': 'ملغى',
    'orders.button.add': 'إضافة طلب',
    'orders.button.create': 'إنشاء طلب',
    'orders.empty.noOrdersYet': 'لا توجد حالات بعد',
    'orders.empty.noneMatchFilters': 'لا توجد حالات تطابق المرشحات الحالية. جرّب تغيير حالة الدفع أو المرشحات الأخرى.',
    'orders.button.cancel': 'إلغاء',
    'orders.confirm.cancelTitle': 'إلغاء الطلب',
    'orders.confirm.cancelMessage': 'هل تريد بالتأكيد إلغاء هذا الطلب؟ سيتم تحويله إلى مسودة وفصله عن الفواتير.',
    'orders.confirm.cancelSuccess': 'تم إلغاء الطلب',
    'orders.confirm.cancelError': 'فشل إلغاء الطلب',
    'orders.button.viewEdit': 'عرض | تعديل',
    'orders.button.view': 'عرض',
    'orders.confirm.deleteTitle': 'حذف حالة',
    'orders.confirm.deleteMessage': 'هل تريد حذف هذه الحالة؟',
    'orders.update.collectPayment': 'تحصيل الحساب',
    'orders.update.refundPayment': 'إرجاع الحساب',
    'orders.update.markDelivered': 'توصيل',
    'orders.update.invoiceButton': 'الفاتورة',
    'orders.alert.noAccess': 'ليس لديك صلاحية لعرض الحالات.',
    'orders.alert.noCreate': 'ليس لديك صلاحية لإضافة حالات.',
    'orders.alert.dentistNoClient': 'حسابك غير مرتبط بعميل. يرجى التواصل مع مسؤول المختبر قبل إنشاء الحالات.',
    'orders.alert.noView': 'ليس لديك صلاحية لعرض هذه الحالة.',
    'orders.alert.editBlocked': 'لا يمكن تعديل تفاصيل الطلب لأنه مكتمل أو مسلّم أو مرتبط بفاتورة. لا يزال بإمكانك تحديث الفني والمندوب والحالة عند السماح بذلك.',
    'colors.form.name.label': 'اسم اللون',
    'colors.form.name.placeholder': 'ادخل اسم اللون',
    'colors.form.name.required': 'من فضلك ادخل اسم اللون',
    'colors.form.name.max': 'يجب ألا يزيد اسم اللون عن 255 حرفًا',
    'colors.form.code.label': 'رمز اللون',
    'colors.form.code.required': 'اللون مطلوب.',
    'colors.quickCreate.title': 'إضافة لون',
    'colors.quickCreate.button': 'إضافة لون جديد',
    'colors.quickCreate.errorFallback': 'تعذر إضافة اللون، حاول مرة أخرى.',
    'dentists.quickCreate.title': 'إضافة طبيب',
    'dentists.quickCreate.button': 'إضافة طبيب جديد',
    'dentists.quickCreate.errorFallback': 'تعذر إضافة الطبيب، حاول مرة أخرى.',
    'dentists.quickCreate.missingType': 'تعذر تحديد نوع مستخدم الطبيب، يرجى إعادة التحميل والمحاولة.',
    'dentists.quickCreate.titleLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.quickCreate.buttonLabContact': 'إضافة جهة اتصال مختبر جديدة',
    'dentists.quickCreate.errorFallbackLabContact': 'تعذر إضافة جهة اتصال المختبر، حاول مرة أخرى.',
    'dentists.form.name.label': 'اسم الطبيب',
    'dentists.form.name.placeholder': 'ادخل اسم الطبيب',
    'dentists.form.name.required': 'من فضلك ادخل اسم الطبيب',
    'dentists.form.name.labelLabContact': 'اسم جهة اتصال المختبر',
    'dentists.form.name.placeholderLabContact': 'ادخل اسم جهة اتصال المختبر',
    'dentists.form.name.requiredLabContact': 'من فضلك ادخل اسم جهة اتصال المختبر',
    'dentists.form.email.label': 'البريد الإلكتروني',
    'dentists.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'dentists.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'dentists.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'dentists.form.username.label': 'اسم المستخدم',
    'dentists.form.username.placeholder': 'ادخل اسم المستخدم',
    'dentists.form.username.hint': 'مطلوب إذا لم يكن للطبيب بريد إلكتروني',
    'dentists.form.password.label': 'كلمة المرور',
    'dentists.form.password.placeholder': 'ادخل كلمة المرور',
    'dentists.form.password.required': 'من فضلك ادخل كلمة المرور',
    'dentists.form.password.min': 'يجب ألا تقل كلمة المرور عن 6 أحرف',
    'dentists.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'dentists.form.phone.label': 'رقم الهاتف',
    'dentists.form.phone.placeholder': 'ادخل رقم الهاتف',
    'dentists.form.whatsapp.label': 'رقم الواتساب',
    'dentists.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'dentists.form.address.label': 'العنوان',
    'dentists.form.address.placeholder': 'ادخل العنوان',

    // Transactions
    'transactions.table.type': 'النوع',
    'transactions.table.reference': 'المرجع',
    'transactions.table.amount': 'القيمة',
    'transactions.table.notes': 'ملاحظات',
    'transactions.table.createdAt': 'تاريخ الإنشاء',
    'transactions.types.invoice': 'فاتورة',
    'transactions.types.expense': 'مصروف',
    'transactions.types.wallet_recharge': 'شحن المحفظة',
    'transactions.types.wallet': 'المحفظة',
    'transactions.types.wallet_deduction': 'خصم من المحفظة',
    'transactions.types.invoice_refund': 'استرداد الفاتورة',
    'transactions.alert.noAccess': 'ليست لديك صلاحية لعرض المعاملات.',

    'formulaTypes.table.name': 'الاسم',
    'formulaTypes.search.placeholder': 'بحث بالاسم',
    'formulaTypes.search.descriptionPlaceholder': 'بحث بالوصف',
    'formulaTypes.filter.unit.placeholder': 'فرز حسب الوحدة أو الفك',
    'formulaTypes.table.cost': 'التكلفة لكل وحدة',
    'formulaTypes.table.description': 'الوصف',
    'formulaTypes.table.actions': 'العمليات',
    'formulaTypes.button.add': 'إضافة نوع تركيبة',
    'formulaTypes.modal.title': 'أنواع التركيبات',
    'formulaTypes.confirm.deleteTitle': 'حذف نوع تركيبة',
    'formulaTypes.alert.noAccess': 'ليس لديك صلاحية لعرض أنواع التركيبات.',
    'formulaTypes.confirm.deleteMessage': 'هل تريد حذف نوع التركيبة هذا؟',
    'formulaTypes.form.name.label': 'اسم التركيبة',
    'formulaTypes.form.name.placeholder': 'ادخل اسم التركيبة',
    'formulaTypes.form.name.required': 'من فضلك ادخل اسم التركيبة',
    'formulaTypes.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'formulaTypes.form.cost.label': 'التكلفة لكل وحدة',
    'formulaTypes.form.cost.placeholder': '٠',
    'formulaTypes.form.cost.required': 'من فضلك ادخل التكلفة',
    'formulaTypes.form.purchasePrice.label': 'سعر الشراء',
    'formulaTypes.form.purchasePrice.placeholder': '٠',
    'formulaTypes.form.purchasePrice.required': 'من فضلك ادخل سعر الشراء',
    'formulaTypes.form.sellingPrice.label': 'سعر البيع',
    'formulaTypes.form.sellingPrice.placeholder': '٠',
    'formulaTypes.form.sellingPrice.required': 'من فضلك ادخل سعر البيع',
    'formulaTypes.form.technicianCost.label': 'تكلفة الفني',
    'formulaTypes.form.technicianCost.placeholder': '٠',
    'formulaTypes.form.technicianCost.required': 'من فضلك ادخل تكلفة الفني',
    'formulaTypes.form.scope.label': 'النطاق',
    'formulaTypes.form.scope.placeholder': 'وحدة أو فك',
    'formulaTypes.form.scope.required': 'من فضلك اختر وحدة أو فك',
    'formulaTypes.scope.unit': 'وحدة',
    'formulaTypes.scope.arch': 'فك',
    'formulaTypes.table.purchasePrice': 'سعر الشراء',
    'formulaTypes.table.sellingPrice': 'سعر البيع',
    'formulaTypes.table.technicianCost': 'تكلفة الفني',
    'formulaTypes.table.scope': 'وحدة / فك',
    'formulaTypes.table.material': 'المادة',
    'formulaTypes.form.description.label': 'وصف التركيبة',
    'formulaTypes.form.description.placeholder': 'ادخل وصف التركيبة',
    'formulaTypes.form.material.label': 'المادة (مكوّن)',
    'formulaTypes.form.material.placeholder': 'اكتب المواد كنص (مفصولة بفاصلة)، مثل: زيركونيا، PMMA',
    'formulaTypes.form.attachments.label': 'المرفقات',
    'formulaTypes.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'formulaTypes.form.attachments.choose': 'اختر ملفات',
    'formulaTypes.form.attachments.existing': 'المرفقات الموجودة:',
    'formulaTypes.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'formulaTypes.attachment.deleted': 'تم حذف المرفق',
    'formulaTypes.attachment.deleteError': 'فشل حذف المرفق',
    'formulaTypes.quickCreate.title': 'إضافة نوع تركيبة',
    'formulaTypes.quickCreate.button': 'إضافة نوع تركيبة جديد',
    'deliveryCenters.quickCreate.title': 'إضافة مركز تسليم',
    'deliveryCenters.quickCreate.button': 'إضافة مركز تسليم جديد',
    'deliveryCenters.quickCreate.errorFallback': 'تعذر إضافة مركز التسليم، حاول مرة أخرى.',
    'deliveryCenters.form.name.label': 'اسم مركز التسليم',
    'deliveryCenters.form.name.placeholder': 'ادخل اسم مركز التسليم',
    'deliveryCenters.form.name.required': 'من فضلك ادخل اسم مركز التسليم',
    'deliveryCenters.form.address.label': 'العنوان',
    'deliveryCenters.form.address.placeholder': 'ادخل العنوان',
    'deliveryCenters.form.phone.label': 'رقم الهاتف',
    'deliveryCenters.form.phone.placeholder': 'ادخل رقم الهاتف',
    'deliveryCenters.form.whatsapp.label': 'رقم الواتساب',
    'deliveryCenters.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'deliveryCenters.form.email.label': 'البريد الإلكتروني',
    'deliveryCenters.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'deliveryCenters.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'deliveryCenters.form.notes.label': 'ملاحظات',
    'deliveryCenters.form.notes.placeholder': 'أضف ملاحظات (اختياري)',

    'lab.title': 'معلومات المعمل',
    'lab.subtitle': 'عرض وتحديث بيانات المعمل ووسائل التواصل والشعار',
    'lab.delivery.subtitle': 'ضبط أنواع التوصيل والمبالغ والخيار الافتراضي للطلبات',
    'lab.payment.subtitle': 'إدارة الحسابات البنكية وقنوات التحويل لمدفوعات العملاء',
    'vacations.subtitle': 'إدارة أيام نهاية الأسبوع وفترات إغلاق المعمل في التقويم',
    'branchs.subtitle': 'إدارة فروع المعمل والعناوين وبيانات التواصل',
    'assets.subtitle': 'تتبع أصول المعمل وتكاليف الشراء والملاحظات',
    'expenses.subtitle': 'تسجيل ومتابعة مصروفات المعمل حسب النوع والتاريخ والمبلغ',
    'expenseTypes.subtitle': 'تعريف بنود المصروفات المستخدمة عند تسجيل المصروفات',
    'colors.subtitle': 'إدارة ألوان الكتالوج المستخدمة في التركيبات والطلبات',
    'formulaTypes.subtitle': 'ضبط أنواع التركيبات والأسعار والوحدات والمرفقات',
    'activities.subtitle': 'سجل تدقيق لعمليات المستخدمين عبر المنصة',
    'transactions.subtitle': 'مراجعة حركات الفواتير والمصروفات والمحفظة',
    'lab.table.field': 'البيان',
    'lab.table.value': 'القيمة',
    'lab.table.actions': 'إجراءات',
    'lab.table.branches': 'الفروع',
    'lab.delivery.title': 'التوصيل',
    'lab.delivery.col.name': 'الاسم',
    'lab.delivery.col.amount': 'المبلغ',
    'lab.delivery.default': 'افتراضي',
    'lab.delivery.setDefault': 'تعيين كافتراضي',
    'lab.delivery.setDefaultSuccess': 'تم التعيين كافتراضي.',
    'lab.delivery.editValue': 'تغيير القيمة',
    'lab.delivery.editStandardTitle': 'تغيير قيمة التوصيل العادي',
    'lab.delivery.amountForCurrency': 'المبلغ ({currency})',
    'lab.delivery.updateSuccess': 'تم التحديث.',
    'lab.field.name': 'اسم المعمل',
    'lab.field.logo': 'الشعار',
    'lab.field.phone': 'تليفون المعمل',
    'lab.field.contactPhone': 'هاتف التواصل',
    'lab.field.vatPercentage': 'نسبة الضريبة',
    'lab.field.delivery': 'التوصيل',
    'lab.field.currency': 'العملة',
    'lab.field.showPriceDiscounts': 'إظهار الخصومات',
    'lab.field.showPriceDiscounts.show': 'ظاهرة',
    'lab.field.showPriceDiscounts.hide': 'مخفية',
    'lab.field.whatsapp': 'رقم واتساب المعمل',
    'lab.field.notes': 'وصف المعمل',
    'lab.button.edit': 'تعديل',
    'lab.modal.title': 'تعديل بيانات المعمل',
    'lab.form.name.label': 'اسم المعمل',
    'lab.form.name.placeholder': 'ادخل اسم المعمل',
    'lab.form.name.required': 'من فضلك ادخل اسم المعمل',
    'lab.form.phone.label': 'رقم التليفون',
    'lab.form.phone.placeholder': 'ادخل رقم التليفون',
    'lab.form.contactPhone.label': 'هاتف التواصل',
    'lab.form.contactPhone.placeholder': 'ادخل هاتف التواصل',
    'lab.form.vatPercentage.label': 'نسبة الضريبة',
    'lab.form.vatPercentage.placeholder': '٠',
    'lab.form.delivery.label': 'التوصيل',
    'lab.form.delivery.placeholder': '٠',
    'lab.form.showPriceDiscounts.label': 'إظهار الخصومات في الطلبات والفواتير',
    'lab.form.showPriceDiscounts.help': 'عند الإيقاف، تُخفى تسميات ومبالغ الخصم في الطلبات والفواتير وملفات PDF والفاتورة العامة. المبالغ المحصلة تبقى حسب أسعار العميل.',
    'lab.form.showPriceDiscounts.show': 'إظهار',
    'lab.form.showPriceDiscounts.hide': 'إخفاء',
    'lab.form.currency.label': 'العملة',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.readOnly': 'لا يمكن تغيير العملة بعد الإعداد.',
    'lab.form.whatsapp.label': 'رقم الواتساب',
    'lab.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'lab.form.notes.label': 'وصف المعمل',
    'lab.form.notes.placeholder': 'ادخل وصف المعمل',
    'lab.form.logo.label': 'الشعار (شريط التنقل)',
    'lab.form.logo.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'lab.form.logo.uploadButton': 'اختر إعدادت الشعار',
    'lab.form.removeLogo': 'إزالة الشعار الحالي',
    'lab.saveSuccess': 'تم حفظ الإعدادات',
    'lab.saveError': 'تعذر حفظ الإعدادات',
    'lab.button.save': 'حفظ',

    'home.currency.egp': 'EGP',
    'home.welcome': 'مرحبا {{labName}},',
    'home.lab_workspace_badge': 'مساحة عمل المعمل',
    'home.dentist_portal_badge': 'صفحة دخول الطبيب',
    'home.dentist_welcome': 'مرحباً د. {{name}}',
    'home.summary': 'ملخص نشاط وأداء المعمل.',
    'home.dentist_summary': 'نظرة عامة على حالات العيادة والتسليمات والفواتير.',
    'home.lab_contact_portal_badge': 'صفحة دخول جهة اتصال المختبر',
    'home.lab_contact_welcome': 'مرحباً {{name}}',
    'home.lab_contact_summary': 'نظرة عامة على حالات المختبر والتسليمات والفواتير.',
    'home.my_orders': 'حالات العيادة',
    'home.my_orders_count': 'حالات العيادة',
    'home.lab_orders': 'حالات المختبر',
    'home.lab_orders_count': 'حالات المختبر',
    'home.delivered_orders': 'تم التسليم',
    'home.pending_orders': 'قيد الانتظار',
    'home.in_progress_orders': 'قيد التنفيذ',
    'home.upcoming_deliveries': 'التسليمات القادمة',
    'home.patients': 'المرضى',
    'home.filter_by_clients': 'تصفية حسب العملاء',
    'home.cases_this_month': 'حالات هذا الشهر',
    'home.clinic_invoices': 'فواتير العيادة',
    'home.lab_invoices': 'فواتير المختبر',
    'home.patient': 'المريض',
    'home.delivery_date': 'تاريخ التسليم',
    'home.invoices_amount': 'إجمالي الفواتير',
    'home.paid_invoices': 'الفواتير المدفوعة',
    'home.orders': 'الحالات',
    'home.dentists': 'الأطباء',
    'home.invoices': 'الفواتير',
    'home.unpaid_amount': 'المبالغ غير المدفوعة',
    'home.statistics': 'إحصائيات',
    'home.recent_clinics': 'المختبرات الأعلى',
    'home.activity_overview': 'نظرة عامة على النشاط',
    'home.activity_subtitle': 'نظرة عامة على الحالات والفواتير والإيرادات',
    'home.view_reports': 'عرض التقارير',
    'home.dental_clinic': 'العيادة',
    'home.active_invoices': 'الفواتير النشطة',
    'home.active_expenses': 'المصروفات النشطة',
    'home.invoices_label': 'الفواتير',
    'home.expenses_label': 'المصروفات',
    'home.amount': 'المبلغ',
    'home.count': 'العدد',
    'home.revenue': 'الإيرادات',
    'home.paid_invoices_amount': 'قيمة الفواتير المدفوعة',
    'home.unpaid_invoices_amount': 'قيمة الفواتير غير المدفوعة',
    'home.paid_invoices_count': 'عدد الفواتير المدفوعة',
    'home.unpaid_invoices_count': 'عدد الفواتير غير المدفوعة',
    'home.invoices_count': 'عدد الفواتير',
    'home.clients_count': 'عدد العملاء',
    'home.orders_count': 'عدد الحالات',
    'home.units_count': 'عدد الوحدات',
    'home.expenses_amount': 'إجمالي المصروفات',
    'home.orders_trend': 'اتجاه الحالات',
    'home.revenue_by_month': 'الإيرادات (6 أشهر)',
    'home.invoices_breakdown': 'توزيع الفواتير',
    'home.active_clients': 'العملاء النشطون',
    'home.active_orders': 'الطلبات النشطة',
    'home.active_dentists': 'الأطباء النشطون',
    'home.clients_label': 'العملاء',
    'home.orders_label': 'الطلبات',
    'home.full_period': 'الفترة الكاملة',

    // New home keys
    'home.new_orders': 'طلبات جديدة',
    'home.latest_orders': 'أحدث الطلبات',
    'home.orders_tracker': 'متعقب الطلبات',
    'home.invoices_tracker': 'متعقب الفواتير',
    'home.formula_types_tracker': 'متعقب أنواع التركيبات',
    'home.formula_type': 'نوع التركيبة',
    'home.units_amount': 'مبلغ الوحدات',
    'home.total_units_amount': 'إجمالي مبلغ الوحدات',
    'home.this_week': 'هذا الأسبوع',
    'home.this_month': 'هذا الشهر',
    'home.last_month': 'الشهر الماضي',
    'home.last_3_months': 'آخر 3 أشهر',
    'home.last_6_months': 'آخر 6 أشهر',
    'home.last_year': ' اخر عام',
    'home.custom_range': 'نطاق مخصص',
    'home.revenue_tracker': 'متعقب الإيرادات',
    'home.total_invoices': 'إجمالي الفواتير',
    'home.total_invoices_amount': 'إجمالي قيمة الفواتير',
    'home.total_expenses': 'إجمالي المصروفات',
    'home.net': 'الصافي',
    'home.invoices_vs_expenses': 'الفواتير مقابل المصروفات',
    'home.order': 'طلب',
    'home.client': 'عميل',
    'home.status': 'الحالة',
    'home.date': 'التاريخ',
    'home.total': 'الإجمالي',
    'home.total_orders': 'إجمالي الطلبات',
    'home.requested': 'مطلوب',
    'home.in_progress': 'قيد التنفيذ',
    'home.finished': 'مكتمل',
    'home.completed_percentage': 'النسبة المكتملة',
    'home.completed_orders': 'الطلبات المكتملة',
    'home.no_data': 'لا توجد بيانات',
    'home.view_all_orders': 'عرض جميع الطلبات',

    // Profile
    'profile.title': 'الملف الشخصي',
    'profile.error.title': 'تعذر تحميل الملف الشخصي',
    'profile.avatar.upload': 'رفع صورة',
    'profile.avatar.remove': 'إزالة الصورة',
    'profile.avatar.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'profile.avatar.tooLarge': 'الصورة المرفوعة كبيرة جدًا. يرجى استخدام صورة بحجم 4 ميجابايت كحد أقصى.',
    'profile.field.avatar': 'الصورة',
    'profile.field.name': 'الاسم',
    'profile.field.username': 'اسم المستخدم',
    'profile.field.email': 'البريد الإلكتروني',
    'profile.field.userType': 'نوع المستخدم',
    'profile.field.vendorName': 'اسم المعمل',
    'profile.field.assignedClient': 'العميل المعين',
    'profile.section.assignedClient': 'العميل المعين',
    'profile.menu.profile': 'الملف الشخصي',
    'profile.menu.settings': 'الإعدادات',
    'profile.field.password': 'كلمة المرور',
    'profile.field.passwordConfirm': 'تأكيد كلمة المرور',
    'profile.field.phone': 'الهاتف',
    'profile.field.whatsapp': 'واتساب',
    'profile.passwordSet': '••••••••',
    'profile.passwordPending': 'في انتظار الدعوة',
    'profile.field.currentPassword': 'كلمة المرور الحالية',
    'profile.changePassword': 'تغيير كلمة المرور',
    'profile.menu.logout': 'تسجيل خروج',

    'notifications.title': 'الإشعارات',
    'notifications.empty': 'لا توجد إشعارات بعد',
    'notifications.markAllRead': 'تعليم الكل كمقروء',
    'notifications.close': 'إغلاق',
    'notifications.unread': 'غير مقروء',
    'notifications.showMore': 'عرض المزيد',
    'notifications.page.subtitle': 'عرض وإدارة جميع إشعاراتك',
    'notifications.countLabel': 'إجمالي',

    'users.page.title': 'المستخدمون',
    'users.header.title': 'المستخدمون',
    'users.header.subtitle': 'إدارة حسابات طاقم المعمل والدعوات والصلاحيات والوصول',
    'users.filter.title': 'تصفية المستخدمين',
    'users.filter.active': 'مفعل',
    'users.filter.clear': 'إعادة تعيين عوامل التصفية',
    'users.button.addUser': 'إضافة مستخدم',
    'users.modal.title': 'المستخدمون',
    'users.table.name': 'الاسم',
    'users.table.username': 'اسم المستخدم',
    'users.table.email': 'البريد الإلكتروني',
    'users.table.userType': 'نوع المستخدم',
    'users.table.status': 'الحالة',
    'users.table.contact': 'التواصل',
    'users.table.phone': 'رقم التليفون',
    'users.table.whatsapp': 'رقم الواتساب',
    'users.table.address': 'العنوان',
    'users.table.actions': 'العمليات',
    'users.status.verified': 'مفعّل',
    'users.status.pending': 'بانتظار التفعيل',
    'users.status.activated': 'تم تفعيل المستخدم',
    'users.status.deactivated': 'تم إلغاء تفعيل المستخدم',
    'users.status.toggleFailed': 'تعذر تحديث حالة المستخدم',
    'users.status.manualVerified': 'تم التحقق من المستخدم',
    'users.status.manualUnverified': 'تم إلغاء تحقق المستخدم',
    'users.status.verifyToggleFailed': 'تعذر تحديث حالة التحقق',
    'users.actions.activate': 'تفعيل',
    'users.actions.deactivate': 'إلغاء التفعيل',
    'users.actions.verify': 'تحقق',
    'users.actions.unverify': 'إلغاء التحقق',
    'users.table.accountStatus': 'التفعيل',
    'users.table.invitationStatus': 'التحقق',
    'users.details.profileSection': 'بيانات الملف',
    'users.details.invitationSection': 'الدعوة',
    'users.details.clientNotAssigned': 'غير مُعيَّن',
    'users.details.assignedOrdersSection': 'الطلبات المسندة',
    'users.details.noAssignedOrders': 'لا توجد طلبات مسندة',
    'users.confirm.activateTitle': 'تفعيل مستخدم',
    'users.confirm.activateMessage': 'سيتمكن هذا المستخدم من تسجيل الدخول مرة أخرى.',
    'users.confirm.deactivateTitle': 'إلغاء تفعيل مستخدم',
    'users.confirm.deactivateMessage': 'سيتم تسجيل خروج هذا المستخدم ومنعه من الدخول حتى يتم تفعيله مرة أخرى.',
    'users.confirm.verifyTitle': 'تحقق من مستخدم',
    'users.confirm.verifyMessage': 'سيتم تعليم هذا المستخدم كمتحقق دون إكمال تدفق الدعوة.',
    'users.confirm.unverifyTitle': 'إلغاء تحقق مستخدم',
    'users.confirm.unverifyMessage': 'سيتم تعليم هذا المستخدم كبانتظار التحقق مرة أخرى.',
    'users.confirm.deleteTitle': 'حذف مستخدم',
    'users.confirm.deleteMessage': 'هل تريد حذف هذا المستخدم؟',
    'users.modal.createTitle': 'إضافة مستخدم',
    'users.modal.editTitle': 'تعديل مستخدم',
    'users.changeHistory': 'سجل التغييرات',
    'users.versions.title': 'سجل تغييرات المستخدم',
    'users.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'users.versions.by': 'تم التحديث بواسطة',
    'users.versions.noFields': 'لا توجد حقول تغيّرت',
    'users.versions.timelineTitle': 'الخط الزمني',
    'users.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'users.versions.selectVersion': 'اختر إصدارًا',
    'users.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'users.versions.field': 'الحقل',
    'users.versions.versionValue': 'قيمة الإصدار',
    'users.versions.currentValue': 'القيمة الحالية',
    'users.versions.current': 'الحالي',
    'users.versions.before': 'قبل',
    'users.versions.after': 'بعد (الحالية)',
    'users.versions.status': 'الحالة',
    'users.versions.changed': 'تم التغيير',
    'users.versions.same': 'بدون تغيير',
    'users.form.name.label': 'الاسم',
    'users.form.name.placeholder': 'ادخل الاسم',
    'users.form.name.required': 'من فضلك ادخل الاسم',
    'users.form.email.label': 'البريد الإلكتروني',
    'users.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'users.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'users.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'users.form.username.label': 'اسم المستخدم',
    'users.form.username.placeholder': 'ادخل اسم المستخدم',
    'users.form.username.hint': 'مطلوب إذا لم يكن للمستخدم بريد إلكتروني',
    'users.form.password.label': 'كلمة المرور',
    'users.form.password.placeholder': 'ادخل كلمة المرور',
    'users.form.password.required': 'من فضلك ادخل كلمة المرور',
    'users.form.password.invitationHint': 'اتركه فارغًا لإرسال رابط الدعوة',
    'users.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'users.form.password.confirm': 'تأكيد كلمة المرور',
    'users.form.password.confirmRequired': 'من فضلك أكد كلمة المرور',
    'users.form.password.mismatch': 'كلمتا المرور غير متطابقتين',
    'users.form.password.confirmPlaceholder': 'أعد إدخال كلمة المرور',
    'users.invitation.copyLink': 'نسخ رابط الدعوة',
    'users.invitation.linkCopied': 'تم نسخ رابط الدعوة',
    'users.invitation.copyFailed': 'تعذر نسخ رابط الدعوة',
    'users.invitation.sendEmail': 'إرسال دعوة بالبريد',
    'users.invitation.emailSent': 'تم إرسال بريد الدعوة',
    'users.invitation.sendFailed': 'تعذر إرسال بريد الدعوة',
    'users.invitation.regenerate': 'إعادة إنشاء رابط الدعوة',
    'users.invitation.regenerated': 'تمت إعادة إنشاء رابط الدعوة',
    'users.invitation.regeneratedAndCopied': 'تمت إعادة إنشاء الرابط ونسخه',
    'users.invitation.regenerateFailed': 'تعذر إعادة إنشاء رابط الدعوة',
    'users.invitation.title': 'الدعوة',
    'users.invitation.invalidToken': 'رابط الدعوة غير صالح أو منتهي الصلاحية',
    'users.invitation.completed': 'تم تفعيل الحساب بنجاح! يمكنك تسجيل الدخول الآن.',
    'users.invitation.completeFailed': 'تعذر إكمال الدعوة',
    'users.invitation.error': 'خطأ',
    'users.invitation.backToLogin': 'العودة إلى تسجيل الدخول',
    'users.invitation.setPassword': 'تعيين كلمة المرور',
    'users.invitation.welcome': 'مرحبًا!',
    'users.invitation.welcomeMessage': 'يرجى تعيين كلمة مرور للحساب {{name}} ({{email}})',
    'users.invitation.complete': 'إكمال التفعيل',
    'users.form.phone.label': 'رقم التليفون',
    'users.form.phone.placeholder': 'ادخل رقم التليفون',
    'users.form.whatsapp.label': 'رقم الواتساب',
    'users.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'users.form.address.label': 'العنوان',
    'users.form.address.placeholder': 'ادخل العنوان',
    'users.form.userType.label': 'نوع المستخدم',
    'users.form.userType.placeholder': 'اختر نوع المستخدم',
    'users.form.userType.required': 'من فضلك اختر نوع المستخدم',
    'users.resetPassword.button': 'إعادة تعيين كلمة المرور',
    'users.resetPassword.confirmTitle': 'إعادة التعيين إلى الكلمة المؤقتة؟',
    'users.resetPassword.confirmMessage': 'سيتم تعيين كلمة المرور إلى temp123. شاركها مع المستخدم ليسجّل الدخول ثم يغيّرها.',
    'users.resetPassword.successTitle': 'كلمة المرور المؤقتة جاهزة',
    'users.resetPassword.successHint': 'أعطِ كلمة المرور هذه للمستخدم. عليه تسجيل الدخول ثم تغييرها من الملف الشخصي.',
    'users.resetPassword.failed': 'تعذر إعادة تعيين كلمة المرور',
    'users.form.client.label': 'العميل',
    'users.form.client.required': 'من فضلك اختر عميلاً لحساب الطبيب',
    'users.form.permissions.label': 'الصلاحيات',
    'users.form.permissions.placeholder': 'اختر الصلاحيات',
    'users.form.permissions.selectAll': 'تحديد الكل',
    'users.permissions.groups.asset': 'الأصول',
    'users.permissions.groups.branch': 'الفروع',
    'users.permissions.groups.delivery_center': 'مراكز التوصيل',
    'users.permissions.groups.color': 'الألوان',
    'users.permissions.groups.dentist': 'الأطباء',
    'users.permissions.groups.expense': 'المصروفات',
    'users.permissions.groups.expense_type': 'بنود المصروفات',
    'users.permissions.groups.invoice': 'الفواتير',
    'users.permissions.groups.formula_type': 'أنواع التركيبات',
    'users.permissions.groups.order': 'الطلبات',
    'users.permissions.groups.order_phase': 'مراحل الطلب',
    'users.permissions.groups.client': 'العملاء',
    'users.permissions.groups.transaction': 'المعاملات',
    'users.permissions.groups.unit': 'الوحدات',
    'users.permissions.groups.unit_type': 'أنواع الوحدات',
    'users.permissions.groups.user': 'المستخدمون',
    'users.permissions.groups.dashboard': 'لوحة التحكم',
    'users.permissions.groups.vendor': 'المعامل',
    'users.permissions.groups.vendor_bank_accounts': 'الحسابات البنكية',
    'users.permissions.groups.vendor_money_transfer_channels': 'طرق التحويل',
    'users.permissions.groups.setting': 'الإعدادات',
    'users.permissions.groups.client_settings': 'إعدادات العميل',
    'users.permissions.groups.client_transactions': 'معاملات العميل',
    'users.permissions.items.view_dashboard_kpi_orders': 'عرض مقياس الطلبات',
    'users.permissions.items.view_dashboard_kpi_invoices': 'عرض مقياس الفواتير',
    'users.permissions.items.view_dashboard_kpi_clients': 'عرض مقياس العملاء',
    'users.permissions.items.view_dashboard_kpi_units': 'عرض مقياس الوحدات',
    'users.permissions.items.view_dashboard_kpi_expenses': 'عرض مقياس المصروفات',
    'users.permissions.items.view_dashboard_revenue_tracker': 'عرض متتبع الإيرادات',
    'users.permissions.items.view_dashboard_latest_orders': 'عرض أحدث الطلبات',
    'users.permissions.items.view_dashboard_orders_tracker': 'عرض متتبع الطلبات',
    'users.permissions.items.view_dashboard_latest_invoices': 'عرض أحدث الفواتير',
    'users.permissions.items.view_dashboard_invoices_tracker': 'عرض متتبع الفواتير',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'عرض متتبع أنواع التركيبات',
    'users.permissions.items.view_dashboard_active_clients': 'عرض العملاء النشطين',
    'users.permissions.items.view_dashboard_active_orders': 'عرض الطلبات النشطة',
    'users.permissions.items.view_dashboard_active_invoices': 'عرض الفواتير النشطة',
    'users.permissions.items.view_dashboard_active_expenses': 'عرض المصروفات النشطة',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'تحميل الفاتورة (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'إرسال الفاتورة عبر واتساب',
    'users.permissions.items.send_invoice_email': 'إرسال الفاتورة عبر البريد الإلكتروني',
    'users.permissions.items.detach_order_from_invoice': 'فصل الطلب عن الفاتورة',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'عرض المعامل',
    'users.permissions.items.add_vendor': 'إضافة موردين',
    'users.permissions.items.edit_vendor': 'تعديل المعامل',
    'users.permissions.items.delete_vendor': 'حذف المعامل',

    'users.permissions.items.view_vendor_bank_accounts': 'عرض الحسابات البنكية',
    'users.permissions.items.add_vendor_bank_accounts': 'إضافة حسابات بنكية',
    'users.permissions.items.edit_vendor_bank_accounts': 'تعديل الحسابات البنكية',
    'users.permissions.items.delete_vendor_bank_accounts': 'حذف الحسابات البنكية',

    'users.permissions.items.view_vendor_money_transfer_channels': 'عرض طرق التحويل',
    'users.permissions.items.add_vendor_money_transfer_channels': 'إضافة طرق التحويل',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'تعديل طرق التحويل',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'حذف طرق التحويل',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'عرض الإعدادات',
    'users.permissions.items.edit_settings': 'تعديل الإعدادات',

    // Dentist portal settings
    'users.permissions.items.view_client_settings_client_info': 'عرض بيانات العميل (الإعدادات)',
    'users.permissions.items.view_client_settings_wallet_balance': 'عرض رصيد المحفظة (الإعدادات)',
    'users.permissions.items.view_client_settings_wallet_history': 'عرض سجل المحفظة (الإعدادات)',
    'users.permissions.items.view_client_settings_transactions': 'عرض المعاملات (الإعدادات)',
    'users.permissions.items.view_client_transactions': 'عرض معاملات العميل',

    'clientTransactions.title': 'المعاملات',
    'clientTransactions.alert.noAccess': 'ليس لديك صلاحية الوصول إلى المعاملات.',
    'users.permissions.items.view_client_settings_wallet': 'عرض محفظة العميل (الإعدادات)',

    'clientSettings.title': 'الإعدادات',
    'clientSettings.alert.noAccess': 'ليس لديك صلاحية الوصول إلى الإعدادات.',
    'clientSettings.alert.noClientAssigned': 'لا يوجد عميل مرتبط بحسابك. تواصل مع مسؤول المعمل.',
    'clientSettings.clientInfo.title': 'بيانات العميل',
    'clientSettings.clientInfo.clientName': 'اسم العميل',
    'clientSettings.clientInfo.clientType': 'نوع العميل',
    'clientSettings.clientInfo.phone': 'رقم الهاتف',
    'clientSettings.clientInfo.whatsapp': 'رقم واتساب',
    'clientSettings.clientInfo.email': 'البريد الإلكتروني',
    'clientSettings.clientInfo.assignedDentists': 'الأطباء المسؤولون ',
    'clientSettings.clientInfo.assignedLabContacts': 'جهات اتصال المختبر',
    'clientSettings.clientInfo.deliveryCenters': 'مراكز التسليم',
    'clientSettings.accounts.title': 'الحسابات',
    'clientSettings.accounts.titleDentists': 'حسابات العميل',
    'clientSettings.accounts.titleLabContacts': 'حسابات جهات اتصال المختبر',
    'clientSettings.accounts.description': 'الحسابات الأخرى المرتبطة بهذا العميل. يمكن للحساب الرئيسي فقط عرض هذه القائمة.',
    'clientSettings.accounts.you': 'أنت',
    'clientSettings.accounts.status': 'الحالة',
    'clientSettings.accounts.statusActive': 'نشط',
    'clientSettings.accounts.statusInactive': 'غير نشط',
    'clientSettings.wallet.title': 'المحفظة',
    'clientSettings.transactions.title': 'المعاملات',

    'users.permissions.items.view_asset': 'عرض الأصول',
    'users.permissions.items.add_asset': 'إضافة الأصول',
    'users.permissions.items.edit_asset': 'تعديل الأصول',
    'users.permissions.items.delete_asset': 'حذف الأصول',
    'users.permissions.items.view_branch': 'عرض الفروع',
    'users.permissions.items.add_branch': 'إضافة الفروع',
    'users.permissions.items.edit_branch': 'تعديل الفروع',
    'users.permissions.items.delete_branch': 'حذف الفروع',
    'users.permissions.items.view_delivery_center': 'عرض مراكز التوصيل',
    'users.permissions.items.add_delivery_center': 'إضافة مراكز التوصيل',
    'users.permissions.items.edit_delivery_center': 'تعديل مراكز التوصيل',
    'users.permissions.items.delete_delivery_center': 'حذف مراكز التوصيل',
    'users.permissions.items.view_color': 'عرض الألوان',
    'users.permissions.items.add_color': 'إضافة الألوان',
    'users.permissions.items.edit_color': 'تعديل الألوان',
    'users.permissions.items.delete_color': 'حذف الألوان',
    'users.permissions.items.view_dentist': 'عرض الأطباء',
    'users.permissions.items.add_dentist': 'إضافة الأطباء',
    'users.permissions.items.edit_dentist': 'تعديل الأطباء',
    'users.permissions.items.delete_dentist': 'حذف الأطباء',
    'users.permissions.items.view_expense': 'عرض المصروفات',
    'users.permissions.items.add_expense': 'إضافة المصروفات',
    'users.permissions.items.edit_expense': 'تعديل المصروفات',
    'users.permissions.items.delete_expense': 'حذف المصروفات',
    'users.permissions.items.view_expense_type': 'عرض بنود المصروفات',
    'users.permissions.items.add_expense_type': 'إضافة بنود المصروفات',
    'users.permissions.items.edit_expense_type': 'تعديل بنود المصروفات',
    'users.permissions.items.delete_expense_type': 'حذف بنود المصروفات',
    'users.permissions.items.view_invoice': 'عرض الفواتير',
    'users.permissions.items.add_invoice': 'إضافة الفواتير',
    'users.permissions.items.edit_invoice': 'تعديل الفواتير',
    'users.permissions.items.delete_invoice': 'حذف الفواتير',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'إنشاء فاتورة من الطلب',
    'users.permissions.items.attach_order_to_invoice': 'ربط الطلب بفاتورة موجودة',
    'users.permissions.items.create_work_order': 'إنشاء أمر عمل',
    'users.permissions.items.view_assigned_orders': 'عرض الطلبات المسندة',
    'users.permissions.items.view_order_public_page': 'عرض صفحة الطلب العامة',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'إنشاء فاتورة',
    'orders.actions.createInvoice.description': 'إنشاء فاتورة باستخدام الطلب الحالي.',
    'orders.actions.createInvoice.cta': 'إنشاء فاتورة',
    'orders.actions.createInvoice.success': 'تم إنشاء الفاتورة بنجاح',
    'orders.actions.createInvoice.error': 'فشل في إنشاء الفاتورة',

    'orders.actions.attach.title': 'ربط بفاتورة موجودة',
    'orders.actions.attach.selectPlaceholder': 'اختر فاتورة',
    'orders.actions.attach.cta': 'ربط',
    'orders.actions.attach.success': 'تم ربط الطلب بالفاتورة',
    'orders.actions.attach.error': 'فشل في الربط',

    'orders.actions.createWorkOrder.title': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.assignedTo': 'تعيين إلى',
    'orders.actions.createWorkOrder.notes': 'ملاحظات',
    'orders.actions.createWorkOrder.cta': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.success': 'تم إنشاء أمر العمل',
    'orders.actions.createWorkOrder.error': 'فشل في إنشاء أمر العمل',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'بنود الطلب (حسب نوع التركيبة)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} وحدة',
    'orders.actions.createWorkOrder.unitLabel': 'الوحدة {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'لا توجد تركيبات في هذا الطلب.',
    'users.permissions.items.view_formula_type': 'عرض أنواع التركيبات',
    'users.permissions.items.add_formula_type': 'إضافة نوع تركيبة',
    'users.permissions.items.edit_formula_type': 'تعديل نوع تركيبة',
    'users.permissions.items.delete_formula_type': 'حذف نوع تركيبة',
    'users.permissions.items.view_all_formula_types': 'عرض كل أنواع التركيبات',
    'users.permissions.items.view_client': 'عرض العملاء',
    'users.permissions.items.add_client': 'إضافة العملاء',
    'users.permissions.items.edit_client': 'تعديل العملاء',
    'users.permissions.items.delete_client': 'حذف العملاء',
    'users.permissions.items.view_order': 'عرض الطلبات',
    'users.permissions.items.add_order': 'إضافة الطلبات',
    'users.permissions.items.edit_order': 'تعديل الطلبات',
    'users.permissions.items.delete_order': 'حذف الطلبات',
    'users.permissions.items.view_order_phase': 'عرض مراحل الطلب',
    'users.permissions.items.add_order_phase': 'إضافة مراحل الطلب',
    'users.permissions.items.edit_order_phase': 'تعديل مراحل الطلب',
    'users.permissions.items.delete_order_phase': 'حذف مراحل الطلب',
    'users.permissions.items.view_transaction': 'عرض المعاملات',
    'users.permissions.items.add_transaction': 'إضافة المعاملات',
    'users.permissions.items.edit_transaction': 'تعديل المعاملات',
    'users.permissions.items.delete_transaction': 'حذف المعاملات',
    'users.permissions.items.view_unit': 'عرض الوحدات',
    'users.permissions.items.add_unit': 'إضافة الوحدات',
    'users.permissions.items.edit_unit': 'تعديل الوحدات',
    'users.permissions.items.delete_unit': 'حذف الوحدات',
    'users.permissions.items.view_unit_type': 'عرض أنواع الوحدات',
    'users.permissions.items.add_unit_type': 'إضافة أنواع الوحدات',
    'users.permissions.items.edit_unit_type': 'تعديل أنواع الوحدات',
    'users.permissions.items.delete_unit_type': 'حذف أنواع الوحدات',
    'users.permissions.items.view_user': 'عرض المستخدمين',
    'users.permissions.items.add_user': 'إضافة المستخدمين',
    'users.permissions.items.edit_user': 'تعديل المستخدمين',
    'users.permissions.items.delete_user': 'حذف المستخدمين',
    'users.permissions.groups.delivery_type': 'أنواع التوصيل',
    'users.permissions.groups.activity_logs': 'سجل النشاط',
    'users.permissions.groups.change_history': 'سجل التغييرات',
    'users.permissions.actions.view': 'عرض',
    'users.permissions.actions.add': 'إضافة',
    'users.permissions.actions.edit': 'تعديل',
    'users.permissions.actions.delete': 'حذف',
    'users.permissions.actions.change': 'تغيير',
    'users.permissions.actions.create': 'إنشاء',
    'users.permissions.actions.view_all': 'عرض الكل',
    'users.permissions.items.view_delivery_type': 'عرض أنواع التوصيل',
    'users.permissions.items.add_delivery_type': 'إضافة أنواع التوصيل',
    'users.permissions.items.edit_delivery_type': 'تعديل أنواع التوصيل',
    'users.permissions.items.delete_delivery_type': 'حذف أنواع التوصيل',
    'users.permissions.items.view_assigned_technician': 'عرض الفني المسند',
    'users.permissions.items.change_assigned_technician': 'تغيير الفني المسند',
    'users.permissions.items.view_assigned_courier': 'عرض المندوب المسند',
    'users.permissions.items.change_assigned_courier': 'تغيير المندوب المسند',
    'users.permissions.items.view_order_status': 'عرض حالة الطلب',
    'users.permissions.items.change_order_status': 'تغيير حالة الطلب',
    'users.permissions.items.view_activity_logs': 'عرض سجل النشاط',
    'users.permissions.items.view_change_history': 'عرض سجل التغييرات',
    'users.permissions.items.view_all_colors': 'عرض كل الألوان',
    'users.form.submit.add': 'إضافة',
    'users.form.submit.edit': 'تعديل',
    'users.alert.noAccess': 'ليس لديك صلاحية لعرض المستخدمين.',

    'invoice.title': 'فاتورة',
    'invoice.detailsTitle': 'تفاصيل الفاتورة',
    'invoice.button.print': 'طباعة',
    'invoice.button.addOrder': 'إضافة طلب',
    'invoice.field.dentistName': 'اسم الطبيب',
    'invoice.field.date': 'تاريخ الفاتورة',
    'invoice.table.orderRef': 'رقم الطلب',
    'invoice.table.invoiceRef': 'رقم الفاتورة',
    'invoice.field.shipmentDate': 'تاريخ الشحنة',
    'invoice.field.vat': 'قيمة الضريبة',
    'invoice.field.deliveryCost': 'تكلفة التوصيل',
    'invoice.field.orderId': 'رقم الطلب',
    'invoice.field.amount': 'المبلغ',
    'invoice.field.client': 'العميل',
    'invoice.field.status': 'حالة الفاتورة',
    'invoice.field.orders': 'الطلبات',
    'invoice.field.units': 'عدد الوحدات',
    'invoice.field.unitCost': 'التكلفة لكل وحدة',
    'invoice.field.issueDate': 'تاريخ الإصدار',
    'invoice.field.dueDate': 'تاريخ الاستحقاق',
    'invoice.field.paidAt': 'تاريخ الدفع',
    'invoice.field.paymentMethod': 'طريقة الدفع',
    'invoice.field.paymentStatus': 'حالة الدفع',
    'invoices.button.showDrafts': 'عرض المسودات',
    'invoices.button.hideDrafts': 'إخفاء المسودات',
    'invoices.filter.all': 'عرض الكل',
    'invoices.filter.drafts': 'عرض المسودات',
    'invoices.filter.nonDrafts': 'إخفاء المسودات',
    'invoice.field.deliveredAt': 'تم التسليم',
    'invoice.orders.viewFormulas': 'عرض التركيبات ومخطط الأسنان',
    'invoice.orders.hideFormulas': 'إخفاء التركيبات ومخطط الأسنان',
    'invoice.orders.expandAll': 'توسيع كل التركيبات',
    'invoice.orders.collapseAll': 'طَيّ كل التركيبات',
    'invoice.orders.formulasCount': '{{count}} تركيبات',
    'invoice.orders.unitsCount': '{{count}} وحدات',
    'invoice.orders.formulaList': 'التركيبات والألوان',
    'invoice.orders.financialSummary': 'التفاصيل المالية',
    'invoice.orders.teeth': 'الأسنان',
    'invoice.button.detach': 'فصل عن الفاتورة',
    'invoice.detach.confirmMessage': 'هل تريد بالتأكيد فصل هذا الطلب عن الفاتورة؟',
    'invoice.detach.success': 'تم فصل الطلب بنجاح',
    'invoice.detach.error': 'فشل فصل الطلب',
    'invoice.cancel.confirmMessage': 'فصل آخر طلب سيحول الفاتورة إلى مسودة. المتابعة؟',
    'invoice.cancel.success': 'تم تحويل الفاتورة إلى مسودة',
    'invoice.cancel.error': 'فشل إلغاء الفاتورة',
    'invoice.alert.draft': 'الفاتورة في حالة مسودة',
    'invoice.alert.paidReadOnly': 'تم دفع هذه الفاتورة. لا يمكن تعديلها؛ استخدم التراجع عن الدفع أدناه إذا سُجّل الدفع بالخطأ، أو الاسترداد لإضافة المبلغ إلى محفظة العميل.',
    'invoice.button.cancel': 'إلغاء الفاتورة',
    'invoice.button.downloadPdf': 'تنزيل PDF',
    'invoice.button.downloadSummaryPdf': 'تنزيل فاتورة ملخصة PDF',
    'invoice.button.sendWhatsapp': 'إرسال عبر واتساب',
    'invoice.button.sendEmail': 'إرسال عبر البريد',
    'invoice.button.markPaid': 'تسجيل كمدفوعة',
    'invoice.button.refund': 'استرداد',
    'invoice.markPaid.title': 'تسجيل الدفع',
    'invoice.markPaid.paymentMethod': 'طريقة الدفع',
    'invoice.markPaid.channel': 'قناة التحويل',
    'invoice.markPaid.channelOther': 'قناة أخرى',
    'invoice.markPaid.notes': 'ملاحظات',
    'invoice.markPaid.attachment': 'مرفق (صورة)',
    'invoice.markPaid.success': 'تم تسجيل الفاتورة كمدفوعة',
    'invoice.markPaid.error': 'فشل تسجيل الفاتورة كمدفوعة',
    'invoice.refund.confirmTitle': 'استرداد الفاتورة؟',
    'invoice.refund.confirmMessage': 'سيتم إضافة المبلغ المدفوع إلى محفظة العميل وستُعاد الفاتورة إلى غير مدفوعة.',
    'invoice.refund.success': 'تم استرداد الفاتورة بنجاح',
    'invoice.refund.error': 'فشل استرداد الفاتورة',
    'invoice.button.undoMarkPaid': 'التراجع عن الدفع',
    'invoice.undoMarkPaid.confirmTitle': 'التراجع عن الدفع؟',
    'invoice.undoMarkPaid.confirmMessage': 'سيتم إلغاء تسجيل الدفع كما لو لم يحدث. ستُحذف معاملات الدفع المرتبطة وتُعاد الفاتورة إلى غير مدفوعة.',
    'invoice.undoMarkPaid.success': 'تم التراجع عن دفع الفاتورة',
    'invoice.undoMarkPaid.error': 'فشل التراجع عن دفع الفاتورة',
    'invoice.changeHistory': 'سجل التغييرات',
    'invoice.versions.title': 'سجل تغييرات الفاتورة',
    'invoice.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'invoice.versions.timelineTitle': 'الخط الزمني',
    'invoice.versions.by': 'تم التحديث بواسطة',
    'invoice.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'invoice.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'invoice.versions.selectVersion': 'اختر إصدارًا',
    'invoice.versions.noFields': 'لا توجد حقول تغيّرت',
    'invoice.versions.currentVersion': 'الإصدار الحالي',
    'invoice.versions.before': 'قبل',
    'invoice.versions.after': 'بعد (الحالية)',
    'invoice.field.phone': 'رقم الهاتف',
    'invoice.field.message': 'الرسالة',
    'invoice.paymentSummary.toggle': 'المبالغ',
    'invoice.paymentSummary.hide': 'إخفاء المبالغ',
    'invoice.paymentSummary.show': 'إظهار المبالغ',
    'invoice.seller.title': 'البائع',
    'invoice.dentist.title': 'الطبيب',
    'invoice.deliveryCenter.title': 'مراكز التسليم',
    'invoice.customer.title': 'العميل',
    'invoice.paymentSummary.title': 'ملخص الدفع',
    'invoice.notes.title': 'ملاحظات',
    'invoice.client.title': 'العميل',
    'invoice.notes.edit': 'تعديل',
    'invoice.notes.save': 'حفظ',
    'invoice.notes.cancel': 'إلغاء',
    'invoice.summary.title': 'ملخص الفاتورة',
    'invoice.summary.subtotal': 'الإجمالي قبل الضريبة',
    'invoice.summary.vat': 'ضريبة القيمة المضافة ({{percent}}%)',
    'invoice.summary.totalVat': 'إجمالي الضريبة',
    'invoice.summary.discount': 'الخصومات',
    'invoice.summary.delivery': 'التوصيل',
    'invoice.summary.total': 'الإجمالي',
    'invoice.attachments.title': 'المرفقات',
    'invoice.addOrder.selectRequired': 'الرجاء اختيار طلب واحد على الأقل',

    // UI invoice labels (عرض الفاتورة العام)
    'ui.invoice.number': 'رقم الفاتورة',
    'ui.invoice.status': 'الحالة',
    'ui.invoice.issue_date': 'تاريخ الإصدار',
    'ui.invoice.due_date': 'تاريخ الاستحقاق',
    'ui.invoice.section_vendor': 'البائع',
    'ui.invoice.section_client': 'العميل',
    'ui.invoice.section_dentist': 'الطبيب',
    'ui.invoice.section_delivery_center': 'مركز التسليم',
    'ui.delivery_cost': 'تكلفة التوصيل',
    'ui.invoice.table.order_ref': 'مرجع الطلب',
    'ui.invoice.table.formula_type': 'نوع التركيبة',
    'ui.invoice.table.units': 'الوحدات',
    'ui.invoice.table.shipment_date': 'تاريخ الشحنة',
    'ui.invoice.table.patient': 'المريض',
    'ui.invoice.table.amount': 'المبلغ',
    'ui.invoice.table.discount': 'الخصم',
    'ui.invoice.table.vat': 'ضريبة',
    'ui.invoice.table.total': 'الإجمالي',
    'ui.invoice.status_paid': 'مدفوع',


    // Channel names

    // Payment / Bank accounts (Arabic)
    'ui.invoice.status_past_due': 'غير مدفوع',
    'ui.invoice.status_unpaid': 'غيرمدفوع',

    // Generic error messages
    'errors.fetchFailed': 'فشل في تحميل البيانات',
    'invoice.addOrder.added': 'تمت إضافة الطلبات للفاتورة',
    'invoice.addOrder.fetchError': 'تعذر استرجاع الطلبات',
    'invoice.addOrder.attachedHint': 'مرتبط بالفاتورة #{id} ({status}) — سيتم فصله إن تم التحديد',
    'invoice.addOrder.attachedWillDetach': 'سيتم فصله إن تم التحديد',
    'invoice.addOrder.noOrders': 'لا توجد طلبات غير مدفوعة لهذا العميل',
    'invoice.addOrder.detachConfirmTitle': 'هل تود فصل الطلبات عن الفواتير الأخرى؟',
    'invoice.addOrder.detachConfirmMessage': 'بعض الطلبات المحددة مرتبطة بفواتير أخرى. اختيارها سيؤدي إلى فصلها عن الفاتورة الحالية. هل تريد المتابعة؟',

    'invoices.detach.title': 'فصل الطلبات',
    'invoices.detach.noInvoice': 'الفاتورة غير موجودة',
    'invoice.addOrder.attachError': 'تعذر إضافة الطلبات',
    'invoice.addOrder.issueDateFrom': 'تاريخ الإصدار من',
    'invoice.addOrder.issueDateTo': 'تاريخ الإصدار إلى',
    'invoice.addOrder.loadByIssueDate': 'تحميل حسب تاريخ الإصدار',
    'invoice.addOrder.selectAllInRange': 'تحديد الكل',
    'invoice.addOrder.clearIssueDateFilter': 'مسح فلتر التاريخ',
    'invoice.addOrder.issueDateRangeRequired': 'يرجى اختيار نطاق تاريخ الإصدار',
    'invoice.addOrder.createNew': 'إنشاء فاتورة جديدة',
    'invoice.addOrder.chooseExisting': 'إرفاق بفاتورة موجودة',
    'invoice.addOrder.attach': 'إرفاق بفاتورة موجودة',
    'invoices.button.add': 'أضف فاتورة',
    'invoices.button.summary': 'فاتورة ملخصة',
    'invoice.summary.pageTitle': 'فاتورة ملخصة',
    'invoice.summary.dentistPlaceholder': 'اختر طبيباً (اختياري)',
    'invoice.summary.clientOrDentistRequired': 'اختر عميلاً و/أو طبيباً',
    'invoice.summary.dateRangeRequired': 'اختر فترة زمنية',
    'invoice.summary.preview': 'معاينة',
    'invoice.summary.downloadPdf': 'تحميل PDF',
    'invoice.summary.loadError': 'تعذر تحميل الفاتورة الملخصة',
    'invoice.summary.downloadError': 'تعذر تنزيل الفاتورة الملخصة',
    'invoice.summary.caseDescription': 'وصف الحالة',
    'invoice.summary.caseType': 'نوع الحالة',
    'invoice.summary.quantity': 'الكمية',
    'invoice.summary.date': 'التاريخ',
    'invoice.summary.patient': 'المريض',
    'invoice.summary.status': 'الحالة',
    'invoice.summary.unitPrice': 'سعر الوحدة',
    'invoice.summary.numberOfUnits': 'عدد التركيبات',
    'invoice.summary.periodTotal': 'حساب الفترة المحددة',
    'invoice.summary.paidDuringPeriod': 'المدفوع خلال الفترة',
    'invoice.summary.previousBalance': 'حساب سابق',
    'invoice.summary.totalAmountDue': 'إجمالي المطلوب دفعه',
    'invoice.summary.noCases': 'لا توجد حالات في الفترة المحددة',
    'invoice.summary.filterTitle': 'معايير التصفية',
    'invoice.summary.resultsTitle': 'نتائج الملخص',
    'invoice.summary.totalCases': 'حالة',
    'invoice.button.downloading': 'جاري التحميل...',
    'invoice.create.title': 'إنشاء فاتورة',
    'invoice.create.subtitle': 'اختر العميل، ويمكنك أيضاً تصفية حسب الطبيب ونطاق التاريخ، ثم الطلبات غير المدفوعة لإضافتها',
    'invoice.create.backToInvoices': 'العودة إلى الفواتير',
    'invoice.create.backToOrders': 'العودة إلى الطلبات',
    'invoice.create.setupTitle': 'العميل والطبيب والتصفية',
    'invoice.create.ordersTitle': 'الطلبات غير المدفوعة',
    'invoice.create.ordersHint': 'حدد الطلبات المراد فوترتها. الطلبات المرتبطة بفاتورة غير مدفوعة أخرى سيتم فصلها إذا تم تحديدها.',
    'invoice.create.selectedCount': '{{count}} محدد',
    'invoice.create.selected': 'المحدد',
    'invoice.create.ordersCount': '{{count}} طلب',
    'invoice.create.totalDue': 'المبلغ المستحق',
    'invoice.create.emptyClient': 'اختر عميلاً لتحميل الطلبات غير المدفوعة',
    'invoice.create.narrowByDate': 'نطاق تاريخ الإصدار',
    'invoice.created': 'تم إنشاء الفاتورة',
    'invoice.form.clientPlaceholder': 'اختر عميلًا لتحميل الطلبات غير المدفوعة',
    'invoice.field.formula_type': 'نوع التركيبة',
    'invoice.field.color': 'اللون',
    'invoice.field.subtotal': 'إجمالي التكلفة',
    'invoice.field.discountType': 'نوع الخصم',
    'invoice.field.discountValue': 'قيمة الخصم',
    'invoice.field.total': 'المبلغ المستحق',
    'invoice.field.paid': 'المبلغ المدفوع',

    // Payment / Bank accounts
    'lab.payment.title': 'إعدادت الدفع',
    'lab.payment.bank_accounts_title': 'حسابات البنك',
    'lab.payment.addAccount': 'اضافة حساب بنكي',
    'lab.payment.editAccount': 'تعديل حساب بنكي',
    'lab.payment.accountHolder': 'صاحب الحساب',
    'lab.payment.accountHolder.required': 'اسم صاحب الحساب مطلوب',
    'lab.payment.accountHolder.max': 'اسم صاحب الحساب طويل جداً',
    'lab.payment.accountNumber': 'رقم الحساب',
    'lab.payment.accountNumber.required': 'رقم الحساب مطلوب',
    'lab.payment.accountNumber.invalid': 'رقم الحساب غير صالح',
    'lab.payment.accountNumber.min': 'رقم الحساب قصير جداً',
    'lab.payment.iban': 'آيبان',
    'lab.payment.iban.invalid': 'آيبان غير صالح',
    'lab.payment.swiftCode': 'رمز السويفت',
    'lab.payment.swiftCode.invalid': 'رمز سويفت/BIC غير صالح',
    'lab.payment.bankName': 'اسم البنك',
    'lab.payment.bankName.required': 'اسم البنك مطلوب',
    'lab.payment.bankName.max': 'اسم البنك طويل جداً',
    'lab.payment.branch': 'فرع البنك',
    'lab.payment.branch.max': 'تفاصيل الفرع طويلة جداً',
    'lab.payment.no_accounts': 'لا توجد حسابات بنكية',
    'lab.payment.no_transfer': 'لا توجد قنوات تحويل مفعلة',
    'lab.payment.addTransfer': 'إضافة قناة تحويل',
    'lab.payment.editTransfer': 'تعديل قناة التحويل',
    'lab.payment.channel': 'قناة التحويل',
    'lab.payment.deactivate': 'إلغاء التفعيل',
    'lab.payment.channel.required': 'يرجى اختيار قناة تحويل',
    'lab.payment.phone.invalid': 'رقم الهاتف غير صالح',
    'lab.payment.transfer_title': 'التحويل البنكي',
    'lab.payment.activate': 'تفعيل',
    'lab.payment.activated': 'تم التفعيل',
    'lab.payment.deactivated': 'تم إلغاء التفعيل',

    'ui.invoice.bank_account': 'الحساب البنكي',
    'ui.invoice.bank_account_numbered': 'الحساب البنكي {{n}}',
    'ui.invoice.account_holder': 'صاحب الحساب',
    'ui.invoice.account_number': 'رقم الحساب',
    'ui.invoice.bank_name': 'اسم البنك',
    'ui.invoice.bank_swift': 'رمز السويفت',
    'ui.invoice.bank_iban': 'آيبان',
    'ui.invoice.vendor_payment_data': 'بيانات دفع البائع',
    'ui.invoice.payment_method': 'طريقة الدفع',
    'ui.invoice.payment_method_wallet': 'المحفظة',
    'ui.invoice.payment_method_money_transfer': 'التحويل البنكي',
    'ui.invoice.payment_method_cash_on_delivery': 'الدفع عند الاستلام',
    'ui.invoice.payment_method_credit_card': 'بطاقة ائتمان',
    'ui.invoice.money_transfer_channel': 'قناة التحويل',
    'ui.invoice.public_link': 'عرض الفاتورة',
    'ui.invoice.money_transfer_channels': 'قنوات التحويل',
    'ui.invoice.paid_at': 'تاريخ الدفع',

    // Channel names (support both slug formats: vodafone-cash and vodafone_cash)
    'ui.invoice.channel.instapay': 'إنستاباي',
    'ui.invoice.channel.vodafone_cash': 'فودافون كاش',
    'ui.invoice.channel.vodafone-cash': 'فودافون كاش',
    'ui.invoice.channel.etisalat_cash': 'اتصالات كاش',
    'ui.invoice.channel.etisalat-cash': 'اتصالات كاش',
    'ui.invoice.channel.we_pay': 'وي باي',
    'ui.invoice.channel.we-pay': 'وي باي',
    'ui.invoice.channel.fawry': 'فوري',
    'ui.invoice.channel.bank_transfer': 'تحويل بنكي',
    'ui.invoice.channel.bank-transfer': 'تحويل بنكي',
    'ui.invoice.channel.meeza': 'ميزة',
    'ui.invoice.channel.masary': 'مصاري',

    // Enhanced Public Invoice UI (Arabic)
    'ui.invoice.view_title': 'فاتورة',
    'ui.invoice.loading_details': 'جاري تحميل تفاصيل الفاتورة...',
    'ui.invoice.financial_summary': 'الملخص المالي',
    'ui.invoice.payment_details': 'تعليمات الدفع والتحويل البنكي',
    'ui.invoice.scan_qr_hint': 'امسح رمز QR لعرض والتحقق من الفاتورة عبر الإنترنت',
    'ui.invoice.copy_iban': 'نسخ الآيبان',
    'ui.invoice.copy_account': 'نسخ رقم الحساب',
    'ui.invoice.copy_number': 'نسخ الرقم',
    'ui.invoice.copied': 'تم النسخ إلى الحافظة',
    'ui.invoice.public_disclaimer': 'هذه الفاتورة رسمية صادرة من معمل الأسنان لأغراض المطابقة والتحقق المالي. لا تتطلب تسجيل الدخول.',
    'ui.invoice.included_orders': 'الطلبات المشمولة',
    'ui.invoice.orders_count': '{{count}} طلبات',
    'ui.invoice.total_restorations': '{{count}} تركيبة',
    'ui.invoice.paid_in_full': 'مدفوع بالكامل',
    'ui.invoice.remaining_balance': 'المبلغ المتبقي',
    'ui.invoice.billing_signoff': 'اعتماد الفاتورة وتوقيع المعمل',
    'ui.invoice.accountant_signature': 'التوقيع المعتمد / الختم',
    'ui.invoice.accountant_name': 'إعداد بواسطة',
    'ui.invoice.verification_date': 'تاريخ الاعتماد',
    'ui.invoice.channel_transfer_notice': 'يرجى إرفاق رقم الفاتورة كمرجع عند إتمام عملية التحويل.',
    'ui.invoice.bank_details': 'بيانات الحسابات البنكية',
    'ui.invoice.no_bank_accounts': 'لا توجد بيانات حسابات بنكية مضافة.',
    'ui.invoice.no_transfer_channels': 'لا توجد قنوات تحويل مالية مضافة.',
    'ui.invoice.balance_cleared': 'تم تسوية الرصيد بالكامل',
    'ui.invoice.unpaid_balance_alert': 'الدفع معلق. يرجى استخدام تفاصيل الدفع أدناه لإتمام السداد.',
    'ui.invoice.past_due_alert': 'تجاوزت هذه الفاتورة تاريخ الاستحقاق. يرجى تسوية المبلغ المستحق في أقرب وقت.',

    // Synced missing keys
    'assets.title': 'الأصول',
    'common.deleted': 'تم الحذف',
    'common.download_success': 'تم التنزيل بنجاح',
    'common.error': 'حدث خطأ ما',
    'common.no': 'لا',
    'common.noAccess': 'ليس لديك صلاحية الوصول',
    'common.noData': 'لا توجد بيانات',
    'common.popupBlocked': 'تم حظر النافذة المنبثقة. يرجى السماح بالنوافذ المنبثقة لهذا الموقع.',
    'common.unauthorized': 'يرجى تسجيل الدخول',
    'common.yes': 'نعم',
    'errors.notFound': 'غير موجود',
    'errors.noViewPermission': 'ليس لديك صلاحية العرض',
    'entity.generic': 'السجل',
    'entity.notFound': '{entity} غير موجود',
    'entity.notFoundDescription': '{entity} رقم {id} غير موجود.',
    'entity.notFoundHint': 'السجل الذي تبحث عنه غير موجود أو تم حذفه.',
    'entity.backToList': 'العودة للقائمة',
    'entity.order': 'الطلب',
    'entity.invoice': 'الفاتورة',
    'entity.client': 'العميل',
    'entity.dentist': 'الطبيب',
    'entity.user': 'المستخدم',
    'entity.wallet': 'المحفظة',
    'home.latest_invoices': 'أحدث الفواتير',
    'home.tracker_description': 'تفاصيل تتبع الطلبات',
    'home.view_all_invoices': 'عرض كل الفواتير',
    'invoice.addOrder.attached': 'تم ربط الطلب بالفاتورة',
    'invoice.addOrder.attachedSuccess': 'تم ربط الطلب بنجاح',
    'invoice.addOrder.modalTitle': 'ربط طلب بفاتورة',
    'invoice.addOrder.noMatches': 'تعذر العثور على فواتير غير مدفوعة مطابقة لهذا العميل/الطبيب',
    'invoice.addOrder.selectPlaceholder': 'اختر فاتورة',
    'invoice.alert.noView': 'ليس لديك صلاحية عرض هذه الفاتورة.',
    'invoice.field.moneyTransferChannel': 'قناة التحويل',
    'invoice.field.transferReference': 'مرجع التحويل',
    'invoice.placeholder': 'عرض الفاتورة — بانتظار تحديد التخطيط.',
    'invoices.pdf.client': 'العميل',
    'invoices.pdf.dentist': 'الطبيب',
    'orders.actions.noInvoiceAttached': 'لا توجد فاتورة مرتبطة بهذا الطلب بعد',
    'orders.actions.operationalBlocked': 'تم قفل الإجراءات التشغيلية لهذا الطلب',
    'orders.actions.workCard': 'بطاقة العمل',
    'orders.actions.workOrder.assignedTo': 'تعيين إلى',
    'orders.actions.workOrder.cta': 'أمر شغل',
    'orders.actions.workOrder.error': 'فشل إنشاء أمر الشغل',
    'orders.actions.workOrder.notes': 'ملاحظات',
    'orders.actions.workOrder.success': 'تم إنشاء أمر الشغل',
    'orders.actions.workOrder.title': 'أمر شغل',
    'orders.assign.assign': 'تعيين',
    'orders.assign.attachExisting': 'الربط بفاتورة موجودة',
    'orders.assign.create': 'إنشاء فاتورة',
    'orders.assign.created': 'تم إنشاء الفاتورة وربط الطلب',
    'orders.assign.error': 'فشل تعيين الطلب للفاتورة',
    'orders.assign.selectExisting': 'اختر فاتورة موجودة لعميل هذا الطلب',
    'orders.assign.selectInvoice': 'يرجى اختيار فاتورة للتعيين',
    'orders.assign.selectPlaceholder': 'اختر فاتورة',
    'orders.assign.success': 'تم تعيين الطلب للفاتورة',
    'orders.assign.title': 'تعيين الطلب لفاتورة',
    'orders.button.assignInvoice': 'تعيين لفاتورة',
    'orders.form.unitsCount.label': 'عدد الوحدات',
    'orders.summary.discount': 'الخصم',
    'orders.table.deliveryCost': 'تكلفة التوصيل',
    'orders.table.reference': 'المرجع',
    'orders.update.section.invoicing': 'الفواتير والمدفوعات',
    'orders.update.section.quickActions': 'إجراءات سريعة',
    'orders.update.section.workflow': 'سير العمل والعمليات',
    'responses.common.locale_updated': 'تم تحديث اللغة',
    'ui.invoice.view_order': 'عرض الطلب',
    'ui.order.dates_and_timeline': 'الجدول الزمني والتواريخ',
    'ui.order.unit_positions_ar': 'مواضع الوحدات',
    'users.form.password.minLength': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',

    'subscription.title': 'الاشتراك',
    'subscription.loadError': 'تعذر تحميل تفاصيل الاشتراك',
    'subscription.adminOnly': 'يمكن لمسؤولي المعمل فقط إدارة خطة الاشتراك.',
    'subscription.currentPlan': 'الخطة الحالية',
    'subscription.noPlan': 'لا توجد خطة اشتراك معيّنة.',
    'subscription.choosePlan': 'اختر خطة',
    'subscription.choosePlanHint': 'اطلب خطة مدفوعة. سيراجع فريقنا طلبك ويفعّل الخطة الجديدة بعد الموافقة.',
    'subscription.popular': 'الأكثر شيوعاً',
    'subscription.month': 'شهر',
    'subscription.current': 'الخطة الحالية',
    'subscription.requestPlan': 'طلب الخطة',
    'subscription.requestConfirm': 'هل تريد إرسال طلب للتبديل إلى خطة {plan}؟',
    'subscription.requestSubmitted': 'تم إرسال طلب تغيير الخطة. سيتم تفعيلها بعد الموافقة.',
    'subscription.requestError': 'تعذر إرسال طلب تغيير الخطة',
    'subscription.awaitingApproval': 'بانتظار الموافقة',
    'subscription.requestPending': 'طلبك للتبديل إلى خطة {plan} بانتظار الموافقة.',
    'subscription.requestPendingHint': 'تظل خطتك الحالية مفعّلة حتى يوافق فريقنا على الطلب.',
    'subscription.cancelRequest': 'إلغاء الطلب',
    'subscription.cancelRequestConfirm': 'هل تريد إلغاء طلب تغيير الخطة؟',
    'subscription.requestCancelled': 'تم إلغاء طلب تغيير الخطة',
    'subscription.requestCancelError': 'تعذر إلغاء طلب تغيير الخطة',
    'subscription.requestRejected': 'تم رفض طلبك للتبديل إلى خطة {plan}.',
    'subscription.rejectionReason': 'السبب',
    'subscription.noPaidPlans': 'لا توجد خطط مدفوعة متاحة حالياً.',
    'subscription.trialEndsAt': 'تنتهي التجربة في',
    'subscription.trialActive': 'التجربة المجانية نشطة — متبقي {days} يوم.',
    'subscription.trialEndingSoon': 'تنتهي تجربتك المجانية خلال {days} يوم. اختر خطة للحفاظ على الوصول.',
    'subscription.trialExpired': 'انتهت تجربتك المجانية. اختر خطة لاستعادة الوصول.',
    'subscription.billing.trialing': 'تجريبي',
    'subscription.billing.active': 'نشط',
    'subscription.billing.past_due': 'متأخر',
    'subscription.billing.cancelled': 'ملغى',
    'subscription.billing.manual': 'يدوي',
    'subscription.status.pending': 'قيد الانتظار',
    'subscription.status.under_review': 'قيد المراجعة',
    'subscription.status.active': 'نشط',
    'subscription.status.suspended': 'معلق',
    'subscription.status.cancelled': 'ملغى',
    'subscription.status.rejected': 'مرفوض',

    'notFound.title': 'الصفحة غير موجودة',
  },
};

export default translations;
